(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('three')) :
  typeof define === 'function' && define.amd ? define(['exports', 'three'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ModelViewerEffects = {}, global.three));
})(this, (function (exports, three) { 'use strict';

  /**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const t$1 = globalThis, e$2 = t$1.ShadowRoot && (void 0 === t$1.ShadyCSS || t$1.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s$1 = Symbol(), o$3 = new WeakMap;
  let n$3 = class n {
      get styleSheet() {
          let t = this.o;
          const s = this.t;
          if (e$2 && void 0 === t) {
              const e = void 0 !== s && 1 === s.length;
              e && (t = o$3.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && o$3.set(s, t));
          }
          return t;
      }
      toString() {
          return this.cssText;
      }
      constructor(t, e, o){
          if (this._$cssResult$ = true, o !== s$1) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
          this.cssText = t, this.t = e;
      }
  };
  const r$4 = (t)=>new n$3("string" == typeof t ? t : t + "", void 0, s$1), S$1 = (s, o)=>{
      if (e$2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
      else for (const e of o){
          const o = document.createElement("style"), n = t$1.litNonce;
          void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
      }
  }, c$2 = e$2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
          let e = "";
          for (const s of t.cssRules)e += s.cssText;
          return r$4(e);
      })(t) : t;

  var _Symbol, _a$1, _a1;
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const { is: i$2, defineProperty: e$1, getOwnPropertyDescriptor: r$3, getOwnPropertyNames: h$1, getOwnPropertySymbols: o$2, getPrototypeOf: n$2 } = Object, a$1 = globalThis, c$1 = a$1.trustedTypes, l$1 = c$1 ? c$1.emptyScript : "", p$1 = a$1.reactiveElementPolyfillSupport, d$1 = (t, s)=>t, u$1 = {
      toAttribute (t, s) {
          switch(s){
              case Boolean:
                  t = t ? l$1 : null;
                  break;
              case Object:
              case Array:
                  t = null == t ? t : JSON.stringify(t);
          }
          return t;
      },
      fromAttribute (t, s) {
          let i = t;
          switch(s){
              case Boolean:
                  i = null !== t;
                  break;
              case Number:
                  i = null === t ? null : Number(t);
                  break;
              case Object:
              case Array:
                  try {
                      i = JSON.parse(t);
                  } catch (t) {
                      i = null;
                  }
          }
          return i;
      }
  }, f$1 = (t, s)=>!i$2(t, s), y = {
      attribute: true,
      type: String,
      converter: u$1,
      reflect: false,
      hasChanged: f$1
  };
  (_Symbol = Symbol).metadata ?? (_Symbol.metadata = Symbol("metadata")), (_a$1 = a$1).litPropertyMetadata ?? (_a$1.litPropertyMetadata = new WeakMap);
  class b extends HTMLElement {
      static addInitializer(t) {
          this._$Ei(), (this.l ?? (this.l = [])).push(t);
      }
      static get observedAttributes() {
          return this.finalize(), this._$Eh && [
              ...this._$Eh.keys()
          ];
      }
      static createProperty(t, s = y) {
          if (s.state && (s.attribute = false), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
              const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
              void 0 !== r && e$1(this.prototype, t, r);
          }
      }
      static getPropertyDescriptor(t, s, i) {
          const { get: e, set: h } = r$3(this.prototype, t) ?? {
              get () {
                  return this[s];
              },
              set (t) {
                  this[s] = t;
              }
          };
          return {
              get () {
                  return e?.call(this);
              },
              set (s) {
                  const r = e?.call(this);
                  h.call(this, s), this.requestUpdate(t, r, i);
              },
              configurable: true,
              enumerable: true
          };
      }
      static getPropertyOptions(t) {
          return this.elementProperties.get(t) ?? y;
      }
      static _$Ei() {
          if (this.hasOwnProperty(d$1("elementProperties"))) return;
          const t = n$2(this);
          t.finalize(), void 0 !== t.l && (this.l = [
              ...t.l
          ]), this.elementProperties = new Map(t.elementProperties);
      }
      static finalize() {
          if (this.hasOwnProperty(d$1("finalized"))) return;
          if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d$1("properties"))) {
              const t = this.properties, s = [
                  ...h$1(t),
                  ...o$2(t)
              ];
              for (const i of s)this.createProperty(i, t[i]);
          }
          const t = this[Symbol.metadata];
          if (null !== t) {
              const s = litPropertyMetadata.get(t);
              if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
          }
          this._$Eh = new Map;
          for (const [t, s] of this.elementProperties){
              const i = this._$Eu(t, s);
              void 0 !== i && this._$Eh.set(i, t);
          }
          this.elementStyles = this.finalizeStyles(this.styles);
      }
      static finalizeStyles(s) {
          const i = [];
          if (Array.isArray(s)) {
              const e = new Set(s.flat(1 / 0).reverse());
              for (const s of e)i.unshift(c$2(s));
          } else void 0 !== s && i.push(c$2(s));
          return i;
      }
      static _$Eu(t, s) {
          const i = s.attribute;
          return false === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
      }
      _$Ev() {
          this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
      }
      addController(t) {
          (this._$EO ?? (this._$EO = new Set)).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
      }
      removeController(t) {
          this._$EO?.delete(t);
      }
      _$E_() {
          const t = new Map, s = this.constructor.elementProperties;
          for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
          t.size > 0 && (this._$Ep = t);
      }
      createRenderRoot() {
          const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
          return S$1(t, this.constructor.elementStyles), t;
      }
      connectedCallback() {
          this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(true), this._$EO?.forEach((t)=>t.hostConnected?.());
      }
      enableUpdating(t) {}
      disconnectedCallback() {
          this._$EO?.forEach((t)=>t.hostDisconnected?.());
      }
      attributeChangedCallback(t, s, i) {
          this._$AK(t, i);
      }
      _$EC(t, s) {
          const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
          if (void 0 !== e && true === i.reflect) {
              const r = (void 0 !== i.converter?.toAttribute ? i.converter : u$1).toAttribute(s, i.type);
              this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
          }
      }
      _$AK(t, s) {
          const i = this.constructor, e = i._$Eh.get(t);
          if (void 0 !== e && this._$Em !== e) {
              const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                  fromAttribute: t.converter
              } : void 0 !== t.converter?.fromAttribute ? t.converter : u$1;
              this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
          }
      }
      requestUpdate(t, s, i) {
          if (void 0 !== t) {
              if (i ?? (i = this.constructor.getPropertyOptions(t)), !(i.hasChanged ?? f$1)(this[t], s)) return;
              this.P(t, s, i);
          }
          false === this.isUpdatePending && (this._$ES = this._$ET());
      }
      P(t, s, i) {
          this._$AL.has(t) || this._$AL.set(t, s), true === i.reflect && this._$Em !== t && (this._$Ej ?? (this._$Ej = new Set)).add(t);
      }
      async _$ET() {
          this.isUpdatePending = true;
          try {
              await this._$ES;
          } catch (t) {
              Promise.reject(t);
          }
          const t = this.scheduleUpdate();
          return null != t && await t, !this.isUpdatePending;
      }
      scheduleUpdate() {
          return this.performUpdate();
      }
      performUpdate() {
          if (!this.isUpdatePending) return;
          if (!this.hasUpdated) {
              if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
                  for (const [t, s] of this._$Ep)this[t] = s;
                  this._$Ep = void 0;
              }
              const t = this.constructor.elementProperties;
              if (t.size > 0) for (const [s, i] of t) true !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
          }
          let t = false;
          const s = this._$AL;
          try {
              t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
          } catch (s) {
              throw t = false, this._$EU(), s;
          }
          t && this._$AE(s);
      }
      willUpdate(t) {}
      _$AE(t) {
          this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t)), this.updated(t);
      }
      _$EU() {
          this._$AL = new Map, this.isUpdatePending = false;
      }
      get updateComplete() {
          return this.getUpdateComplete();
      }
      getUpdateComplete() {
          return this._$ES;
      }
      shouldUpdate(t) {
          return true;
      }
      update(t) {
          this._$Ej && (this._$Ej = this._$Ej.forEach((t)=>this._$EC(t, this[t]))), this._$EU();
      }
      updated(t) {}
      firstUpdated(t) {}
      constructor(){
          super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
      }
  }
  b.elementStyles = [], b.shadowRootOptions = {
      mode: "open"
  }, b[d$1("elementProperties")] = new Map, b[d$1("finalized")] = new Map, p$1?.({
      ReactiveElement: b
  }), ((_a1 = a$1).reactiveElementVersions ?? (_a1.reactiveElementVersions = [])).push("2.0.4");

  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ const o$1 = {
      attribute: true,
      type: String,
      converter: u$1,
      reflect: false,
      hasChanged: f$1
  }, r$2 = (t = o$1, e, r)=>{
      const { kind: n, metadata: i } = r;
      let s = globalThis.litPropertyMetadata.get(i);
      if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
          const { name: o } = r;
          return {
              set (r) {
                  const n = e.get.call(this);
                  e.set.call(this, r), this.requestUpdate(o, n, t);
              },
              init (e) {
                  return void 0 !== e && this.P(o, void 0, t), e;
              }
          };
      }
      if ("setter" === n) {
          const { name: o } = r;
          return function(r) {
              const n = this[o];
              e.call(this, r), this.requestUpdate(o, n, t);
          };
      }
      throw Error("Unsupported decorator location: " + n);
  };
  function n$1(t) {
      return (e, o)=>"object" == typeof o ? r$2(t, e, o) : ((t, e, o)=>{
              const r = e.hasOwnProperty(o);
              return e.constructor.createProperty(o, r ? {
                  ...t,
                  wrapped: true
              } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
          })(t, e, o);
  }

  /**
   * postprocessing v6.37.2 build Fri Mar 28 2025
   * https://github.com/pmndrs/postprocessing
   * Copyright 2015-2025 Raoul van Rüschen
   * @license Zlib
   */ // package.json
  // src/core/Timer.js
  var MILLISECONDS_TO_SECONDS = 1 / 1e3;
  var SECONDS_TO_MILLISECONDS = 1e3;
  var Timer = class {
      /**
     * Enables or disables auto reset based on page visibility.
     *
     * If enabled, the timer will be reset when the page becomes visible. This effectively pauses the timer when the page
     * is hidden. Has no effect if the API is not supported.
     *
     * @type {Boolean}
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
     */ get autoReset() {
          return this._autoReset;
      }
      set autoReset(value) {
          if (typeof document !== "undefined" && document.hidden !== void 0) {
              if (value) {
                  document.addEventListener("visibilitychange", this);
              } else {
                  document.removeEventListener("visibilitychange", this);
              }
              this._autoReset = value;
          }
      }
      get delta() {
          return this._delta * MILLISECONDS_TO_SECONDS;
      }
      get fixedDelta() {
          return this._fixedDelta * MILLISECONDS_TO_SECONDS;
      }
      set fixedDelta(value) {
          this._fixedDelta = value * SECONDS_TO_MILLISECONDS;
      }
      get elapsed() {
          return this._elapsed * MILLISECONDS_TO_SECONDS;
      }
      /**
     * Updates this timer.
     *
     * @param {Boolean} [timestamp] - The current time in milliseconds.
     */ update(timestamp) {
          if (this.useFixedDelta) {
              this._delta = this.fixedDelta;
          } else {
              this.previousTime = this.currentTime;
              this.currentTime = (timestamp !== void 0 ? timestamp : performance.now()) - this.startTime;
              this._delta = this.currentTime - this.previousTime;
          }
          this._delta *= this.timescale;
          this._elapsed += this._delta;
      }
      /**
     * Resets this timer.
     */ reset() {
          this._delta = 0;
          this._elapsed = 0;
          this.currentTime = performance.now() - this.startTime;
      }
      getDelta() {
          return this.delta;
      }
      getElapsed() {
          return this.elapsed;
      }
      handleEvent(e) {
          if (!document.hidden) {
              this.currentTime = performance.now() - this.startTime;
          }
      }
      dispose() {
          this.autoReset = false;
      }
      /**
     * Constructs a new timer.
     */ constructor(){
          this.startTime = performance.now();
          this.previousTime = 0;
          this.currentTime = 0;
          this._delta = 0;
          this._elapsed = 0;
          this._fixedDelta = 1e3 / 60;
          this.timescale = 1;
          this.useFixedDelta = false;
          this._autoReset = false;
      }
  };
  var fullscreenGeometry = /* @__PURE__ */ (()=>{
      const vertices = new Float32Array([
          -1,
          -1,
          0,
          3,
          -1,
          0,
          -1,
          3,
          0
      ]);
      const uvs = new Float32Array([
          0,
          0,
          2,
          0,
          0,
          2
      ]);
      const geometry = new three.BufferGeometry();
      geometry.setAttribute("position", new three.BufferAttribute(vertices, 3));
      geometry.setAttribute("uv", new three.BufferAttribute(uvs, 2));
      return geometry;
  })();
  var Pass = class _Pass {
      /**
     * A shared fullscreen triangle.
     *
     * The screen size is 2x2 units (NDC). A triangle needs to be 4x4 units to fill the screen.
     * @see https://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
     * @type {BufferGeometry}
     * @internal
     */ static get fullscreenGeometry() {
          return fullscreenGeometry;
      }
      /**
     * Sets the render to screen flag.
     *
     * If this flag is changed, the fullscreen material will be updated as well.
     *
     * @type {Boolean}
     */ get renderToScreen() {
          return !this.rtt;
      }
      set renderToScreen(value) {
          if (this.rtt === value) {
              const material = this.fullscreenMaterial;
              if (material !== null) {
                  material.needsUpdate = true;
              }
              this.rtt = !value;
          }
      }
      /**
     * Sets the main scene.
     *
     * @type {Scene}
     */ set mainScene(value) {}
      /**
     * Sets the main camera.
     *
     * @type {Camera}
     */ set mainCamera(value) {}
      /**
     * Sets the renderer
     *
     * @deprecated
     * @param {WebGLRenderer} renderer - The renderer.
     */ setRenderer(renderer) {
          this.renderer = renderer;
      }
      /**
     * Indicates whether this pass is enabled.
     *
     * @deprecated Use enabled instead.
     * @return {Boolean} Whether this pass is enabled.
     */ isEnabled() {
          return this.enabled;
      }
      /**
     * Enables or disables this pass.
     *
     * @deprecated Use enabled instead.
     * @param {Boolean} value - Whether the pass should be enabled.
     */ setEnabled(value) {
          this.enabled = value;
      }
      /**
     * The fullscreen material.
     *
     * @type {Material}
     */ get fullscreenMaterial() {
          return this.screen !== null ? this.screen.material : null;
      }
      set fullscreenMaterial(value) {
          let screen = this.screen;
          if (screen !== null) {
              screen.material = value;
          } else {
              screen = new three.Mesh(_Pass.fullscreenGeometry, value);
              screen.frustumCulled = false;
              if (this.scene === null) {
                  this.scene = new three.Scene();
              }
              this.scene.add(screen);
              this.screen = screen;
          }
      }
      /**
     * Returns the current fullscreen material.
     *
     * @deprecated Use fullscreenMaterial instead.
     * @return {Material} The current fullscreen material, or null if there is none.
     */ getFullscreenMaterial() {
          return this.fullscreenMaterial;
      }
      /**
     * Sets the fullscreen material.
     *
     * @deprecated Use fullscreenMaterial instead.
     * @protected
     * @param {Material} value - A fullscreen material.
     */ setFullscreenMaterial(value) {
          this.fullscreenMaterial = value;
      }
      /**
     * Returns the current depth texture.
     *
     * @return {Texture} The current depth texture, or null if there is none.
     */ getDepthTexture() {
          return null;
      }
      /**
     * Sets the depth texture.
     *
     * This method will be called automatically by the {@link EffectComposer}.
     * You may override this method if your pass relies on the depth information of a preceding {@link RenderPass}.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategy} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {}
      /**
     * Renders this pass.
     *
     * This is an abstract method that must be overridden.
     *
     * @abstract
     * @throws {Error} An error is thrown if the method is not overridden.
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          throw new Error("Render method not implemented!");
      }
      /**
     * Sets the size.
     *
     * You may override this method if you want to be informed about the size of the backbuffer/canvas.
     * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {}
      /**
     * Performs initialization tasks.
     *
     * This method is called when this pass is added to an {@link EffectComposer}.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {}
      /**
     * Performs a shallow search for disposable properties and deletes them.
     *
     * The {@link EffectComposer} calls this method when it is being destroyed. You can use it independently to free
     * memory when you're certain that you don't need this pass anymore.
     */ dispose() {
          for (const key of Object.keys(this)){
              const property = this[key];
              const isDisposable = property instanceof three.WebGLRenderTarget || property instanceof three.Material || property instanceof three.Texture || property instanceof _Pass;
              if (isDisposable) {
                  this[key].dispose();
              }
          }
          if (this.fullscreenMaterial !== null) {
              this.fullscreenMaterial.dispose();
          }
      }
      /**
     * Constructs a new pass.
     *
     * @param {String} [name] - The name of this pass. Does not have to be unique.
     * @param {Scene} [scene] - The scene to render. The default scene contains a single mesh that fills the screen.
     * @param {Camera} [camera] - A camera. Fullscreen effect passes don't require a camera.
     */ constructor(name = "Pass", scene = new three.Scene(), camera = new three.Camera()){
          this.name = name;
          this.renderer = null;
          this.scene = scene;
          this.camera = camera;
          this.screen = null;
          this.rtt = true;
          this.needsSwap = true;
          this.needsDepthTexture = false;
          this.enabled = true;
      }
  };
  // src/passes/ClearMaskPass.js
  var ClearMaskPass = class extends Pass {
      /**
     * Disables the global stencil test.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const stencil = renderer.state.buffers.stencil;
          stencil.setLocked(false);
          stencil.setTest(false);
      }
      /**
     * Constructs a new clear mask pass.
     */ constructor(){
          super("ClearMaskPass", null, null);
          this.needsSwap = false;
      }
  };
  // src/materials/glsl/copy.frag
  var copy_default = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <colorspace_fragment>
#include <dithering_fragment>
}`;
  // src/materials/glsl/common.vert
  var common_default = `varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/CopyMaterial.js
  var CopyMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */ setInputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */ getOpacity(value) {
          return this.uniforms.opacity.value;
      }
      /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */ setOpacity(value) {
          this.uniforms.opacity.value = value;
      }
      /**
     * Constructs a new copy material.
     */ constructor(){
          super({
              name: "CopyMaterial",
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  opacity: new three.Uniform(1)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: copy_default,
              vertexShader: common_default
          });
      }
  };
  // src/passes/CopyPass.js
  var CopyPass = class extends Pass {
      /**
     * Enables or disables auto resizing of the render target.
     *
     * @deprecated Use autoResize instead.
     * @type {Boolean}
     */ get resize() {
          return this.autoResize;
      }
      set resize(value) {
          this.autoResize = value;
      }
      /**
     * The output texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the output texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTarget.texture;
      }
      /**
     * Enables or disables auto resizing of the render target.
     *
     * @deprecated Use autoResize instead.
     * @param {Boolean} value - Whether the render target size should be updated automatically.
     */ setAutoResizeEnabled(value) {
          this.autoResize = value;
      }
      /**
     * Saves the input buffer.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          this.fullscreenMaterial.inputBuffer = inputBuffer.texture;
          renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
          renderer.render(this.scene, this.camera);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          if (this.autoResize) {
              this.renderTarget.setSize(width, height);
          }
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - A renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          if (frameBufferType !== void 0) {
              this.renderTarget.texture.type = frameBufferType;
              if (frameBufferType !== three.UnsignedByteType) {
                  this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
              } else if (renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
                  this.renderTarget.texture.colorSpace = three.SRGBColorSpace;
              }
          }
      }
      /**
     * Constructs a new save pass.
     *
     * @param {WebGLRenderTarget} [renderTarget] - A render target.
     * @param {Boolean} [autoResize=true] - Whether the render target size should be updated automatically.
     */ constructor(renderTarget, autoResize = true){
          super("CopyPass");
          this.fullscreenMaterial = new CopyMaterial();
          this.needsSwap = false;
          this.renderTarget = renderTarget;
          if (renderTarget === void 0) {
              this.renderTarget = new three.WebGLRenderTarget(1, 1, {
                  minFilter: three.LinearFilter,
                  magFilter: three.LinearFilter,
                  stencilBuffer: false,
                  depthBuffer: false
              });
              this.renderTarget.texture.name = "CopyPass.Target";
          }
          this.autoResize = autoResize;
      }
  };
  var color = /* @__PURE__ */ new three.Color();
  var ClearPass = class extends Pass {
      /**
     * Sets the clear flags.
     *
     * @param {Boolean} color - Whether the color buffer should be cleared.
     * @param {Boolean} depth - Whether the depth buffer should be cleared.
     * @param {Boolean} stencil - Whether the stencil buffer should be cleared.
     */ setClearFlags(color2, depth, stencil) {
          this.color = color2;
          this.depth = depth;
          this.stencil = stencil;
      }
      /**
     * Returns the override clear color. Default is null.
     *
     * @deprecated Use overrideClearColor instead.
     * @return {Color} The clear color.
     */ getOverrideClearColor() {
          return this.overrideClearColor;
      }
      /**
     * Sets the override clear color.
     *
     * @deprecated Use overrideClearColor instead.
     * @param {Color} value - The clear color.
     */ setOverrideClearColor(value) {
          this.overrideClearColor = value;
      }
      /**
     * Returns the override clear alpha. Default is -1.
     *
     * @deprecated Use overrideClearAlpha instead.
     * @return {Number} The clear alpha.
     */ getOverrideClearAlpha() {
          return this.overrideClearAlpha;
      }
      /**
     * Sets the override clear alpha.
     *
     * @deprecated Use overrideClearAlpha instead.
     * @param {Number} value - The clear alpha.
     */ setOverrideClearAlpha(value) {
          this.overrideClearAlpha = value;
      }
      /**
     * Clears the input buffer or the screen.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const overrideClearColor = this.overrideClearColor;
          const overrideClearAlpha = this.overrideClearAlpha;
          const clearAlpha = renderer.getClearAlpha();
          const hasOverrideClearColor = overrideClearColor !== null;
          const hasOverrideClearAlpha = overrideClearAlpha >= 0;
          if (hasOverrideClearColor) {
              renderer.getClearColor(color);
              renderer.setClearColor(overrideClearColor, hasOverrideClearAlpha ? overrideClearAlpha : clearAlpha);
          } else if (hasOverrideClearAlpha) {
              renderer.setClearAlpha(overrideClearAlpha);
          }
          renderer.setRenderTarget(this.renderToScreen ? null : inputBuffer);
          renderer.clear(this.color, this.depth, this.stencil);
          if (hasOverrideClearColor) {
              renderer.setClearColor(color, clearAlpha);
          } else if (hasOverrideClearAlpha) {
              renderer.setClearAlpha(clearAlpha);
          }
      }
      /**
     * Constructs a new clear pass.
     *
     * @param {Boolean} [color=true] - Determines whether the color buffer should be cleared.
     * @param {Boolean} [depth=true] - Determines whether the depth buffer should be cleared.
     * @param {Boolean} [stencil=false] - Determines whether the stencil buffer should be cleared.
     */ constructor(color2 = true, depth = true, stencil = false){
          super("ClearPass", null, null);
          this.needsSwap = false;
          this.color = color2;
          this.depth = depth;
          this.stencil = stencil;
          this.overrideClearColor = null;
          this.overrideClearAlpha = -1;
      }
  };
  // src/passes/MaskPass.js
  var MaskPass = class extends Pass {
      set mainScene(value) {
          this.scene = value;
      }
      set mainCamera(value) {
          this.camera = value;
      }
      /**
     * Indicates whether the mask should be inverted.
     *
     * @type {Boolean}
     */ get inverted() {
          return this.inverse;
      }
      set inverted(value) {
          this.inverse = value;
      }
      /**
     * Indicates whether this pass should clear the stencil buffer.
     *
     * @type {Boolean}
     * @deprecated Use clearPass.enabled instead.
     */ get clear() {
          return this.clearPass.enabled;
      }
      set clear(value) {
          this.clearPass.enabled = value;
      }
      /**
     * Returns the internal clear pass.
     *
     * @deprecated Use clearPass.enabled instead.
     * @return {ClearPass} The clear pass.
     */ getClearPass() {
          return this.clearPass;
      }
      /**
     * Indicates whether the mask is inverted.
     *
     * @deprecated Use inverted instead.
     * @return {Boolean} Whether the mask is inverted.
     */ isInverted() {
          return this.inverted;
      }
      /**
     * Enables or disable mask inversion.
     *
     * @deprecated Use inverted instead.
     * @param {Boolean} value - Whether the mask should be inverted.
     */ setInverted(value) {
          this.inverted = value;
      }
      /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const context = renderer.getContext();
          const buffers = renderer.state.buffers;
          const scene = this.scene;
          const camera = this.camera;
          const clearPass = this.clearPass;
          const writeValue = this.inverted ? 0 : 1;
          const clearValue = 1 - writeValue;
          buffers.color.setMask(false);
          buffers.depth.setMask(false);
          buffers.color.setLocked(true);
          buffers.depth.setLocked(true);
          buffers.stencil.setTest(true);
          buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
          buffers.stencil.setFunc(context.ALWAYS, writeValue, 4294967295);
          buffers.stencil.setClear(clearValue);
          buffers.stencil.setLocked(true);
          if (this.clearPass.enabled) {
              if (this.renderToScreen) {
                  clearPass.render(renderer, null);
              } else {
                  clearPass.render(renderer, inputBuffer);
                  clearPass.render(renderer, outputBuffer);
              }
          }
          if (this.renderToScreen) {
              renderer.setRenderTarget(null);
              renderer.render(scene, camera);
          } else {
              renderer.setRenderTarget(inputBuffer);
              renderer.render(scene, camera);
              renderer.setRenderTarget(outputBuffer);
              renderer.render(scene, camera);
          }
          buffers.color.setLocked(false);
          buffers.depth.setLocked(false);
          buffers.stencil.setLocked(false);
          buffers.stencil.setFunc(context.EQUAL, 1, 4294967295);
          buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
          buffers.stencil.setLocked(true);
      }
      /**
     * Constructs a new mask pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use.
     */ constructor(scene, camera){
          super("MaskPass", scene, camera);
          this.needsSwap = false;
          this.clearPass = new ClearPass(false, false, true);
          this.inverse = false;
      }
  };
  // src/core/EffectComposer.js
  var EffectComposer$1 = class EffectComposer {
      /**
     * The current amount of samples used for multisample anti-aliasing.
     *
     * @type {Number}
     */ get multisampling() {
          return this.inputBuffer.samples || 0;
      }
      /**
     * Sets the amount of MSAA samples.
     *
     * Requires WebGL 2. Set to zero to disable multisampling.
     *
     * @type {Number}
     */ set multisampling(value) {
          const buffer = this.inputBuffer;
          const multisampling = this.multisampling;
          if (multisampling > 0 && value > 0) {
              this.inputBuffer.samples = value;
              this.outputBuffer.samples = value;
              this.inputBuffer.dispose();
              this.outputBuffer.dispose();
          } else if (multisampling !== value) {
              this.inputBuffer.dispose();
              this.outputBuffer.dispose();
              this.inputBuffer = this.createBuffer(buffer.depthBuffer, buffer.stencilBuffer, buffer.texture.type, value);
              this.inputBuffer.depthTexture = this.depthTexture;
              this.outputBuffer = this.inputBuffer.clone();
          }
      }
      /**
     * Returns the internal timer.
     *
     * @return {Timer} The timer.
     */ getTimer() {
          return this.timer;
      }
      /**
     * Returns the renderer.
     *
     * @return {WebGLRenderer} The renderer.
     */ getRenderer() {
          return this.renderer;
      }
      /**
     * Sets the renderer.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     */ setRenderer(renderer) {
          this.renderer = renderer;
          if (renderer !== null) {
              const size = renderer.getSize(new three.Vector2());
              const alpha = renderer.getContext().getContextAttributes().alpha;
              const frameBufferType = this.inputBuffer.texture.type;
              if (frameBufferType === three.UnsignedByteType && renderer.outputColorSpace === three.SRGBColorSpace) {
                  this.inputBuffer.texture.colorSpace = three.SRGBColorSpace;
                  this.outputBuffer.texture.colorSpace = three.SRGBColorSpace;
                  this.inputBuffer.dispose();
                  this.outputBuffer.dispose();
              }
              renderer.autoClear = false;
              this.setSize(size.width, size.height);
              for (const pass of this.passes){
                  pass.initialize(renderer, alpha, frameBufferType);
              }
          }
      }
      /**
     * Replaces the current renderer with the given one.
     *
     * The auto clear mechanism of the provided renderer will be disabled. If the new render size differs from the
     * previous one, all passes will be updated.
     *
     * By default, the DOM element of the current renderer will automatically be removed from its parent node and the DOM
     * element of the new renderer will take its place.
     *
     * @deprecated Use setRenderer instead.
     * @param {WebGLRenderer} renderer - The new renderer.
     * @param {Boolean} updateDOM - Indicates whether the old canvas should be replaced by the new one in the DOM.
     * @return {WebGLRenderer} The old renderer.
     */ replaceRenderer(renderer, updateDOM = true) {
          const oldRenderer = this.renderer;
          const parent = oldRenderer.domElement.parentNode;
          this.setRenderer(renderer);
          if (updateDOM && parent !== null) {
              parent.removeChild(oldRenderer.domElement);
              parent.appendChild(renderer.domElement);
          }
          return oldRenderer;
      }
      /**
     * Creates a depth texture attachment that will be provided to all passes.
     *
     * Note: When a shader reads from a depth texture and writes to a render target that uses the same depth texture
     * attachment, the depth information will be lost. This happens even if `depthWrite` is disabled.
     *
     * @private
     * @return {DepthTexture} The depth texture.
     */ createDepthTexture() {
          const depthTexture = this.depthTexture = new three.DepthTexture();
          this.inputBuffer.depthTexture = depthTexture;
          this.inputBuffer.dispose();
          if (this.inputBuffer.stencilBuffer) {
              depthTexture.format = three.DepthStencilFormat;
              depthTexture.type = three.UnsignedInt248Type;
          } else {
              depthTexture.type = three.UnsignedIntType;
          }
          return depthTexture;
      }
      /**
     * Deletes the current depth texture.
     *
     * @private
     */ deleteDepthTexture() {
          if (this.depthTexture !== null) {
              this.depthTexture.dispose();
              this.depthTexture = null;
              this.inputBuffer.depthTexture = null;
              this.inputBuffer.dispose();
              for (const pass of this.passes){
                  pass.setDepthTexture(null);
              }
          }
      }
      /**
     * Creates a new render target.
     *
     * @deprecated Create buffers manually via WebGLRenderTarget instead.
     * @param {Boolean} depthBuffer - Whether the render target should have a depth buffer.
     * @param {Boolean} stencilBuffer - Whether the render target should have a stencil buffer.
     * @param {Number} type - The frame buffer type.
     * @param {Number} multisampling - The number of samples to use for antialiasing.
     * @return {WebGLRenderTarget} A new render target that equals the renderer's canvas.
     */ createBuffer(depthBuffer, stencilBuffer, type, multisampling) {
          const renderer = this.renderer;
          const size = renderer === null ? new three.Vector2() : renderer.getDrawingBufferSize(new three.Vector2());
          const options = {
              minFilter: three.LinearFilter,
              magFilter: three.LinearFilter,
              stencilBuffer,
              depthBuffer,
              type
          };
          const renderTarget = new three.WebGLRenderTarget(size.width, size.height, options);
          if (multisampling > 0) {
              renderTarget.ignoreDepthForMultisampleCopy = false;
              renderTarget.samples = multisampling;
          }
          if (type === three.UnsignedByteType && renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
              renderTarget.texture.colorSpace = three.SRGBColorSpace;
          }
          renderTarget.texture.name = "EffectComposer.Buffer";
          renderTarget.texture.generateMipmaps = false;
          return renderTarget;
      }
      /**
     * Can be used to change the main scene for all registered passes and effects.
     *
     * @param {Scene} scene - The scene.
     */ setMainScene(scene) {
          for (const pass of this.passes){
              pass.mainScene = scene;
          }
      }
      /**
     * Can be used to change the main camera for all registered passes and effects.
     *
     * @param {Camera} camera - The camera.
     */ setMainCamera(camera) {
          for (const pass of this.passes){
              pass.mainCamera = camera;
          }
      }
      /**
     * Adds a pass, optionally at a specific index.
     *
     * @param {Pass} pass - A new pass.
     * @param {Number} [index] - An index at which the pass should be inserted.
     */ addPass(pass, index) {
          const passes = this.passes;
          const renderer = this.renderer;
          const drawingBufferSize = renderer.getDrawingBufferSize(new three.Vector2());
          const alpha = renderer.getContext().getContextAttributes().alpha;
          const frameBufferType = this.inputBuffer.texture.type;
          pass.setRenderer(renderer);
          pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
          pass.initialize(renderer, alpha, frameBufferType);
          if (this.autoRenderToScreen) {
              if (passes.length > 0) {
                  passes[passes.length - 1].renderToScreen = false;
              }
              if (pass.renderToScreen) {
                  this.autoRenderToScreen = false;
              }
          }
          if (index !== void 0) {
              passes.splice(index, 0, pass);
          } else {
              passes.push(pass);
          }
          if (this.autoRenderToScreen) {
              passes[passes.length - 1].renderToScreen = true;
          }
          if (pass.needsDepthTexture || this.depthTexture !== null) {
              if (this.depthTexture === null) {
                  const depthTexture = this.createDepthTexture();
                  for (pass of passes){
                      pass.setDepthTexture(depthTexture);
                  }
              } else {
                  pass.setDepthTexture(this.depthTexture);
              }
          }
      }
      /**
     * Removes a pass.
     *
     * @param {Pass} pass - The pass.
     */ removePass(pass) {
          const passes = this.passes;
          const index = passes.indexOf(pass);
          const exists = index !== -1;
          const removed = exists && passes.splice(index, 1).length > 0;
          if (removed) {
              if (this.depthTexture !== null) {
                  const reducer = (a, b)=>a || b.needsDepthTexture;
                  const depthTextureRequired = passes.reduce(reducer, false);
                  if (!depthTextureRequired) {
                      if (pass.getDepthTexture() === this.depthTexture) {
                          pass.setDepthTexture(null);
                      }
                      this.deleteDepthTexture();
                  }
              }
              if (this.autoRenderToScreen) {
                  if (index === passes.length) {
                      pass.renderToScreen = false;
                      if (passes.length > 0) {
                          passes[passes.length - 1].renderToScreen = true;
                      }
                  }
              }
          }
      }
      /**
     * Removes all passes.
     */ removeAllPasses() {
          const passes = this.passes;
          this.deleteDepthTexture();
          if (passes.length > 0) {
              if (this.autoRenderToScreen) {
                  passes[passes.length - 1].renderToScreen = false;
              }
              this.passes = [];
          }
      }
      /**
     * Renders all enabled passes in the order in which they were added.
     *
     * @param {Number} [deltaTime] - The time since the last frame in seconds.
     */ render(deltaTime) {
          const renderer = this.renderer;
          const copyPass = this.copyPass;
          let inputBuffer = this.inputBuffer;
          let outputBuffer = this.outputBuffer;
          let stencilTest = false;
          let context, stencil, buffer;
          if (deltaTime === void 0) {
              this.timer.update();
              deltaTime = this.timer.getDelta();
          }
          for (const pass of this.passes){
              if (pass.enabled) {
                  pass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
                  if (pass.needsSwap) {
                      if (stencilTest) {
                          copyPass.renderToScreen = pass.renderToScreen;
                          context = renderer.getContext();
                          stencil = renderer.state.buffers.stencil;
                          stencil.setFunc(context.NOTEQUAL, 1, 4294967295);
                          copyPass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
                          stencil.setFunc(context.EQUAL, 1, 4294967295);
                      }
                      buffer = inputBuffer;
                      inputBuffer = outputBuffer;
                      outputBuffer = buffer;
                  }
                  if (pass instanceof MaskPass) {
                      stencilTest = true;
                  } else if (pass instanceof ClearMaskPass) {
                      stencilTest = false;
                  }
              }
          }
      }
      /**
     * Sets the size of the buffers, passes and the renderer.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     * @param {Boolean} [updateStyle] - Determines whether the style of the canvas should be updated.
     */ setSize(width, height, updateStyle) {
          const renderer = this.renderer;
          const currentSize = renderer.getSize(new three.Vector2());
          if (width === void 0 || height === void 0) {
              width = currentSize.width;
              height = currentSize.height;
          }
          if (currentSize.width !== width || currentSize.height !== height) {
              renderer.setSize(width, height, updateStyle);
          }
          const drawingBufferSize = renderer.getDrawingBufferSize(new three.Vector2());
          this.inputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
          this.outputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
          for (const pass of this.passes){
              pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
          }
      }
      /**
     * Resets this composer by deleting all passes and creating new buffers.
     */ reset() {
          this.dispose();
          this.autoRenderToScreen = true;
      }
      /**
     * Disposes this composer and all passes.
     */ dispose() {
          for (const pass of this.passes){
              pass.dispose();
          }
          this.passes = [];
          if (this.inputBuffer !== null) {
              this.inputBuffer.dispose();
          }
          if (this.outputBuffer !== null) {
              this.outputBuffer.dispose();
          }
          this.deleteDepthTexture();
          this.copyPass.dispose();
          this.timer.dispose();
          Pass.fullscreenGeometry.dispose();
      }
      /**
     * Constructs a new effect composer.
     *
     * @param {WebGLRenderer} renderer - The renderer that should be used.
     * @param {Object} [options] - The options.
     * @param {Boolean} [options.depthBuffer=true] - Whether the main render targets should have a depth buffer.
     * @param {Boolean} [options.stencilBuffer=false] - Whether the main render targets should have a stencil buffer.
     * @param {Boolean} [options.alpha] - Deprecated. Buffers are always RGBA since three r137.
     * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
     * @param {Number} [options.frameBufferType] - The type of the internal frame buffers. It's recommended to use HalfFloatType if possible.
     */ constructor(renderer = null, { depthBuffer = true, stencilBuffer = false, multisampling = 0, frameBufferType } = {}){
          this.renderer = null;
          this.inputBuffer = this.createBuffer(depthBuffer, stencilBuffer, frameBufferType, multisampling);
          this.outputBuffer = this.inputBuffer.clone();
          this.copyPass = new CopyPass();
          this.depthTexture = null;
          this.passes = [];
          this.timer = new Timer();
          this.autoRenderToScreen = true;
          this.setRenderer(renderer);
      }
  };
  // src/enums/EffectAttribute.js
  var EffectAttribute = {
      NONE: 0,
      DEPTH: 1,
      CONVOLUTION: 2
  };
  // src/enums/EffectShaderSection.js
  var EffectShaderSection = {
      FRAGMENT_HEAD: "FRAGMENT_HEAD",
      FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
      FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
      VERTEX_HEAD: "VERTEX_HEAD",
      VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
  };
  // src/core/EffectShaderData.js
  var EffectShaderData = class {
      /**
     * Constructs new shader data.
     */ constructor(){
          this.shaderParts = /* @__PURE__ */ new Map([
              [
                  EffectShaderSection.FRAGMENT_HEAD,
                  null
              ],
              [
                  EffectShaderSection.FRAGMENT_MAIN_UV,
                  null
              ],
              [
                  EffectShaderSection.FRAGMENT_MAIN_IMAGE,
                  null
              ],
              [
                  EffectShaderSection.VERTEX_HEAD,
                  null
              ],
              [
                  EffectShaderSection.VERTEX_MAIN_SUPPORT,
                  null
              ]
          ]);
          this.defines = /* @__PURE__ */ new Map();
          this.uniforms = /* @__PURE__ */ new Map();
          this.blendModes = /* @__PURE__ */ new Map();
          this.extensions = /* @__PURE__ */ new Set();
          this.attributes = EffectAttribute.NONE;
          this.varyings = /* @__PURE__ */ new Set();
          this.uvTransformation = false;
          this.readDepth = false;
          this.colorSpace = three.LinearSRGBColorSpace;
      }
  };
  var workaroundEnabled = false;
  var OverrideMaterialManager = class {
      /**
     * Clones the given material.
     *
     * @private
     * @param {Material} material - The material.
     * @return {Material} The cloned material.
     */ cloneMaterial(material) {
          if (!(material instanceof three.ShaderMaterial)) {
              return material.clone();
          }
          const uniforms = material.uniforms;
          const textureUniforms = /* @__PURE__ */ new Map();
          for(const key in uniforms){
              const value = uniforms[key].value;
              if (value.isRenderTargetTexture) {
                  uniforms[key].value = null;
                  textureUniforms.set(key, value);
              }
          }
          const clone = material.clone();
          for (const entry of textureUniforms){
              uniforms[entry[0]].value = entry[1];
              clone.uniforms[entry[0]].value = entry[1];
          }
          return clone;
      }
      /**
     * Sets the override material.
     *
     * @param {Material} material - The material.
     */ setMaterial(material) {
          this.disposeMaterials();
          this.material = material;
          if (material !== null) {
              const materials = this.materials = [
                  this.cloneMaterial(material),
                  this.cloneMaterial(material),
                  this.cloneMaterial(material)
              ];
              for (const m2 of materials){
                  m2.uniforms = Object.assign({}, material.uniforms);
                  m2.side = three.FrontSide;
              }
              materials[2].skinning = true;
              this.materialsBackSide = materials.map((m2)=>{
                  const c2 = this.cloneMaterial(m2);
                  c2.uniforms = Object.assign({}, material.uniforms);
                  c2.side = three.BackSide;
                  return c2;
              });
              this.materialsDoubleSide = materials.map((m2)=>{
                  const c2 = this.cloneMaterial(m2);
                  c2.uniforms = Object.assign({}, material.uniforms);
                  c2.side = three.DoubleSide;
                  return c2;
              });
              this.materialsFlatShaded = materials.map((m2)=>{
                  const c2 = this.cloneMaterial(m2);
                  c2.uniforms = Object.assign({}, material.uniforms);
                  c2.flatShading = true;
                  return c2;
              });
              this.materialsFlatShadedBackSide = materials.map((m2)=>{
                  const c2 = this.cloneMaterial(m2);
                  c2.uniforms = Object.assign({}, material.uniforms);
                  c2.flatShading = true;
                  c2.side = three.BackSide;
                  return c2;
              });
              this.materialsFlatShadedDoubleSide = materials.map((m2)=>{
                  const c2 = this.cloneMaterial(m2);
                  c2.uniforms = Object.assign({}, material.uniforms);
                  c2.flatShading = true;
                  c2.side = three.DoubleSide;
                  return c2;
              });
          }
      }
      /**
     * Renders the scene with the override material.
     *
     * @private
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Scene} scene - A scene.
     * @param {Camera} camera - A camera.
     */ render(renderer, scene, camera) {
          const shadowMapEnabled = renderer.shadowMap.enabled;
          renderer.shadowMap.enabled = false;
          if (workaroundEnabled) {
              const originalMaterials = this.originalMaterials;
              this.meshCount = 0;
              scene.traverse(this.replaceMaterial);
              renderer.render(scene, camera);
              for (const entry of originalMaterials){
                  entry[0].material = entry[1];
              }
              if (this.meshCount !== originalMaterials.size) {
                  originalMaterials.clear();
              }
          } else {
              const overrideMaterial = scene.overrideMaterial;
              scene.overrideMaterial = this.material;
              renderer.render(scene, camera);
              scene.overrideMaterial = overrideMaterial;
          }
          renderer.shadowMap.enabled = shadowMapEnabled;
      }
      /**
     * Deletes cloned override materials.
     *
     * @private
     */ disposeMaterials() {
          if (this.material !== null) {
              const materials = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
              for (const m2 of materials){
                  m2.dispose();
              }
          }
      }
      /**
     * Performs cleanup tasks.
     */ dispose() {
          this.originalMaterials.clear();
          this.disposeMaterials();
      }
      /**
     * Indicates whether the override material workaround is enabled.
     *
     * @type {Boolean}
     */ static get workaroundEnabled() {
          return workaroundEnabled;
      }
      /**
     * Enables or disables the override material workaround globally.
     *
     * This only affects post processing passes and effects.
     *
     * @type {Boolean}
     */ static set workaroundEnabled(value) {
          workaroundEnabled = value;
      }
      /**
     * Constructs a new override material manager.
     *
     * @param {Material} [material=null] - An override material.
     */ constructor(material = null){
          this.originalMaterials = /* @__PURE__ */ new Map();
          this.material = null;
          this.materials = null;
          this.materialsBackSide = null;
          this.materialsDoubleSide = null;
          this.materialsFlatShaded = null;
          this.materialsFlatShadedBackSide = null;
          this.materialsFlatShadedDoubleSide = null;
          this.setMaterial(material);
          this.meshCount = 0;
          this.replaceMaterial = (node)=>{
              if (node.isMesh) {
                  let materials;
                  if (node.material.flatShading) {
                      switch(node.material.side){
                          case three.DoubleSide:
                              materials = this.materialsFlatShadedDoubleSide;
                              break;
                          case three.BackSide:
                              materials = this.materialsFlatShadedBackSide;
                              break;
                          default:
                              materials = this.materialsFlatShaded;
                              break;
                      }
                  } else {
                      switch(node.material.side){
                          case three.DoubleSide:
                              materials = this.materialsDoubleSide;
                              break;
                          case three.BackSide:
                              materials = this.materialsBackSide;
                              break;
                          default:
                              materials = this.materials;
                              break;
                      }
                  }
                  this.originalMaterials.set(node, node.material);
                  if (node.isSkinnedMesh) {
                      node.material = materials[2];
                  } else if (node.isInstancedMesh) {
                      node.material = materials[1];
                  } else {
                      node.material = materials[0];
                  }
                  ++this.meshCount;
              }
          };
      }
  };
  var AUTO_SIZE = -1;
  var Resolution = class extends three.EventDispatcher {
      /**
     * Calculates the effective size.
     *
     * @private
     */ updateEffectiveSize() {
          const base = this.baseSize;
          const preferred = this.preferredSize;
          const effective = this.effectiveSize;
          const scale = this.scale;
          if (preferred.width !== AUTO_SIZE) {
              effective.width = preferred.width;
          } else if (preferred.height !== AUTO_SIZE) {
              effective.width = Math.round(preferred.height * (base.width / Math.max(base.height, 1)));
          } else {
              effective.width = Math.round(base.width * scale);
          }
          if (preferred.height !== AUTO_SIZE) {
              effective.height = preferred.height;
          } else if (preferred.width !== AUTO_SIZE) {
              effective.height = Math.round(preferred.width / Math.max(base.width / Math.max(base.height, 1), 1));
          } else {
              effective.height = Math.round(base.height * scale);
          }
      }
      /**
     * The effective width.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
     *
     * @type {Number}
     */ get width() {
          return this.effectiveSize.width;
      }
      set width(value) {
          this.preferredWidth = value;
      }
      /**
     * The effective height.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
     *
     * @type {Number}
     */ get height() {
          return this.effectiveSize.height;
      }
      set height(value) {
          this.preferredHeight = value;
      }
      /**
     * Returns the effective width.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
     *
     * @deprecated Use width instead.
     * @return {Number} The effective width.
     */ getWidth() {
          return this.width;
      }
      /**
     * Returns the effective height.
     *
     * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
     *
     * @deprecated Use height instead.
     * @return {Number} The effective height.
     */ getHeight() {
          return this.height;
      }
      /**
     * The resolution scale.
     *
     * @type {Number}
     */ get scale() {
          return this.s;
      }
      set scale(value) {
          if (this.s !== value) {
              this.s = value;
              this.preferredSize.setScalar(AUTO_SIZE);
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Returns the current resolution scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} The scale.
     */ getScale() {
          return this.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * Also sets the preferred resolution to {@link Resizer.AUTO_SIZE}.
     *
     * @deprecated Use scale instead.
     * @param {Number} value - The scale.
     */ setScale(value) {
          this.scale = value;
      }
      /**
     * The base width.
     *
     * @type {Number}
     */ get baseWidth() {
          return this.baseSize.width;
      }
      set baseWidth(value) {
          if (this.baseSize.width !== value) {
              this.baseSize.width = value;
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Returns the base width.
     *
     * @deprecated Use baseWidth instead.
     * @return {Number} The base width.
     */ getBaseWidth() {
          return this.baseWidth;
      }
      /**
     * Sets the base width.
     *
     * @deprecated Use baseWidth instead.
     * @param {Number} value - The width.
     */ setBaseWidth(value) {
          this.baseWidth = value;
      }
      /**
     * The base height.
     *
     * @type {Number}
     */ get baseHeight() {
          return this.baseSize.height;
      }
      set baseHeight(value) {
          if (this.baseSize.height !== value) {
              this.baseSize.height = value;
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Returns the base height.
     *
     * @deprecated Use baseHeight instead.
     * @return {Number} The base height.
     */ getBaseHeight() {
          return this.baseHeight;
      }
      /**
     * Sets the base height.
     *
     * @deprecated Use baseHeight instead.
     * @param {Number} value - The height.
     */ setBaseHeight(value) {
          this.baseHeight = value;
      }
      /**
     * Sets the base size.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setBaseSize(width, height) {
          if (this.baseSize.width !== width || this.baseSize.height !== height) {
              this.baseSize.set(width, height);
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * The preferred width.
     *
     * @type {Number}
     */ get preferredWidth() {
          return this.preferredSize.width;
      }
      set preferredWidth(value) {
          if (this.preferredSize.width !== value) {
              this.preferredSize.width = value;
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Returns the preferred width.
     *
     * @deprecated Use preferredWidth instead.
     * @return {Number} The preferred width.
     */ getPreferredWidth() {
          return this.preferredWidth;
      }
      /**
     * Sets the preferred width.
     *
     * Use {@link Resizer.AUTO_SIZE} to automatically calculate the width based on the height and aspect ratio.
     *
     * @deprecated Use preferredWidth instead.
     * @param {Number} value - The width.
     */ setPreferredWidth(value) {
          this.preferredWidth = value;
      }
      /**
     * The preferred height.
     *
     * @type {Number}
     */ get preferredHeight() {
          return this.preferredSize.height;
      }
      set preferredHeight(value) {
          if (this.preferredSize.height !== value) {
              this.preferredSize.height = value;
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Returns the preferred height.
     *
     * @deprecated Use preferredHeight instead.
     * @return {Number} The preferred height.
     */ getPreferredHeight() {
          return this.preferredHeight;
      }
      /**
     * Sets the preferred height.
     *
     * Use {@link Resizer.AUTO_SIZE} to automatically calculate the height based on the width and aspect ratio.
     *
     * @deprecated Use preferredHeight instead.
     * @param {Number} value - The height.
     */ setPreferredHeight(value) {
          this.preferredHeight = value;
      }
      /**
     * Sets the preferred size.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setPreferredSize(width, height) {
          if (this.preferredSize.width !== width || this.preferredSize.height !== height) {
              this.preferredSize.set(width, height);
              this.dispatchEvent({
                  type: "change"
              });
              this.resizable.setSize(this.baseSize.width, this.baseSize.height);
          }
      }
      /**
     * Copies the given resolution.
     *
     * @param {Resolution} resolution - The resolution.
     */ copy(resolution) {
          this.s = resolution.scale;
          this.baseSize.set(resolution.baseWidth, resolution.baseHeight);
          this.preferredSize.set(resolution.preferredWidth, resolution.preferredHeight);
          this.dispatchEvent({
              type: "change"
          });
          this.resizable.setSize(this.baseSize.width, this.baseSize.height);
      }
      /**
     * An auto sizing constant.
     *
     * Can be used to automatically calculate the width or height based on the original aspect ratio.
     *
     * @type {Number}
     */ static get AUTO_SIZE() {
          return AUTO_SIZE;
      }
      /**
     * Constructs a new resolution.
     *
     * TODO Remove resizable param.
     * @param {Resizable} resizable - A resizable object.
     * @param {Number} [width=Resolution.AUTO_SIZE] - The preferred width.
     * @param {Number} [height=Resolution.AUTO_SIZE] - The preferred height.
     * @param {Number} [scale=1.0] - A resolution scale.
     */ constructor(resizable, width = AUTO_SIZE, height = AUTO_SIZE, scale = 1){
          super();
          this.resizable = resizable;
          this.baseSize = new three.Vector2(1, 1);
          this.preferredSize = new three.Vector2(width, height);
          this.target = this.preferredSize;
          this.s = scale;
          this.effectiveSize = new three.Vector2();
          this.addEventListener("change", ()=>this.updateEffectiveSize());
          this.updateEffectiveSize();
      }
  };
  // src/utils/IdManager.js
  var IdManager = class {
      /**
     * Returns the next unique ID.
     *
     * @return The ID.
     */ getNextId() {
          return this.nextId++;
      }
      /**
     * Resets the ID counter.
     *
     * @param initialId - The first ID.
     * @return This manager.
     */ reset(initialId = 0) {
          this.nextId = initialId;
          return this;
      }
      /**
     * Constructs a new ID manager.
     *
     * @param initialId - The first ID.
     */ constructor(initialId = 0){
          this.nextId = initialId;
      }
  };
  // src/core/Selection.js
  var idManager = /* @__PURE__ */ new IdManager(2);
  var Selection = class extends Set {
      /**
     * The render layer for selected objects.
     *
     * @type {Number}
     */ get layer() {
          return this._layer;
      }
      set layer(value) {
          const currentLayer = this._layer;
          for (const object of this){
              object.layers.disable(currentLayer);
              object.layers.enable(value);
          }
          this._layer = value;
      }
      /**
     * Returns the current render layer for selected objects.
     *
     * The default layer is 2. If this collides with your own custom layers, please change it before rendering!
     *
     * @deprecated Use layer instead.
     * @return {Number} The layer.
     */ getLayer() {
          return this.layer;
      }
      /**
     * Sets the render layer for selected objects.
     *
     * The current selection will be updated accordingly.
     *
     * @deprecated Use layer instead.
     * @param {Number} value - The layer. Range is [0, 31].
     */ setLayer(value) {
          this.layer = value;
      }
      /**
     * Indicates whether objects that are added to this selection will be removed from all other layers.
     *
     * @deprecated Use exclusive instead.
     * @return {Number} Whether this selection is exclusive. Default is false.
     */ isExclusive() {
          return this.exclusive;
      }
      /**
     * Controls whether objects that are added to this selection should be removed from all other layers.
     *
     * @deprecated Use exclusive instead.
     * @param {Number} value - Whether this selection should be exclusive.
     */ setExclusive(value) {
          this.exclusive = value;
      }
      /**
     * Clears this selection.
     *
     * @return {Selection} This selection.
     */ clear() {
          const layer = this.layer;
          for (const object of this){
              object.layers.disable(layer);
          }
          return super.clear();
      }
      /**
     * Clears this selection and adds the given objects.
     *
     * @param {Iterable<Object3D>} objects - The objects that should be selected.
     * @return {Selection} This selection.
     */ set(objects) {
          this.clear();
          for (const object of objects){
              this.add(object);
          }
          return this;
      }
      /**
     * An alias for {@link has}.
     *
     * @param {Object3D} object - An object.
     * @return {Number} Returns 0 if the given object is currently selected, or -1 otherwise.
     * @deprecated Added for backward-compatibility.
     */ indexOf(object) {
          return this.has(object) ? 0 : -1;
      }
      /**
     * Adds an object to this selection.
     *
     * If {@link exclusive} is set to `true`, the object will also be removed from all other layers.
     *
     * @param {Object3D} object - The object that should be selected.
     * @return {Selection} This selection.
     */ add(object) {
          if (this.exclusive) {
              object.layers.set(this.layer);
          } else {
              object.layers.enable(this.layer);
          }
          return super.add(object);
      }
      /**
     * Removes an object from this selection.
     *
     * @param {Object3D} object - The object that should be deselected.
     * @return {Boolean} Returns true if an object has successfully been removed from this selection; otherwise false.
     */ delete(object) {
          if (this.has(object)) {
              object.layers.disable(this.layer);
          }
          return super.delete(object);
      }
      /**
     * Removes an existing object from the selection. If the object doesn't exist it's added instead.
     *
     * @param {Object3D} object - The object.
     * @return {Boolean} Returns true if the object is added, false otherwise.
     */ toggle(object) {
          let result;
          if (this.has(object)) {
              this.delete(object);
              result = false;
          } else {
              this.add(object);
              result = true;
          }
          return result;
      }
      /**
     * Sets the visibility of all selected objects.
     *
     * This method enables or disables render layer 0 of all selected objects.
     *
     * @param {Boolean} visible - Whether the selected objects should be visible.
     * @return {Selection} This selection.
     */ setVisible(visible) {
          for (const object of this){
              if (visible) {
                  object.layers.enable(0);
              } else {
                  object.layers.disable(0);
              }
          }
          return this;
      }
      /**
     * Constructs a new selection.
     *
     * @param {Iterable<Object3D>} [iterable] - A collection of objects that should be added to this selection.
     * @param {Number} [layer] - A dedicated render layer for selected objects. Range is `[2, 31]`. Starts at 2 if omitted.
     */ constructor(iterable, layer = idManager.getNextId()){
          super();
          this.exclusive = false;
          this._layer = layer;
          if (this._layer < 1 || this._layer > 31) {
              console.warn("Layer out of range, resetting to 2");
              idManager.reset(2);
              this._layer = idManager.getNextId();
          }
          if (iterable !== void 0) {
              this.set(iterable);
          }
      }
  };
  // src/enums/BlendFunction.js
  var BlendFunction = {
      SKIP: 9,
      SET: 30,
      ADD: 0,
      ALPHA: 1,
      AVERAGE: 2,
      COLOR: 3,
      COLOR_BURN: 4,
      COLOR_DODGE: 5,
      DARKEN: 6,
      DIFFERENCE: 7,
      DIVIDE: 8,
      DST: 9,
      EXCLUSION: 10,
      HARD_LIGHT: 11,
      HARD_MIX: 12,
      HUE: 13,
      INVERT: 14,
      INVERT_RGB: 15,
      LIGHTEN: 16,
      LINEAR_BURN: 17,
      LINEAR_DODGE: 18,
      LINEAR_LIGHT: 19,
      LUMINOSITY: 20,
      MULTIPLY: 21,
      NEGATION: 22,
      NORMAL: 23,
      OVERLAY: 24,
      PIN_LIGHT: 25,
      REFLECT: 26,
      SATURATION: 27,
      SCREEN: 28,
      SOFT_LIGHT: 29,
      SRC: 30,
      SUBTRACT: 31,
      VIVID_LIGHT: 32
  };
  // src/effects/blending/glsl/add.frag
  var add_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y,opacity);}`;
  // src/effects/blending/glsl/alpha.frag
  var alpha_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,min(y.a,opacity));}`;
  // src/effects/blending/glsl/average.frag
  var average_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y)*0.5,opacity);}`;
  // src/effects/blending/glsl/color.frag
  var color_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.rg,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}`;
  // src/effects/blending/glsl/color-burn.frag
  var color_burn_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(step(0.0,y)*(1.0-min(vec4(1.0),(1.0-x)/y)),vec4(1.0),step(1.0,x));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/color-dodge.frag
  var color_dodge_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=step(0.0,x)*mix(min(vec4(1.0),x/max(1.0-y,1e-9)),vec4(1.0),step(1.0,y));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/darken.frag
  var darken_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x,y),opacity);}`;
  // src/effects/blending/glsl/difference.frag
  var difference_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,abs(x-y),opacity);}`;
  // src/effects/blending/glsl/divide.frag
  var divide_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x/max(y,1e-12),opacity);}`;
  // src/effects/blending/glsl/exclusion.frag
  var exclusion_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,(x+y-2.0*x*y),opacity);}`;
  // src/effects/blending/glsl/hard-light.frag
  var hard_light_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 a=min(x,1.0),b=min(y,1.0);vec4 z=mix(2.0*a*b,1.0-2.0*(1.0-a)*(1.0-b),step(0.5,y));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/hard-mix.frag
  var hard_mix_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,step(1.0,x+y),opacity);}`;
  // src/effects/blending/glsl/hue.frag
  var hue_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(yHSL.r,xHSL.gb));return vec4(mix(x.rgb,z,opacity),y.a);}`;
  // src/effects/blending/glsl/invert.frag
  var invert_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-y,opacity);}`;
  // src/effects/blending/glsl/invert-rgb.frag
  var invert_rgb_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y*(1.0-x),opacity);}`;
  // src/effects/blending/glsl/lighten.frag
  var lighten_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x,y),opacity);}`;
  // src/effects/blending/glsl/linear-burn.frag
  var linear_burn_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(y+x-1.0,0.0,1.0),opacity);}`;
  // src/effects/blending/glsl/linear-dodge.frag
  var linear_dodge_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,min(x+y,1.0),opacity);}`;
  // src/effects/blending/glsl/linear-light.frag
  var linear_light_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,clamp(2.0*y+x-1.0,0.0,1.0),opacity);}`;
  // src/effects/blending/glsl/luminosity.frag
  var luminosity_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.rg,yHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}`;
  // src/effects/blending/glsl/multiply.frag
  var multiply_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x*y,opacity);}`;
  // src/effects/blending/glsl/negation.frag
  var negation_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,1.0-abs(1.0-x-y),opacity);}`;
  // src/effects/blending/glsl/normal.frag
  var normal_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,y,opacity);}`;
  // src/effects/blending/glsl/overlay.frag
  var overlay_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(2.0*y*x,1.0-2.0*(1.0-y)*(1.0-x),step(0.5,x));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/pin-light.frag
  var pin_light_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 z=mix(mix(y2,x,step(0.5*x,y)),max(vec4(0.0),y2-1.0),step(x,(y2-1.0)));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/reflect.frag
  var reflect_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(min(x*x/max(1.0-y,1e-12),1.0),y,step(1.0,y));return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/saturation.frag
  var saturation_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec3 xHSL=RGBToHSL(x.rgb);vec3 yHSL=RGBToHSL(y.rgb);vec3 z=HSLToRGB(vec3(xHSL.r,yHSL.g,xHSL.b));return vec4(mix(x.rgb,z,opacity),y.a);}`;
  // src/effects/blending/glsl/screen.frag
  var screen_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,x+y-min(x*y,1.0),opacity);}`;
  // src/effects/blending/glsl/soft-light.frag
  var soft_light_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 y2=2.0*y;vec4 w=step(0.5,y);vec4 z=mix(x-(1.0-y2)*x*(1.0-x),mix(x+(y2-1.0)*(sqrt(x)-x),x+(y2-1.0)*x*((16.0*x-12.0)*x+3.0),w*(1.0-step(0.25,x))),w);return mix(x,z,opacity);}`;
  // src/effects/blending/glsl/src.frag
  var src_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y;}`;
  // src/effects/blending/glsl/subtract.frag
  var subtract_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return mix(x,max(x+y-1.0,0.0),opacity);}`;
  // src/effects/blending/glsl/vivid-light.frag
  var vivid_light_default = `vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=mix(max(1.0-min((1.0-x)/(2.0*y),1.0),0.0),min(x/(2.0*(1.0-y)),1.0),step(0.5,y));return mix(x,z,opacity);}`;
  // src/effects/blending/BlendMode.js
  var blendFunctions = /* @__PURE__ */ new Map([
      [
          BlendFunction.ADD,
          add_default
      ],
      [
          BlendFunction.ALPHA,
          alpha_default
      ],
      [
          BlendFunction.AVERAGE,
          average_default
      ],
      [
          BlendFunction.COLOR,
          color_default
      ],
      [
          BlendFunction.COLOR_BURN,
          color_burn_default
      ],
      [
          BlendFunction.COLOR_DODGE,
          color_dodge_default
      ],
      [
          BlendFunction.DARKEN,
          darken_default
      ],
      [
          BlendFunction.DIFFERENCE,
          difference_default
      ],
      [
          BlendFunction.DIVIDE,
          divide_default
      ],
      [
          BlendFunction.DST,
          null
      ],
      [
          BlendFunction.EXCLUSION,
          exclusion_default
      ],
      [
          BlendFunction.HARD_LIGHT,
          hard_light_default
      ],
      [
          BlendFunction.HARD_MIX,
          hard_mix_default
      ],
      [
          BlendFunction.HUE,
          hue_default
      ],
      [
          BlendFunction.INVERT,
          invert_default
      ],
      [
          BlendFunction.INVERT_RGB,
          invert_rgb_default
      ],
      [
          BlendFunction.LIGHTEN,
          lighten_default
      ],
      [
          BlendFunction.LINEAR_BURN,
          linear_burn_default
      ],
      [
          BlendFunction.LINEAR_DODGE,
          linear_dodge_default
      ],
      [
          BlendFunction.LINEAR_LIGHT,
          linear_light_default
      ],
      [
          BlendFunction.LUMINOSITY,
          luminosity_default
      ],
      [
          BlendFunction.MULTIPLY,
          multiply_default
      ],
      [
          BlendFunction.NEGATION,
          negation_default
      ],
      [
          BlendFunction.NORMAL,
          normal_default
      ],
      [
          BlendFunction.OVERLAY,
          overlay_default
      ],
      [
          BlendFunction.PIN_LIGHT,
          pin_light_default
      ],
      [
          BlendFunction.REFLECT,
          reflect_default
      ],
      [
          BlendFunction.SATURATION,
          saturation_default
      ],
      [
          BlendFunction.SCREEN,
          screen_default
      ],
      [
          BlendFunction.SOFT_LIGHT,
          soft_light_default
      ],
      [
          BlendFunction.SRC,
          src_default
      ],
      [
          BlendFunction.SUBTRACT,
          subtract_default
      ],
      [
          BlendFunction.VIVID_LIGHT,
          vivid_light_default
      ]
  ]);
  var BlendMode = class extends three.EventDispatcher {
      /**
     * Returns the opacity.
     *
     * @return {Number} The opacity.
     */ getOpacity() {
          return this.opacity.value;
      }
      /**
     * Sets the opacity.
     *
     * @param {Number} value - The opacity.
     */ setOpacity(value) {
          this.opacity.value = value;
      }
      /**
     * The blend function.
     *
     * @type {BlendFunction}
     */ get blendFunction() {
          return this._blendFunction;
      }
      set blendFunction(value) {
          this._blendFunction = value;
          this.dispatchEvent({
              type: "change"
          });
      }
      /**
     * Returns the blend function.
     *
     * @deprecated Use blendFunction instead.
     * @return {BlendFunction} The blend function.
     */ getBlendFunction() {
          return this.blendFunction;
      }
      /**
     * Sets the blend function.
     *
     * @deprecated Use blendFunction instead.
     * @param {BlendFunction} value - The blend function.
     */ setBlendFunction(value) {
          this.blendFunction = value;
      }
      /**
     * Returns the blend function shader code.
     *
     * @return {String} The blend function shader code.
     */ getShaderCode() {
          return blendFunctions.get(this.blendFunction);
      }
      /**
     * Constructs a new blend mode.
     *
     * @param {BlendFunction} blendFunction - The blend function.
     * @param {Number} opacity - The opacity of the color that will be blended with the base color.
     */ constructor(blendFunction, opacity = 1){
          super();
          this._blendFunction = blendFunction;
          this.opacity = new three.Uniform(opacity);
      }
  };
  var Effect = class extends three.EventDispatcher {
      /**
     * The input color space.
     *
     * @type {ColorSpace}
     * @experimental
     */ get inputColorSpace() {
          return this._inputColorSpace;
      }
      /**
     * @type {ColorSpace}
     * @protected
     * @experimental
     */ set inputColorSpace(value) {
          this._inputColorSpace = value;
          this.setChanged();
      }
      /**
     * The output color space.
     *
     * Should only be changed if this effect converts the input colors to a different color space.
     *
     * @type {ColorSpace}
     * @experimental
     */ get outputColorSpace() {
          return this._outputColorSpace;
      }
      /**
     * @type {ColorSpace}
     * @protected
     * @experimental
     */ set outputColorSpace(value) {
          this._outputColorSpace = value;
          this.setChanged();
      }
      /**
     * Sets the main scene.
     *
     * @type {Scene}
     */ set mainScene(value) {}
      /**
     * Sets the main camera.
     *
     * @type {Camera}
     */ set mainCamera(value) {}
      /**
     * Returns the name of this effect.
     *
     * @deprecated Use name instead.
     * @return {String} The name.
     */ getName() {
          return this.name;
      }
      /**
     * Sets the renderer.
     *
     * @deprecated
     * @param {WebGLRenderer} renderer - The renderer.
     */ setRenderer(renderer) {
          this.renderer = renderer;
      }
      /**
     * Returns the preprocessor macro definitions.
     *
     * @deprecated Use defines instead.
     * @return {Map<String, String>} The extensions.
     */ getDefines() {
          return this.defines;
      }
      /**
     * Returns the uniforms of this effect.
     *
     * @deprecated Use uniforms instead.
     * @return {Map<String, Uniform>} The extensions.
     */ getUniforms() {
          return this.uniforms;
      }
      /**
     * Returns the WebGL extensions that are required by this effect.
     *
     * @deprecated Use extensions instead.
     * @return {Set<WebGLExtension>} The extensions.
     */ getExtensions() {
          return this.extensions;
      }
      /**
     * Returns the blend mode.
     *
     * The result of this effect will be blended with the result of the previous effect using this blend mode.
     *
     * @deprecated Use blendMode instead.
     * @return {BlendMode} The blend mode.
     */ getBlendMode() {
          return this.blendMode;
      }
      /**
     * Returns the effect attributes.
     *
     * @return {EffectAttribute} The attributes.
     */ getAttributes() {
          return this.attributes;
      }
      /**
     * Sets the effect attributes.
     *
     * Effects that have the same attributes will be executed in the order in which they were registered. Some attributes
     * imply a higher priority.
     *
     * @protected
     * @param {EffectAttribute} attributes - The attributes.
     */ setAttributes(attributes) {
          this.attributes = attributes;
          this.setChanged();
      }
      /**
     * Returns the fragment shader.
     *
     * @return {String} The fragment shader.
     */ getFragmentShader() {
          return this.fragmentShader;
      }
      /**
     * Sets the fragment shader.
     *
     * @protected
     * @param {String} fragmentShader - The fragment shader.
     */ setFragmentShader(fragmentShader) {
          this.fragmentShader = fragmentShader;
          this.setChanged();
      }
      /**
     * Returns the vertex shader.
     *
     * @return {String} The vertex shader.
     */ getVertexShader() {
          return this.vertexShader;
      }
      /**
     * Sets the vertex shader.
     *
     * @protected
     * @param {String} vertexShader - The vertex shader.
     */ setVertexShader(vertexShader) {
          this.vertexShader = vertexShader;
          this.setChanged();
      }
      /**
     * Informs the associated {@link EffectPass} that this effect requires a shader recompilation.
     *
     * Should be called after changing macros or extensions and after adding/removing uniforms.
     *
     * @protected
     */ setChanged() {
          this.dispatchEvent({
              type: "change"
          });
      }
      /**
     * Sets the depth texture.
     *
     * You may override this method if your effect requires direct access to the depth texture that is bound to the
     * associated {@link EffectPass}.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {}
      /**
     * Updates this effect by performing supporting operations.
     *
     * This method is called by the {@link EffectPass} right before the main fullscreen render operation, even if the
     * blend function is set to `SKIP`.
     *
     * You may override this method if you need to update custom uniforms or render additional off-screen textures.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {}
      /**
     * Updates the size of this effect.
     *
     * You may override this method if you want to be informed about the size of the backbuffer/canvas.
     * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {}
      /**
     * Performs initialization tasks.
     *
     * This method is called when the associated {@link EffectPass} is added to an {@link EffectComposer}.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     * @example if(!alpha && frameBufferType === UnsignedByteType) { this.myRenderTarget.texture.format = RGBFormat; }
     */ initialize(renderer, alpha, frameBufferType) {}
      /**
     * Performs a shallow search for properties that define a dispose method and deletes them.
     *
     * The {@link EffectComposer} calls this method when it is being destroyed.
     */ dispose() {
          for (const key of Object.keys(this)){
              const property = this[key];
              const isDisposable = property instanceof three.WebGLRenderTarget || property instanceof three.Material || property instanceof three.Texture || property instanceof Pass;
              if (isDisposable) {
                  this[key].dispose();
              }
          }
      }
      /**
     * Constructs a new effect.
     *
     * @param {String} name - The name of this effect. Doesn't have to be unique.
     * @param {String} fragmentShader - The fragment shader. This shader is required.
     * @param {Object} [options] - Additional options.
     * @param {EffectAttribute} [options.attributes=EffectAttribute.NONE] - The effect attributes that determine the execution priority and resource requirements.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
     * @param {Map<String, String>} [options.defines] - Custom preprocessor macro definitions. Keys are names and values are code.
     * @param {Map<String, Uniform>} [options.uniforms] - Custom shader uniforms. Keys are names and values are uniforms.
     * @param {Set<WebGLExtension>} [options.extensions] - WebGL extensions.
     * @param {String} [options.vertexShader=null] - The vertex shader. Most effects don't need one.
     */ constructor(name, fragmentShader, { attributes = EffectAttribute.NONE, blendFunction = BlendFunction.NORMAL, defines = /* @__PURE__ */ new Map(), uniforms = /* @__PURE__ */ new Map(), extensions = null, vertexShader = null } = {}){
          super();
          this.name = name;
          this.renderer = null;
          this.attributes = attributes;
          this.fragmentShader = fragmentShader;
          this.vertexShader = vertexShader;
          this.defines = defines;
          this.uniforms = uniforms;
          this.extensions = extensions;
          this.blendMode = new BlendMode(blendFunction);
          this.blendMode.addEventListener("change", (event)=>this.setChanged());
          this._inputColorSpace = three.LinearSRGBColorSpace;
          this._outputColorSpace = three.NoColorSpace;
      }
  };
  // src/enums/KernelSize.js
  var KernelSize = {
      VERY_SMALL: 0,
      MEDIUM: 2,
      LARGE: 3,
      HUGE: 5
  };
  // src/materials/glsl/convolution.kawase.frag
  var convolution_kawase_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <colorspace_fragment>
}`;
  // src/materials/glsl/convolution.kawase.vert
  var convolution_kawase_default2 = `uniform vec4 texelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/KawaseBlurMaterial.js
  var kernelPresets = [
      new Float32Array([
          0,
          0
      ]),
      new Float32Array([
          0,
          1,
          1
      ]),
      new Float32Array([
          0,
          1,
          1,
          2
      ]),
      new Float32Array([
          0,
          1,
          2,
          2,
          3
      ]),
      new Float32Array([
          0,
          1,
          2,
          3,
          4,
          4,
          5
      ]),
      new Float32Array([
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8,
          9,
          10
      ])
  ];
  var KawaseBlurMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */ setInputBuffer(value) {
          this.inputBuffer = value;
      }
      /**
     * The kernel sequence for the current kernel size.
     *
     * @type {Float32Array}
     */ get kernelSequence() {
          return kernelPresets[this.kernelSize];
      }
      /**
     * The blur scale.
     *
     * @type {Number}
     */ get scale() {
          return this.uniforms.scale.value;
      }
      set scale(value) {
          this.uniforms.scale.value = value;
      }
      /**
     * Returns the blur scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} The scale.
     */ getScale() {
          return this.uniforms.scale.value;
      }
      /**
     * Sets the blur scale.
     *
     * @deprecated Use scale instead.
     * @return {Number} value - The scale.
     */ setScale(value) {
          this.uniforms.scale.value = value;
      }
      /**
     * Returns the kernel.
     *
     * @return {Float32Array} The kernel.
     * @deprecated Implementation detail, removed with no replacement.
     */ getKernel() {
          return null;
      }
      /**
     * The current kernel.
     *
     * @type {Number}
     */ get kernel() {
          return this.uniforms.kernel.value;
      }
      set kernel(value) {
          this.uniforms.kernel.value = value;
      }
      /**
     * Sets the current kernel.
     *
     * @deprecated Use kernel instead.
     * @param {Number} value - The kernel.
     */ setKernel(value) {
          this.kernel = value;
      }
      /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */ setTexelSize(x, y) {
          this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const x = 1 / width, y = 1 / height;
          this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
      }
      /**
     * Constructs a new convolution material.
     *
     * TODO Remove texelSize param.
     * @param {Vector4} [texelSize] - Deprecated.
     */ constructor(texelSize = new three.Vector4()){
          super({
              name: "KawaseBlurMaterial",
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(new three.Vector4()),
                  scale: new three.Uniform(1),
                  kernel: new three.Uniform(0)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: convolution_kawase_default,
              vertexShader: convolution_kawase_default2
          });
          this.setTexelSize(texelSize.x, texelSize.y);
          this.kernelSize = KernelSize.MEDIUM;
      }
  };
  // src/passes/KawaseBlurPass.js
  var KawaseBlurPass = class extends Pass {
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * The blur material.
     *
     * @type {KawaseBlurMaterial}
     */ get blurMaterial() {
          return this._blurMaterial;
      }
      /**
     * The blur material.
     *
     * @type {KawaseBlurMaterial}
     * @protected
     */ set blurMaterial(value) {
          this._blurMaterial = value;
      }
      /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     * @deprecated Use copyMaterial.dithering instead.
     */ get dithering() {
          return this.copyMaterial.dithering;
      }
      set dithering(value) {
          this.copyMaterial.dithering = value;
      }
      /**
     * The kernel size.
     *
     * @type {KernelSize}
     * @deprecated Use blurMaterial.kernelSize instead.
     */ get kernelSize() {
          return this.blurMaterial.kernelSize;
      }
      set kernelSize(value) {
          this.blurMaterial.kernelSize = value;
      }
      /**
     * The current width of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.width instead.
     */ get width() {
          return this.resolution.width;
      }
      /**
     * Sets the render width.
     *
     * @type {Number}
     * @deprecated Use resolution.preferredWidth instead.
     */ set width(value) {
          this.resolution.preferredWidth = value;
      }
      /**
     * The current height of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.height instead.
     */ get height() {
          return this.resolution.height;
      }
      /**
     * Sets the render height.
     *
     * @type {Number}
     * @deprecated Use resolution.preferredHeight instead.
     */ set height(value) {
          this.resolution.preferredHeight = value;
      }
      /**
     * The current blur scale.
     *
     * @type {Number}
     * @deprecated Use blurMaterial.scale instead.
     */ get scale() {
          return this.blurMaterial.scale;
      }
      set scale(value) {
          this.blurMaterial.scale = value;
      }
      /**
     * Returns the current blur scale.
     *
     * @deprecated Use blurMaterial.scale instead.
     * @return {Number} The scale.
     */ getScale() {
          return this.blurMaterial.scale;
      }
      /**
     * Sets the blur scale.
     *
     * @deprecated Use blurMaterial.scale instead.
     * @param {Number} value - The scale.
     */ setScale(value) {
          this.blurMaterial.scale = value;
      }
      /**
     * Returns the kernel size.
     *
     * @deprecated Use blurMaterial.kernelSize instead.
     * @return {KernelSize} The kernel size.
     */ getKernelSize() {
          return this.kernelSize;
      }
      /**
     * Sets the kernel size.
     *
     * Larger kernels require more processing power but scale well with larger render resolutions.
     *
     * @deprecated Use blurMaterial.kernelSize instead.
     * @param {KernelSize} value - The kernel size.
     */ setKernelSize(value) {
          this.kernelSize = value;
      }
      /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution instead.
     */ getResolutionScale() {
          return this.resolution.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution instead.
     */ setResolutionScale(scale) {
          this.resolution.scale = scale;
      }
      /**
     * Renders the blur.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const scene = this.scene;
          const camera = this.camera;
          const renderTargetA = this.renderTargetA;
          const renderTargetB = this.renderTargetB;
          const material = this.blurMaterial;
          const kernelSequence = material.kernelSequence;
          let previousBuffer = inputBuffer;
          this.fullscreenMaterial = material;
          for(let i = 0, l = kernelSequence.length; i < l; ++i){
              const buffer = (i & 1) === 0 ? renderTargetA : renderTargetB;
              material.kernel = kernelSequence[i];
              material.inputBuffer = previousBuffer.texture;
              renderer.setRenderTarget(buffer);
              renderer.render(scene, camera);
              previousBuffer = buffer;
          }
          this.fullscreenMaterial = this.copyMaterial;
          this.copyMaterial.inputBuffer = previousBuffer.texture;
          renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
          renderer.render(scene, camera);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          const w = resolution.width, h = resolution.height;
          this.renderTargetA.setSize(w, h);
          this.renderTargetB.setSize(w, h);
          this.blurMaterial.setSize(width, height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          if (frameBufferType !== void 0) {
              this.renderTargetA.texture.type = frameBufferType;
              this.renderTargetB.texture.type = frameBufferType;
              if (frameBufferType !== three.UnsignedByteType) {
                  this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                  this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
              } else if (renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
                  this.renderTargetA.texture.colorSpace = three.SRGBColorSpace;
                  this.renderTargetB.texture.colorSpace = three.SRGBColorSpace;
              }
          }
      }
      /**
     * An auto sizing flag.
     *
     * @type {Number}
     * @deprecated Use {@link Resolution.AUTO_SIZE} instead.
     */ static get AUTO_SIZE() {
          return Resolution.AUTO_SIZE;
      }
      /**
     * Constructs a new Kawase blur pass.
     *
     * @param {Object} [options] - The options.
     * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
     * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor({ kernelSize = KernelSize.MEDIUM, resolutionScale = 0.5, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("KawaseBlurPass");
          this.renderTargetA = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTargetA.texture.name = "Blur.Target.A";
          this.renderTargetB = this.renderTargetA.clone();
          this.renderTargetB.texture.name = "Blur.Target.B";
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
          this._blurMaterial = new KawaseBlurMaterial();
          this._blurMaterial.kernelSize = kernelSize;
          this.copyMaterial = new CopyMaterial();
      }
  };
  // src/materials/glsl/luminance.frag
  var luminance_default = `#include <common>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l)*l;
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*clamp(l,0.0,1.0),l);
#else
gl_FragColor=vec4(l);
#endif
}`;
  // src/materials/LuminanceMaterial.js
  var LuminanceMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */ setInputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * The luminance threshold.
     *
     * @type {Number}
     */ get threshold() {
          return this.uniforms.threshold.value;
      }
      set threshold(value) {
          if (this.smoothing > 0 || value > 0) {
              this.defines.THRESHOLD = "1";
          } else {
              delete this.defines.THRESHOLD;
          }
          this.uniforms.threshold.value = value;
      }
      /**
     * Returns the luminance threshold.
     *
     * @deprecated Use threshold instead.
     * @return {Number} The threshold.
     */ getThreshold() {
          return this.threshold;
      }
      /**
     * Sets the luminance threshold.
     *
     * @deprecated Use threshold instead.
     * @param {Number} value - The threshold.
     */ setThreshold(value) {
          this.threshold = value;
      }
      /**
     * The luminance threshold smoothing.
     *
     * @type {Number}
     */ get smoothing() {
          return this.uniforms.smoothing.value;
      }
      set smoothing(value) {
          if (this.threshold > 0 || value > 0) {
              this.defines.THRESHOLD = "1";
          } else {
              delete this.defines.THRESHOLD;
          }
          this.uniforms.smoothing.value = value;
      }
      /**
     * Returns the luminance threshold smoothing factor.
     *
     * @deprecated Use smoothing instead.
     * @return {Number} The smoothing factor.
     */ getSmoothingFactor() {
          return this.smoothing;
      }
      /**
     * Sets the luminance threshold smoothing factor.
     *
     * @deprecated Use smoothing instead.
     * @param {Number} value - The smoothing factor.
     */ setSmoothingFactor(value) {
          this.smoothing = value;
      }
      /**
     * Indicates whether the luminance threshold is enabled.
     *
     * @type {Boolean}
     * @deprecated Adjust the threshold or smoothing factor instead.
     */ get useThreshold() {
          return this.threshold > 0 || this.smoothing > 0;
      }
      set useThreshold(value) {}
      /**
     * Indicates whether color output is enabled.
     *
     * @type {Boolean}
     */ get colorOutput() {
          return this.defines.COLOR !== void 0;
      }
      set colorOutput(value) {
          if (value) {
              this.defines.COLOR = "1";
          } else {
              delete this.defines.COLOR;
          }
          this.needsUpdate = true;
      }
      /**
     * Indicates whether color output is enabled.
     *
     * @deprecated Use colorOutput instead.
     * @return {Boolean} Whether color output is enabled.
     */ isColorOutputEnabled(value) {
          return this.colorOutput;
      }
      /**
     * Enables or disables color output.
     *
     * @deprecated Use colorOutput instead.
     * @param {Boolean} value - Whether color output should be enabled.
     */ setColorOutputEnabled(value) {
          this.colorOutput = value;
      }
      /**
     * Indicates whether luminance masking is enabled.
     *
     * @type {Boolean}
     * @deprecated
     */ get useRange() {
          return this.luminanceRange !== null;
      }
      set useRange(value) {
          this.luminanceRange = null;
      }
      /**
     * The luminance range. Set to null to disable.
     *
     * @type {Boolean}
     */ get luminanceRange() {
          return this.uniforms.range.value;
      }
      set luminanceRange(value) {
          if (value !== null) {
              this.defines.RANGE = "1";
          } else {
              delete this.defines.RANGE;
          }
          this.uniforms.range.value = value;
          this.needsUpdate = true;
      }
      /**
     * Returns the current luminance range.
     *
     * @deprecated Use luminanceRange instead.
     * @return {Vector2} The luminance range.
     */ getLuminanceRange() {
          return this.luminanceRange;
      }
      /**
     * Sets a luminance range. Set to null to disable.
     *
     * @deprecated Use luminanceRange instead.
     * @param {Vector2} value - The luminance range.
     */ setLuminanceRange(value) {
          this.luminanceRange = value;
      }
      /**
     * Constructs a new luminance material.
     *
     * @param {Boolean} [colorOutput=false] - Defines whether the shader should output colors scaled with their luminance value.
     * @param {Vector2} [luminanceRange] - If provided, the shader will mask out texels that aren't in the specified luminance range.
     */ constructor(colorOutput = false, luminanceRange = null){
          super({
              name: "LuminanceMaterial",
              defines: {
                  THREE_REVISION: three.REVISION.replace(/\D+/g, "")
              },
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  threshold: new three.Uniform(0),
                  smoothing: new three.Uniform(1),
                  range: new three.Uniform(null)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: luminance_default,
              vertexShader: common_default
          });
          this.colorOutput = colorOutput;
          this.luminanceRange = luminanceRange;
      }
  };
  // src/passes/LuminancePass.js
  var LuminancePass = class extends Pass {
      /**
     * The luminance texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the luminance texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Renders the luminance.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const material = this.fullscreenMaterial;
          material.inputBuffer = inputBuffer.texture;
          renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
          renderer.render(this.scene, this.camera);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          this.renderTarget.setSize(resolution.width, resolution.height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - A renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          if (frameBufferType !== void 0 && frameBufferType !== three.UnsignedByteType) {
              this.renderTarget.texture.type = frameBufferType;
              this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
          }
      }
      /**
     * Constructs a new luminance pass.
     *
     * @param {Object} [options] - The options. See {@link LuminanceMaterial} for additional options.
     * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor({ renderTarget, luminanceRange, colorOutput, resolutionScale = 1, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("LuminancePass");
          this.fullscreenMaterial = new LuminanceMaterial(colorOutput, luminanceRange);
          this.needsSwap = false;
          this.renderTarget = renderTarget;
          if (this.renderTarget === void 0) {
              this.renderTarget = new three.WebGLRenderTarget(1, 1, {
                  depthBuffer: false
              });
              this.renderTarget.texture.name = "LuminancePass.Target";
          }
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
      }
  };
  // src/materials/glsl/convolution.downsampling.frag
  var convolution_downsampling_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#define WEIGHT_INNER 0.125
#define WEIGHT_OUTER 0.0555555
varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;float clampToBorder(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void main(){vec4 c=vec4(0.0);vec4 w=WEIGHT_INNER*vec4(clampToBorder(vUv00),clampToBorder(vUv01),clampToBorder(vUv02),clampToBorder(vUv03));c+=w.x*texture2D(inputBuffer,vUv00);c+=w.y*texture2D(inputBuffer,vUv01);c+=w.z*texture2D(inputBuffer,vUv02);c+=w.w*texture2D(inputBuffer,vUv03);w=WEIGHT_OUTER*vec4(clampToBorder(vUv04),clampToBorder(vUv05),clampToBorder(vUv06),clampToBorder(vUv07));c+=w.x*texture2D(inputBuffer,vUv04);c+=w.y*texture2D(inputBuffer,vUv05);c+=w.z*texture2D(inputBuffer,vUv06);c+=w.w*texture2D(inputBuffer,vUv07);w=WEIGHT_OUTER*vec4(clampToBorder(vUv08),clampToBorder(vUv09),clampToBorder(vUv10),clampToBorder(vUv11));c+=w.x*texture2D(inputBuffer,vUv08);c+=w.y*texture2D(inputBuffer,vUv09);c+=w.z*texture2D(inputBuffer,vUv10);c+=w.w*texture2D(inputBuffer,vUv11);c+=WEIGHT_OUTER*texture2D(inputBuffer,vUv);gl_FragColor=c;
#include <colorspace_fragment>
}`;
  // src/materials/glsl/convolution.downsampling.vert
  var convolution_downsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;void main(){vUv=position.xy*0.5+0.5;vUv00=vUv+texelSize*vec2(-1.0,1.0);vUv01=vUv+texelSize*vec2(1.0,1.0);vUv02=vUv+texelSize*vec2(-1.0,-1.0);vUv03=vUv+texelSize*vec2(1.0,-1.0);vUv04=vUv+texelSize*vec2(-2.0,2.0);vUv05=vUv+texelSize*vec2(0.0,2.0);vUv06=vUv+texelSize*vec2(2.0,2.0);vUv07=vUv+texelSize*vec2(-2.0,0.0);vUv08=vUv+texelSize*vec2(2.0,0.0);vUv09=vUv+texelSize*vec2(-2.0,-2.0);vUv10=vUv+texelSize*vec2(0.0,-2.0);vUv11=vUv+texelSize*vec2(2.0,-2.0);gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/DownsamplingMaterial.js
  var DownsamplingMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.uniforms.texelSize.value.set(1 / width, 1 / height);
      }
      /**
     * Constructs a new downsampling material.
     */ constructor(){
          super({
              name: "DownsamplingMaterial",
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(new three.Vector2())
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: convolution_downsampling_default,
              vertexShader: convolution_downsampling_default2
          });
      }
  };
  // src/materials/glsl/convolution.upsampling.frag
  var convolution_upsampling_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;uniform mediump sampler2D supportBuffer;
#else
uniform lowp sampler2D inputBuffer;uniform lowp sampler2D supportBuffer;
#endif
uniform float radius;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vec4 c=vec4(0.0);c+=texture2D(inputBuffer,vUv0)*0.0625;c+=texture2D(inputBuffer,vUv1)*0.125;c+=texture2D(inputBuffer,vUv2)*0.0625;c+=texture2D(inputBuffer,vUv3)*0.125;c+=texture2D(inputBuffer,vUv)*0.25;c+=texture2D(inputBuffer,vUv4)*0.125;c+=texture2D(inputBuffer,vUv5)*0.0625;c+=texture2D(inputBuffer,vUv6)*0.125;c+=texture2D(inputBuffer,vUv7)*0.0625;vec4 baseColor=texture2D(supportBuffer,vUv);gl_FragColor=mix(baseColor,c,radius);
#include <colorspace_fragment>
}`;
  // src/materials/glsl/convolution.upsampling.vert
  var convolution_upsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,1.0);vUv1=vUv+texelSize*vec2(0.0,1.0);vUv2=vUv+texelSize*vec2(1.0,1.0);vUv3=vUv+texelSize*vec2(-1.0,0.0);vUv4=vUv+texelSize*vec2(1.0,0.0);vUv5=vUv+texelSize*vec2(-1.0,-1.0);vUv6=vUv+texelSize*vec2(0.0,-1.0);vUv7=vUv+texelSize*vec2(1.0,-1.0);gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/UpsamplingMaterial.js
  var UpsamplingMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * A support buffer.
     *
     * @type {Texture}
     */ set supportBuffer(value) {
          this.uniforms.supportBuffer.value = value;
      }
      /**
     * The blur radius.
     *
     * @type {Number}
     */ get radius() {
          return this.uniforms.radius.value;
      }
      set radius(value) {
          this.uniforms.radius.value = value;
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.uniforms.texelSize.value.set(1 / width, 1 / height);
      }
      /**
     * Constructs a new upsampling material.
     */ constructor(){
          super({
              name: "UpsamplingMaterial",
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  supportBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(new three.Vector2()),
                  radius: new three.Uniform(0.85)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: convolution_upsampling_default,
              vertexShader: convolution_upsampling_default2
          });
      }
  };
  // src/passes/MipmapBlurPass.js
  var MipmapBlurPass = class extends Pass {
      /**
     * A texture that contains the blurred result.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * The MIP levels. Default is 8.
     *
     * @type {Number}
     */ get levels() {
          return this.downsamplingMipmaps.length;
      }
      set levels(value) {
          if (this.levels !== value) {
              const renderTarget = this.renderTarget;
              this.dispose();
              this.downsamplingMipmaps = [];
              this.upsamplingMipmaps = [];
              for(let i = 0; i < value; ++i){
                  const mipmap = renderTarget.clone();
                  mipmap.texture.name = "Downsampling.Mipmap" + i;
                  this.downsamplingMipmaps.push(mipmap);
              }
              this.upsamplingMipmaps.push(renderTarget);
              for(let i = 1, l = value - 1; i < l; ++i){
                  const mipmap = renderTarget.clone();
                  mipmap.texture.name = "Upsampling.Mipmap" + i;
                  this.upsamplingMipmaps.push(mipmap);
              }
              this.setSize(this.resolution.x, this.resolution.y);
          }
      }
      /**
     * The blur radius.
     *
     * @type {Number}
     */ get radius() {
          return this.upsamplingMaterial.radius;
      }
      set radius(value) {
          this.upsamplingMaterial.radius = value;
      }
      /**
     * Renders the blur.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const { scene, camera } = this;
          const { downsamplingMaterial, upsamplingMaterial } = this;
          const { downsamplingMipmaps, upsamplingMipmaps } = this;
          let previousBuffer = inputBuffer;
          this.fullscreenMaterial = downsamplingMaterial;
          for(let i = 0, l = downsamplingMipmaps.length; i < l; ++i){
              const mipmap = downsamplingMipmaps[i];
              downsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
              downsamplingMaterial.inputBuffer = previousBuffer.texture;
              renderer.setRenderTarget(mipmap);
              renderer.render(scene, camera);
              previousBuffer = mipmap;
          }
          this.fullscreenMaterial = upsamplingMaterial;
          for(let i = upsamplingMipmaps.length - 1; i >= 0; --i){
              const mipmap = upsamplingMipmaps[i];
              upsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
              upsamplingMaterial.inputBuffer = previousBuffer.texture;
              upsamplingMaterial.supportBuffer = downsamplingMipmaps[i].texture;
              renderer.setRenderTarget(mipmap);
              renderer.render(scene, camera);
              previousBuffer = mipmap;
          }
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.set(width, height);
          let w = resolution.width, h = resolution.height;
          for(let i = 0, l = this.downsamplingMipmaps.length; i < l; ++i){
              w = Math.round(w * 0.5);
              h = Math.round(h * 0.5);
              this.downsamplingMipmaps[i].setSize(w, h);
              if (i < this.upsamplingMipmaps.length) {
                  this.upsamplingMipmaps[i].setSize(w, h);
              }
          }
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          if (frameBufferType !== void 0) {
              const mipmaps = this.downsamplingMipmaps.concat(this.upsamplingMipmaps);
              for (const mipmap of mipmaps){
                  mipmap.texture.type = frameBufferType;
              }
              if (frameBufferType !== three.UnsignedByteType) {
                  this.downsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                  this.upsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
              } else if (renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
                  for (const mipmap of mipmaps){
                      mipmap.texture.colorSpace = three.SRGBColorSpace;
                  }
              }
          }
      }
      /**
     * Deletes internal render targets and textures.
     */ dispose() {
          super.dispose();
          for (const mipmap of this.downsamplingMipmaps.concat(this.upsamplingMipmaps)){
              mipmap.dispose();
          }
      }
      /**
     * Constructs a new mipmap blur pass.
     *
     * @param {Object} [options] - The options.
     */ constructor(){
          super("MipmapBlurPass");
          this.needsSwap = false;
          this.renderTarget = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTarget.texture.name = "Upsampling.Mipmap0";
          this.downsamplingMipmaps = [];
          this.upsamplingMipmaps = [];
          this.downsamplingMaterial = new DownsamplingMaterial();
          this.upsamplingMaterial = new UpsamplingMaterial();
          this.resolution = new three.Vector2();
      }
  };
  // src/effects/glsl/bloom.frag
  var bloom_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 texel=texture2D(map,uv);outputColor=vec4(texel.rgb*intensity,texel.a);}`;
  // src/effects/BloomEffect.js
  var BloomEffect = class extends Effect {
      /**
     * A texture that contains the intermediate result of this effect.
     *
     * @type {Texture}
     */ get texture() {
          return this.mipmapBlurPass.enabled ? this.mipmapBlurPass.texture : this.renderTarget.texture;
      }
      /**
     * Returns the generated bloom texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.texture;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Returns the blur pass.
     *
     * @deprecated
     * @return {KawaseBlurPass} The blur pass.
     */ getBlurPass() {
          return this.blurPass;
      }
      /**
     * Returns the luminance pass.
     *
     * @deprecated Use luminancePass instead.
     * @return {LuminancePass} The luminance pass.
     */ getLuminancePass() {
          return this.luminancePass;
      }
      /**
     * The luminance material.
     *
     * @type {LuminanceMaterial}
     */ get luminanceMaterial() {
          return this.luminancePass.fullscreenMaterial;
      }
      /**
     * Returns the luminance material.
     *
     * @deprecated Use luminanceMaterial instead.
     * @return {LuminanceMaterial} The material.
     */ getLuminanceMaterial() {
          return this.luminancePass.fullscreenMaterial;
      }
      /**
     * The current width of the internal render targets.
     *
     * @type {Number}
     * @deprecated
     */ get width() {
          return this.resolution.width;
      }
      set width(value) {
          this.resolution.preferredWidth = value;
      }
      /**
     * The current height of the internal render targets.
     *
     * @type {Number}
     * @deprecated
     */ get height() {
          return this.resolution.height;
      }
      set height(value) {
          this.resolution.preferredHeight = value;
      }
      /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     * @deprecated Use EffectPass.dithering instead.
     */ get dithering() {
          return this.blurPass.dithering;
      }
      set dithering(value) {
          this.blurPass.dithering = value;
      }
      /**
     * The blur kernel size.
     *
     * @type {KernelSize}
     * @deprecated
     */ get kernelSize() {
          return this.blurPass.kernelSize;
      }
      set kernelSize(value) {
          this.blurPass.kernelSize = value;
      }
      /**
     * @type {Number}
     * @deprecated
     */ get distinction() {
          console.warn(this.name, "distinction was removed");
          return 1;
      }
      set distinction(value) {
          console.warn(this.name, "distinction was removed");
      }
      /**
     * The bloom intensity.
     *
     * @type {Number}
     */ get intensity() {
          return this.uniforms.get("intensity").value;
      }
      set intensity(value) {
          this.uniforms.get("intensity").value = value;
      }
      /**
     * The bloom intensity.
     *
     * @deprecated Use intensity instead.
     * @return {Number} The intensity.
     */ getIntensity() {
          return this.intensity;
      }
      /**
     * Sets the bloom intensity.
     *
     * @deprecated Use intensity instead.
     * @param {Number} value - The intensity.
     */ setIntensity(value) {
          this.intensity = value;
      }
      /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated
     */ getResolutionScale() {
          return this.resolution.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated
     */ setResolutionScale(scale) {
          this.resolution.scale = scale;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          const renderTarget = this.renderTarget;
          const luminancePass = this.luminancePass;
          if (luminancePass.enabled) {
              luminancePass.render(renderer, inputBuffer);
              if (this.mipmapBlurPass.enabled) {
                  this.mipmapBlurPass.render(renderer, luminancePass.renderTarget);
              } else {
                  this.blurPass.render(renderer, luminancePass.renderTarget, renderTarget);
              }
          } else {
              if (this.mipmapBlurPass.enabled) {
                  this.mipmapBlurPass.render(renderer, inputBuffer);
              } else {
                  this.blurPass.render(renderer, inputBuffer, renderTarget);
              }
          }
      }
      /**
     * Updates the size of internal render targets.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          this.renderTarget.setSize(resolution.width, resolution.height);
          this.blurPass.resolution.copy(resolution);
          this.luminancePass.setSize(width, height);
          this.mipmapBlurPass.setSize(width, height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          this.blurPass.initialize(renderer, alpha, frameBufferType);
          this.luminancePass.initialize(renderer, alpha, frameBufferType);
          this.mipmapBlurPass.initialize(renderer, alpha, frameBufferType);
          if (frameBufferType !== void 0) {
              this.renderTarget.texture.type = frameBufferType;
              if (renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
                  this.renderTarget.texture.colorSpace = three.SRGBColorSpace;
              }
          }
      }
      /**
     * Constructs a new bloom effect.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
     * @param {Number} [options.luminanceThreshold=0.9] - The luminance threshold. Raise this value to mask out darker elements in the scene.
     * @param {Number} [options.luminanceSmoothing=0.025] - Controls the smoothness of the luminance threshold.
     * @param {Boolean} [options.mipmapBlur=false] - Enables or disables mipmap blur.
     * @param {Number} [options.intensity=1.0] - The bloom intensity.
     * @param {Number} [options.radius=0.85] - The blur radius. Only applies to mipmap blur.
     * @param {Number} [options.levels=8] - The amount of MIP levels. Only applies to mipmap blur.
     * @param {KernelSize} [options.kernelSize=KernelSize.LARGE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionScale=0.5] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
     */ constructor({ blendFunction = BlendFunction.SCREEN, luminanceThreshold = 0.9, luminanceSmoothing = 0.025, mipmapBlur = false, intensity = 1, radius = 0.85, levels = 8, kernelSize = KernelSize.LARGE, resolutionScale = 0.5, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("BloomEffect", bloom_default, {
              blendFunction,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "map",
                      new three.Uniform(null)
                  ],
                  [
                      "intensity",
                      new three.Uniform(intensity)
                  ]
              ])
          });
          this.renderTarget = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTarget.texture.name = "Bloom.Target";
          this.blurPass = new KawaseBlurPass({
              kernelSize
          });
          this.luminancePass = new LuminancePass({
              colorOutput: true
          });
          this.luminanceMaterial.threshold = luminanceThreshold;
          this.luminanceMaterial.smoothing = luminanceSmoothing;
          this.mipmapBlurPass = new MipmapBlurPass();
          this.mipmapBlurPass.enabled = mipmapBlur;
          this.mipmapBlurPass.radius = radius;
          this.mipmapBlurPass.levels = levels;
          this.uniforms.get("map").value = mipmapBlur ? this.mipmapBlurPass.texture : this.renderTarget.texture;
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
      }
  };
  // src/effects/glsl/brightness-contrast.frag
  var brightness_contrast_default = `uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(color+vec3(0.5),inputColor.a);}`;
  // src/effects/BrightnessContrastEffect.js
  var BrightnessContrastEffect = class extends Effect {
      /**
     * The brightness.
     *
     * @type {Number}
     */ get brightness() {
          return this.uniforms.get("brightness").value;
      }
      set brightness(value) {
          this.uniforms.get("brightness").value = value;
      }
      /**
     * Returns the brightness.
     *
     * @deprecated Use brightness instead.
     * @return {Number} The brightness.
     */ getBrightness() {
          return this.brightness;
      }
      /**
     * Sets the brightness.
     *
     * @deprecated Use brightness instead.
     * @param {Number} value - The brightness.
     */ setBrightness(value) {
          this.brightness = value;
      }
      /**
     * The contrast.
     *
     * @type {Number}
     */ get contrast() {
          return this.uniforms.get("contrast").value;
      }
      set contrast(value) {
          this.uniforms.get("contrast").value = value;
      }
      /**
     * Returns the contrast.
     *
     * @deprecated Use contrast instead.
     * @return {Number} The contrast.
     */ getContrast() {
          return this.contrast;
      }
      /**
     * Sets the contrast.
     *
     * @deprecated Use contrast instead.
     * @param {Number} value - The contrast.
     */ setContrast(value) {
          this.contrast = value;
      }
      /**
     * Constructs a new brightness/contrast effect.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
     * @param {Number} [options.brightness=0.0] - The brightness factor, ranging from -1 to 1, where 0 means no change.
     * @param {Number} [options.contrast=0.0] - The contrast factor, ranging from -1 to 1, where 0 means no change.
     */ constructor({ blendFunction = BlendFunction.SRC, brightness = 0, contrast = 0 } = {}){
          super("BrightnessContrastEffect", brightness_contrast_default, {
              blendFunction,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "brightness",
                      new three.Uniform(brightness)
                  ],
                  [
                      "contrast",
                      new three.Uniform(contrast)
                  ]
              ])
          });
          this.inputColorSpace = three.SRGBColorSpace;
      }
  };
  // src/effects/glsl/chromatic-aberration.frag
  var chromatic_aberration_default = `#ifdef RADIAL_MODULATION
uniform float modulationOffset;
#endif
varying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=inputColor.ra;vec2 ba=inputColor.ba;
#ifdef RADIAL_MODULATION
const vec2 center=vec2(0.5);float d=distance(uv,center)*2.0;d=max(d-modulationOffset,0.0);if(vActive>0.0&&d>0.0){ra=texture2D(inputBuffer,mix(uv,vUvR,d)).ra;ba=texture2D(inputBuffer,mix(uv,vUvB,d)).ba;}
#else
if(vActive>0.0){ra=texture2D(inputBuffer,vUvR).ra;ba=texture2D(inputBuffer,vUvB).ba;}
#endif
outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}`;
  // src/effects/glsl/chromatic-aberration.vert
  var chromatic_aberration_default2 = `uniform vec2 offset;varying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vActive=(shift.x!=0.0||shift.y!=0.0)?1.0:0.0;vUvR=uv+shift;vUvB=uv-shift;}`;
  // src/effects/ChromaticAberrationEffect.js
  var ChromaticAberrationEffect = class extends Effect {
      /**
     * The color offset.
     *
     * @type {Vector2}
     */ get offset() {
          return this.uniforms.get("offset").value;
      }
      set offset(value) {
          this.uniforms.get("offset").value = value;
      }
      /**
     * Indicates whether radial modulation is enabled.
     *
     * When enabled, the effect will be weaker in the middle and stronger towards the screen edges.
     *
     * @type {Boolean}
     */ get radialModulation() {
          return this.defines.has("RADIAL_MODULATION");
      }
      set radialModulation(value) {
          if (value) {
              this.defines.set("RADIAL_MODULATION", "1");
          } else {
              this.defines.delete("RADIAL_MODULATION");
          }
          this.setChanged();
      }
      /**
     * The modulation offset.
     *
     * @type {Number}
     */ get modulationOffset() {
          return this.uniforms.get("modulationOffset").value;
      }
      set modulationOffset(value) {
          this.uniforms.get("modulationOffset").value = value;
      }
      /**
     * Returns the color offset vector.
     *
     * @deprecated Use offset instead.
     * @return {Vector2} The offset.
     */ getOffset() {
          return this.offset;
      }
      /**
     * Sets the color offset vector.
     *
     * @deprecated Use offset instead.
     * @param {Vector2} value - The offset.
     */ setOffset(value) {
          this.offset = value;
      }
      /**
     * Constructs a new chromatic aberration effect.
     *
     * @param {Object} [options] - The options.
     * @param {Vector2} [options.offset] - The color offset.
     * @param {Boolean} [options.radialModulation=false] - Whether the effect should be modulated with a radial gradient.
     * @param {Number} [options.modulationOffset=0.15] - The modulation offset. Only applies if `radialModulation` is enabled.
     */ constructor({ offset = new three.Vector2(1e-3, 5e-4), radialModulation = false, modulationOffset = 0.15 } = {}){
          super("ChromaticAberrationEffect", chromatic_aberration_default, {
              vertexShader: chromatic_aberration_default2,
              attributes: EffectAttribute.CONVOLUTION,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "offset",
                      new three.Uniform(offset)
                  ],
                  [
                      "modulationOffset",
                      new three.Uniform(modulationOffset)
                  ]
              ])
          });
          this.radialModulation = radialModulation;
      }
  };
  // src/utils/orthographicDepthToViewZ.js
  function orthographicDepthToViewZ(depth, near, far) {
      return depth * (near - far) - near;
  }
  // src/utils/viewZToOrthographicDepth.js
  function viewZToOrthographicDepth(viewZ, near, far) {
      return Math.min(Math.max((viewZ + near) / (near - far), 0), 1);
  }
  var ShaderPass = class extends Pass {
      /**
     * Sets the name of the input buffer uniform.
     *
     * @param {String} input - The name of the input buffer uniform.
     * @deprecated Use input instead.
     */ setInput(input) {
          this.input = input;
      }
      /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const uniforms = this.fullscreenMaterial.uniforms;
          if (inputBuffer !== null && uniforms !== void 0 && uniforms[this.input] !== void 0) {
              uniforms[this.input].value = inputBuffer.texture;
          }
          renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
          renderer.render(this.scene, this.camera);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - A renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          if (frameBufferType !== void 0 && frameBufferType !== three.UnsignedByteType) {
              this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
          }
      }
      /**
     * Constructs a new shader pass.
     *
     * @param {ShaderMaterial} material - A shader material.
     * @param {String} [input="inputBuffer"] - The name of the input buffer uniform.
     */ constructor(material, input = "inputBuffer"){
          super("ShaderPass");
          this.fullscreenMaterial = material;
          this.input = input;
      }
  };
  // src/enums/GlitchMode.js
  var GlitchMode = {
      DISABLED: 0,
      SPORADIC: 1,
      CONSTANT_MILD: 2,
      CONSTANT_WILD: 3
  };
  function getNoise(size, format, type) {
      const channels = /* @__PURE__ */ new Map([
          [
              three.LuminanceFormat,
              1
          ],
          [
              three.RedFormat,
              1
          ],
          [
              three.RGFormat,
              2
          ],
          [
              three.RGBAFormat,
              4
          ]
      ]);
      let data;
      if (!channels.has(format)) {
          console.error("Invalid noise texture format");
      }
      if (type === three.UnsignedByteType) {
          data = new Uint8Array(size * channels.get(format));
          for(let i = 0, l = data.length; i < l; ++i){
              data[i] = Math.random() * 255 + 0.5;
          }
      } else {
          data = new Float32Array(size * channels.get(format));
          for(let i = 0, l = data.length; i < l; ++i){
              data[i] = Math.random();
          }
      }
      return data;
  }
  var NoiseTexture = class extends three.DataTexture {
      /**
     * Constructs a new noise texture.
     *
     * The texture format can be either `LuminanceFormat` or `RGBAFormat`. Additionally, the formats `RedFormat` and
     * `RGFormat` can be used in a WebGL 2 context.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     * @param {Number} [format=LuminanceFormat] - The texture format.
     * @param {Number} [type=UnsignedByteType] - The texture type.
     */ constructor(width, height, format = three.LuminanceFormat, type = three.UnsignedByteType){
          super(getNoise(width * height, format, type), width, height, format, type);
          this.needsUpdate = true;
      }
  };
  // src/effects/glsl/glitch.frag
  var glitch_default = `uniform lowp sampler2D perturbationMap;uniform bool active;uniform float columns;uniform float random;uniform vec2 seeds;uniform vec2 distortion;void mainUv(inout vec2 uv){if(active){if(uv.y<distortion.x+columns&&uv.y>distortion.x-columns*random){float sx=clamp(ceil(seeds.x),0.0,1.0);uv.y=sx*(1.0-(uv.y+distortion.y))+(1.0-sx)*distortion.y;}if(uv.x<distortion.y+columns&&uv.x>distortion.y-columns*random){float sy=clamp(ceil(seeds.y),0.0,1.0);uv.x=sy*distortion.x+(1.0-sy)*(1.0-(uv.x+distortion.x));}vec2 normal=texture2D(perturbationMap,uv*random*random).rg;uv+=normal*seeds*(random*0.2);}}`;
  // src/effects/GlitchEffect.js
  var textureTag = "Glitch.Generated";
  function randomFloat(low, high) {
      return low + Math.random() * (high - low);
  }
  var GlitchEffect = class extends Effect {
      /**
     * Random number seeds.
     *
     * @type {Vector2}
     * @private
     */ get seeds() {
          return this.uniforms.get("seeds").value;
      }
      /**
     * Indicates whether the glitch effect is currently active.
     *
     * @type {Boolean}
     */ get active() {
          return this.uniforms.get("active").value;
      }
      /**
     * Indicates whether the glitch effect is currently active.
     *
     * @deprecated Use active instead.
     * @return {Boolean} Whether the glitch effect is active.
     */ isActive() {
          return this.active;
      }
      /**
     * The minimum delay between glitch activations.
     *
     * @type {Number}
     */ get minDelay() {
          return this.delay.x;
      }
      set minDelay(value) {
          this.delay.x = value;
      }
      /**
     * Returns the minimum delay between glitch activations.
     *
     * @deprecated Use minDelay instead.
     * @return {Number} The minimum delay in seconds.
     */ getMinDelay() {
          return this.delay.x;
      }
      /**
     * Sets the minimum delay between glitch activations.
     *
     * @deprecated Use minDelay instead.
     * @param {Number} value - The minimum delay in seconds.
     */ setMinDelay(value) {
          this.delay.x = value;
      }
      /**
     * The maximum delay between glitch activations.
     *
     * @type {Number}
     */ get maxDelay() {
          return this.delay.y;
      }
      set maxDelay(value) {
          this.delay.y = value;
      }
      /**
     * Returns the maximum delay between glitch activations.
     *
     * @deprecated Use maxDelay instead.
     * @return {Number} The maximum delay in seconds.
     */ getMaxDelay() {
          return this.delay.y;
      }
      /**
     * Sets the maximum delay between glitch activations.
     *
     * @deprecated Use maxDelay instead.
     * @param {Number} value - The maximum delay in seconds.
     */ setMaxDelay(value) {
          this.delay.y = value;
      }
      /**
     * The minimum duration of sporadic glitches.
     *
     * @type {Number}
     */ get minDuration() {
          return this.duration.x;
      }
      set minDuration(value) {
          this.duration.x = value;
      }
      /**
     * Returns the minimum duration of sporadic glitches.
     *
     * @deprecated Use minDuration instead.
     * @return {Number} The minimum duration in seconds.
     */ getMinDuration() {
          return this.duration.x;
      }
      /**
     * Sets the minimum duration of sporadic glitches.
     *
     * @deprecated Use minDuration instead.
     * @param {Number} value - The minimum duration in seconds.
     */ setMinDuration(value) {
          this.duration.x = value;
      }
      /**
     * The maximum duration of sporadic glitches.
     *
     * @type {Number}
     */ get maxDuration() {
          return this.duration.y;
      }
      set maxDuration(value) {
          this.duration.y = value;
      }
      /**
     * Returns the maximum duration of sporadic glitches.
     *
     * @deprecated Use maxDuration instead.
     * @return {Number} The maximum duration in seconds.
     */ getMaxDuration() {
          return this.duration.y;
      }
      /**
     * Sets the maximum duration of sporadic glitches.
     *
     * @deprecated Use maxDuration instead.
     * @param {Number} value - The maximum duration in seconds.
     */ setMaxDuration(value) {
          this.duration.y = value;
      }
      /**
     * The strength of weak glitches.
     *
     * @type {Number}
     */ get minStrength() {
          return this.strength.x;
      }
      set minStrength(value) {
          this.strength.x = value;
      }
      /**
     * Returns the strength of weak glitches.
     *
     * @deprecated Use minStrength instead.
     * @return {Number} The strength.
     */ getMinStrength() {
          return this.strength.x;
      }
      /**
     * Sets the strength of weak glitches.
     *
     * @deprecated Use minStrength instead.
     * @param {Number} value - The strength.
     */ setMinStrength(value) {
          this.strength.x = value;
      }
      /**
     * The strength of strong glitches.
     *
     * @type {Number}
     */ get maxStrength() {
          return this.strength.y;
      }
      set maxStrength(value) {
          this.strength.y = value;
      }
      /**
     * Returns the strength of strong glitches.
     *
     * @deprecated Use maxStrength instead.
     * @return {Number} The strength.
     */ getMaxStrength() {
          return this.strength.y;
      }
      /**
     * Sets the strength of strong glitches.
     *
     * @deprecated Use maxStrength instead.
     * @param {Number} value - The strength.
     */ setMaxStrength(value) {
          this.strength.y = value;
      }
      /**
     * Returns the current glitch mode.
     *
     * @deprecated Use mode instead.
     * @return {GlitchMode} The mode.
     */ getMode() {
          return this.mode;
      }
      /**
     * Sets the current glitch mode.
     *
     * @deprecated Use mode instead.
     * @param {GlitchMode} value - The mode.
     */ setMode(value) {
          this.mode = value;
      }
      /**
     * Returns the glitch ratio.
     *
     * @deprecated Use ratio instead.
     * @return {Number} The ratio.
     */ getGlitchRatio() {
          return 1 - this.ratio;
      }
      /**
     * Sets the ratio of weak (0.0) and strong (1.0) glitches.
     *
     * @deprecated Use ratio instead.
     * @param {Number} value - The ratio. Range is [0.0, 1.0].
     */ setGlitchRatio(value) {
          this.ratio = Math.min(Math.max(1 - value, 0), 1);
      }
      /**
     * The glitch column size.
     *
     * @type {Number}
     */ get columns() {
          return this.uniforms.get("columns").value;
      }
      set columns(value) {
          this.uniforms.get("columns").value = value;
      }
      /**
     * Returns the glitch column size.
     *
     * @deprecated Use columns instead.
     * @return {Number} The glitch column size.
     */ getGlitchColumns() {
          return this.columns;
      }
      /**
     * Sets the glitch column size.
     *
     * @deprecated Use columns instead.
     * @param {Number} value - The glitch column size.
     */ setGlitchColumns(value) {
          this.columns = value;
      }
      /**
     * Returns the chromatic aberration offset.
     *
     * @deprecated Use chromaticAberrationOffset instead.
     * @return {Vector2} The offset.
     */ getChromaticAberrationOffset() {
          return this.chromaticAberrationOffset;
      }
      /**
     * Sets the chromatic aberration offset.
     *
     * @deprecated Use chromaticAberrationOffset instead.
     * @param {Vector2} value - The offset.
     */ setChromaticAberrationOffset(value) {
          this.chromaticAberrationOffset = value;
      }
      /**
     * The perturbation map.
     *
     * @type {Texture}
     */ get perturbationMap() {
          return this.uniforms.get("perturbationMap").value;
      }
      set perturbationMap(value) {
          const currentMap = this.perturbationMap;
          if (currentMap !== null && currentMap.name === textureTag) {
              currentMap.dispose();
          }
          value.minFilter = value.magFilter = three.NearestFilter;
          value.wrapS = value.wrapT = three.RepeatWrapping;
          value.generateMipmaps = false;
          this.uniforms.get("perturbationMap").value = value;
      }
      /**
     * Returns the current perturbation map.
     *
     * @deprecated Use perturbationMap instead.
     * @return {Texture} The current perturbation map.
     */ getPerturbationMap() {
          return this.perturbationMap;
      }
      /**
     * Replaces the current perturbation map with the given one.
     *
     * The current map will be disposed if it was generated by this effect.
     *
     * @deprecated Use perturbationMap instead.
     * @param {Texture} value - The new perturbation map.
     */ setPerturbationMap(value) {
          this.perturbationMap = value;
      }
      /**
     * Generates a perturbation map.
     *
     * @deprecated Use NoiseTexture instead.
     * @param {Number} [value=64] - The texture size.
     * @return {DataTexture} The perturbation map.
     */ generatePerturbationMap(value = 64) {
          const map = new NoiseTexture(value, value, three.RGBAFormat);
          map.name = textureTag;
          return map;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          const mode = this.mode;
          const breakPoint = this.breakPoint;
          const offset = this.chromaticAberrationOffset;
          const s = this.strength;
          let time = this.time;
          let active = false;
          let r = 0, a = 0;
          let trigger;
          if (mode !== GlitchMode.DISABLED) {
              if (mode === GlitchMode.SPORADIC) {
                  time += deltaTime;
                  trigger = time > breakPoint.x;
                  if (time >= breakPoint.x + breakPoint.y) {
                      breakPoint.set(randomFloat(this.delay.x, this.delay.y), randomFloat(this.duration.x, this.duration.y));
                      time = 0;
                  }
              }
              r = Math.random();
              this.uniforms.get("random").value = r;
              if (trigger && r > this.ratio || mode === GlitchMode.CONSTANT_WILD) {
                  active = true;
                  r *= s.y * 0.03;
                  a = randomFloat(-Math.PI, Math.PI);
                  this.seeds.set(randomFloat(-s.y, s.y), randomFloat(-s.y, s.y));
                  this.distortion.set(randomFloat(0, 1), randomFloat(0, 1));
              } else if (trigger || mode === GlitchMode.CONSTANT_MILD) {
                  active = true;
                  r *= s.x * 0.03;
                  a = randomFloat(-Math.PI, Math.PI);
                  this.seeds.set(randomFloat(-s.x, s.x), randomFloat(-s.x, s.x));
                  this.distortion.set(randomFloat(0, 1), randomFloat(0, 1));
              }
              this.time = time;
          }
          if (offset !== null) {
              if (active) {
                  offset.set(Math.cos(a), Math.sin(a)).multiplyScalar(r);
              } else {
                  offset.set(0, 0);
              }
          }
          this.uniforms.get("active").value = active;
      }
      /**
     * Deletes generated resources.
     */ dispose() {
          const map = this.perturbationMap;
          if (map !== null && map.name === textureTag) {
              map.dispose();
          }
      }
      /**
     * Constructs a new glitch effect.
     *
     * TODO Change ratio to 0.15.
     * @param {Object} [options] - The options.
     * @param {Vector2} [options.chromaticAberrationOffset] - A chromatic aberration offset. If provided, the glitch effect will influence this offset.
     * @param {Vector2} [options.delay] - The minimum and maximum delay between glitch activations in seconds.
     * @param {Vector2} [options.duration] - The minimum and maximum duration of a glitch in seconds.
     * @param {Vector2} [options.strength] - The strength of weak and strong glitches.
     * @param {Texture} [options.perturbationMap] - A perturbation map. If none is provided, a noise texture will be created.
     * @param {Number} [options.dtSize=64] - The size of the generated noise map. Will be ignored if a perturbation map is provided.
     * @param {Number} [options.columns=0.05] - The scale of the blocky glitch columns.
     * @param {Number} [options.ratio=0.85] - The threshold for strong glitches.
     */ constructor({ chromaticAberrationOffset = null, delay = new three.Vector2(1.5, 3.5), duration = new three.Vector2(0.6, 1), strength = new three.Vector2(0.3, 1), columns = 0.05, ratio = 0.85, perturbationMap = null, dtSize = 64 } = {}){
          super("GlitchEffect", glitch_default, {
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "perturbationMap",
                      new three.Uniform(null)
                  ],
                  [
                      "columns",
                      new three.Uniform(columns)
                  ],
                  [
                      "active",
                      new three.Uniform(false)
                  ],
                  [
                      "random",
                      new three.Uniform(1)
                  ],
                  [
                      "seeds",
                      new three.Uniform(new three.Vector2())
                  ],
                  [
                      "distortion",
                      new three.Uniform(new three.Vector2())
                  ]
              ])
          });
          if (perturbationMap === null) {
              const map = new NoiseTexture(dtSize, dtSize, three.RGBAFormat);
              map.name = textureTag;
              this.perturbationMap = map;
          } else {
              this.perturbationMap = perturbationMap;
          }
          this.time = 0;
          this.distortion = this.uniforms.get("distortion").value;
          this.delay = delay;
          this.duration = duration;
          this.breakPoint = new three.Vector2(randomFloat(this.delay.x, this.delay.y), randomFloat(this.duration.x, this.duration.y));
          this.strength = strength;
          this.mode = GlitchMode.SPORADIC;
          this.ratio = ratio;
          this.chromaticAberrationOffset = chromaticAberrationOffset;
      }
  };
  // src/enums/DepthTestStrategy.js
  var DepthTestStrategy = {
      KEEP_MAX_DEPTH: 1,
      DISCARD_MAX_DEPTH: 2
  };
  // src/materials/glsl/depth-mask.frag
  var depth_mask_default = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer0;uniform highp sampler2D depthBuffer1;
#else
uniform mediump sampler2D depthBuffer0;uniform mediump sampler2D depthBuffer1;
#endif
uniform sampler2D inputBuffer;uniform vec2 cameraNearFar;float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#else
return orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#endif
}varying vec2 vUv;void main(){vec2 depth;
#if DEPTH_PACKING_0 == 3201
depth.x=unpackRGBAToDepth(texture2D(depthBuffer0,vUv));
#else
depth.x=texture2D(depthBuffer0,vUv).r;
#ifdef LOG_DEPTH
float d=pow(2.0,depth.x*log2(cameraNearFar.y+1.0))-1.0;float a=cameraNearFar.y/(cameraNearFar.y-cameraNearFar.x);float b=cameraNearFar.y*cameraNearFar.x/(cameraNearFar.x-cameraNearFar.y);depth.x=a+b/d;
#endif
#endif
#if DEPTH_PACKING_1 == 3201
depth.y=unpackRGBAToDepth(texture2D(depthBuffer1,vUv));
#else
depth.y=texture2D(depthBuffer1,vUv).r;
#ifdef LOG_DEPTH
float d=pow(2.0,depth.y*log2(cameraNearFar.y+1.0))-1.0;float a=cameraNearFar.y/(cameraNearFar.y-cameraNearFar.x);float b=cameraNearFar.y*cameraNearFar.x/(cameraNearFar.x-cameraNearFar.y);depth.y=a+b/d;
#endif
#endif
bool isMaxDepth=(depth.x==1.0);
#ifdef PERSPECTIVE_CAMERA
depth.x=viewZToOrthographicDepth(getViewZ(depth.x),cameraNearFar.x,cameraNearFar.y);depth.y=viewZToOrthographicDepth(getViewZ(depth.y),cameraNearFar.x,cameraNearFar.y);
#endif
#if DEPTH_TEST_STRATEGY == 0
bool keep=depthTest(depth.x,depth.y);
#elif DEPTH_TEST_STRATEGY == 1
bool keep=isMaxDepth||depthTest(depth.x,depth.y);
#else
bool keep=!isMaxDepth&&depthTest(depth.x,depth.y);
#endif
if(keep){gl_FragColor=texture2D(inputBuffer,vUv);}else{discard;}}`;
  // src/materials/DepthMaskMaterial.js
  var DepthMaskMaterial = class extends three.ShaderMaterial {
      /**
     * The primary depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer0(value) {
          this.uniforms.depthBuffer0.value = value;
      }
      /**
     * The primary depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking0(value) {
          this.defines.DEPTH_PACKING_0 = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the base depth buffer.
     *
     * @deprecated Use depthBuffer0 and depthPacking0 instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer0(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer0 = buffer;
          this.depthPacking0 = depthPacking;
      }
      /**
     * The secondary depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer1(value) {
          this.uniforms.depthBuffer1.value = value;
      }
      /**
     * The secondary depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking1(value) {
          this.defines.DEPTH_PACKING_1 = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer that will be compared with the base depth buffer.
     *
     * @deprecated Use depthBuffer1 and depthPacking1 instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer1(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer1 = buffer;
          this.depthPacking1 = depthPacking;
      }
      /**
     * The strategy for handling maximum depth.
     *
     * @type {DepthTestStrategy}
     */ get maxDepthStrategy() {
          return Number(this.defines.DEPTH_TEST_STRATEGY);
      }
      set maxDepthStrategy(value) {
          this.defines.DEPTH_TEST_STRATEGY = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Indicates whether maximum depth values should be preserved.
     *
     * @type {Boolean}
     * @deprecated Use maxDepthStrategy instead.
     */ get keepFar() {
          return this.maxDepthStrategy;
      }
      set keepFar(value) {
          this.maxDepthStrategy = value ? DepthTestStrategy.KEEP_MAX_DEPTH : DepthTestStrategy.DISCARD_MAX_DEPTH;
      }
      /**
     * Returns the strategy for dealing with maximum depth values.
     *
     * @deprecated Use maxDepthStrategy instead.
     * @return {DepthTestStrategy} The strategy.
     */ getMaxDepthStrategy() {
          return this.maxDepthStrategy;
      }
      /**
     * Sets the strategy for dealing with maximum depth values.
     *
     * @deprecated Use maxDepthStrategy instead.
     * @param {DepthTestStrategy} value - The strategy.
     */ setMaxDepthStrategy(value) {
          this.maxDepthStrategy = value;
      }
      /**
     * A small error threshold that is used for `EqualDepth` and `NotEqualDepth` tests. Default is `1e-4`.
     *
     * @type {Number}
     */ get epsilon() {
          return Number(this.defines.DEPTH_EPSILON);
      }
      set epsilon(value) {
          this.defines.DEPTH_EPSILON = value.toFixed(16);
          this.needsUpdate = true;
      }
      /**
     * Returns the current error threshold for depth comparisons.
     *
     * @deprecated Use epsilon instead.
     * @return {Number} The error threshold.
     */ getEpsilon() {
          return this.epsilon;
      }
      /**
     * Sets the depth comparison error threshold.
     *
     * @deprecated Use epsilon instead.
     * @param {Number} value - The new error threshold.
     */ setEpsilon(value) {
          this.epsilon = value;
      }
      /**
     * The depth mode.
     *
     * @see https://threejs.org/docs/#api/en/constants/Materials
     * @type {DepthModes}
     */ get depthMode() {
          return Number(this.defines.DEPTH_MODE);
      }
      set depthMode(value) {
          let depthTest;
          switch(value){
              case three.NeverDepth:
                  depthTest = "false";
                  break;
              case three.AlwaysDepth:
                  depthTest = "true";
                  break;
              case three.EqualDepth:
                  depthTest = "abs(d1 - d0) <= DEPTH_EPSILON";
                  break;
              case three.NotEqualDepth:
                  depthTest = "abs(d1 - d0) > DEPTH_EPSILON";
                  break;
              case three.LessDepth:
                  depthTest = "d0 > d1";
                  break;
              case three.LessEqualDepth:
                  depthTest = "d0 >= d1";
                  break;
              case three.GreaterEqualDepth:
                  depthTest = "d0 <= d1";
                  break;
              case three.GreaterDepth:
              default:
                  depthTest = "d0 < d1";
                  break;
          }
          this.defines.DEPTH_MODE = value.toFixed(0);
          this.defines["depthTest(d0, d1)"] = depthTest;
          this.needsUpdate = true;
      }
      /**
     * Returns the current depth mode.
     *
     * @deprecated Use depthMode instead.
     * @return {DepthModes} The depth mode. Default is `LessDepth`.
     */ getDepthMode() {
          return this.depthMode;
      }
      /**
     * Sets the depth mode.
     *
     * @deprecated Use depthMode instead.
     * @param {DepthModes} mode - The depth mode.
     */ setDepthMode(mode) {
          this.depthMode = mode;
      }
      /**
     * Copies the settings of the given camera.
     *
     * @deprecated Use copyCameraSettings instead.
     * @param {Camera} camera - A camera.
     */ adoptCameraSettings(camera) {
          this.copyCameraSettings(camera);
      }
      /**
     * Copies the settings of the given camera.
     *
     * @param {Camera} camera - A camera.
     */ copyCameraSettings(camera) {
          if (camera) {
              this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
              if (camera instanceof three.PerspectiveCamera) {
                  this.defines.PERSPECTIVE_CAMERA = "1";
              } else {
                  delete this.defines.PERSPECTIVE_CAMERA;
              }
              this.needsUpdate = true;
          }
      }
      /**
     * Constructs a new depth mask material.
     */ constructor(){
          super({
              name: "DepthMaskMaterial",
              defines: {
                  DEPTH_EPSILON: "0.0001",
                  DEPTH_PACKING_0: "0",
                  DEPTH_PACKING_1: "0",
                  DEPTH_TEST_STRATEGY: DepthTestStrategy.KEEP_MAX_DEPTH
              },
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  depthBuffer0: new three.Uniform(null),
                  depthBuffer1: new three.Uniform(null),
                  cameraNearFar: new three.Uniform(new three.Vector2(1, 1))
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: depth_mask_default,
              vertexShader: common_default
          });
          this.depthMode = three.LessDepth;
      }
  };
  // src/passes/RenderPass.js
  var RenderPass = class extends Pass {
      set mainScene(value) {
          this.scene = value;
      }
      set mainCamera(value) {
          this.camera = value;
      }
      get renderToScreen() {
          return super.renderToScreen;
      }
      set renderToScreen(value) {
          super.renderToScreen = value;
          this.clearPass.renderToScreen = value;
      }
      /**
     * The current override material.
     *
     * @type {Material}
     */ get overrideMaterial() {
          const manager = this.overrideMaterialManager;
          return manager !== null ? manager.material : null;
      }
      set overrideMaterial(value) {
          const manager = this.overrideMaterialManager;
          if (value !== null) {
              if (manager !== null) {
                  manager.setMaterial(value);
              } else {
                  this.overrideMaterialManager = new OverrideMaterialManager(value);
              }
          } else if (manager !== null) {
              manager.dispose();
              this.overrideMaterialManager = null;
          }
      }
      /**
     * Returns the current override material.
     *
     * @deprecated Use overrideMaterial instead.
     * @return {Material} The material.
     */ getOverrideMaterial() {
          return this.overrideMaterial;
      }
      /**
     * Sets the override material.
     *
     * @deprecated Use overrideMaterial instead.
     * @return {Material} value - The material.
     */ setOverrideMaterial(value) {
          this.overrideMaterial = value;
      }
      /**
     * Indicates whether the target buffer should be cleared before rendering.
     *
     * @type {Boolean}
     * @deprecated Use clearPass.enabled instead.
     */ get clear() {
          return this.clearPass.enabled;
      }
      set clear(value) {
          this.clearPass.enabled = value;
      }
      /**
     * Returns the selection. Default is `null` (no restriction).
     *
     * @deprecated Use selection instead.
     * @return {Selection} The selection.
     */ getSelection() {
          return this.selection;
      }
      /**
     * Sets the selection. Set to `null` to disable.
     *
     * @deprecated Use selection instead.
     * @param {Selection} value - The selection.
     */ setSelection(value) {
          this.selection = value;
      }
      /**
     * Indicates whether the scene background is disabled.
     *
     * @deprecated Use ignoreBackground instead.
     * @return {Boolean} Whether the scene background is disabled.
     */ isBackgroundDisabled() {
          return this.ignoreBackground;
      }
      /**
     * Enables or disables the scene background.
     *
     * @deprecated Use ignoreBackground instead.
     * @param {Boolean} value - Whether the scene background should be disabled.
     */ setBackgroundDisabled(value) {
          this.ignoreBackground = value;
      }
      /**
     * Indicates whether the shadow map auto update is disabled.
     *
     * @deprecated Use skipShadowMapUpdate instead.
     * @return {Boolean} Whether the shadow map update is disabled.
     */ isShadowMapDisabled() {
          return this.skipShadowMapUpdate;
      }
      /**
     * Enables or disables the shadow map auto update.
     *
     * @deprecated Use skipShadowMapUpdate instead.
     * @param {Boolean} value - Whether the shadow map auto update should be disabled.
     */ setShadowMapDisabled(value) {
          this.skipShadowMapUpdate = value;
      }
      /**
     * Returns the clear pass.
     *
     * @deprecated Use clearPass.enabled instead.
     * @return {ClearPass} The clear pass.
     */ getClearPass() {
          return this.clearPass;
      }
      /**
     * Renders the scene.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const scene = this.scene;
          const camera = this.camera;
          const selection = this.selection;
          const mask = camera.layers.mask;
          const background = scene.background;
          const shadowMapAutoUpdate = renderer.shadowMap.autoUpdate;
          const renderTarget = this.renderToScreen ? null : inputBuffer;
          if (selection !== null) {
              camera.layers.set(selection.getLayer());
          }
          if (this.skipShadowMapUpdate) {
              renderer.shadowMap.autoUpdate = false;
          }
          if (this.ignoreBackground || this.clearPass.overrideClearColor !== null) {
              scene.background = null;
          }
          if (this.clearPass.enabled) {
              this.clearPass.render(renderer, inputBuffer);
          }
          renderer.setRenderTarget(renderTarget);
          if (this.overrideMaterialManager !== null) {
              this.overrideMaterialManager.render(renderer, scene, camera);
          } else {
              renderer.render(scene, camera);
          }
          camera.layers.mask = mask;
          scene.background = background;
          renderer.shadowMap.autoUpdate = shadowMapAutoUpdate;
      }
      /**
     * Constructs a new render pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use to render the scene.
     * @param {Material} [overrideMaterial=null] - An override material.
     */ constructor(scene, camera, overrideMaterial = null){
          super("RenderPass", scene, camera);
          this.needsSwap = false;
          this.clearPass = new ClearPass();
          this.overrideMaterialManager = overrideMaterial === null ? null : new OverrideMaterialManager(overrideMaterial);
          this.ignoreBackground = false;
          this.skipShadowMapUpdate = false;
          this.selection = null;
      }
  };
  // src/effects/glsl/hue-saturation.frag
  var hue_saturation_default = `uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}`;
  // src/effects/HueSaturationEffect.js
  var HueSaturationEffect = class extends Effect {
      /**
     * The saturation.
     *
     * @type {Number}
     */ get saturation() {
          return this.uniforms.get("saturation").value;
      }
      set saturation(value) {
          this.uniforms.get("saturation").value = value;
      }
      /**
     * Returns the saturation.
     *
     * @deprecated Use saturation instead.
     * @return {Number} The saturation.
     */ getSaturation() {
          return this.saturation;
      }
      /**
     * Sets the saturation.
     *
     * @deprecated Use saturation instead.
     * @param {Number} value - The saturation.
     */ setSaturation(value) {
          this.saturation = value;
      }
      /**
     * The hue.
     *
     * @type {Number}
     */ get hue() {
          const hue = this.uniforms.get("hue").value;
          return Math.acos((hue.x * 3 - 1) / 2);
      }
      set hue(value) {
          const s = Math.sin(value), c2 = Math.cos(value);
          this.uniforms.get("hue").value.set((2 * c2 + 1) / 3, (-Math.sqrt(3) * s - c2 + 1) / 3, (Math.sqrt(3) * s - c2 + 1) / 3);
      }
      /**
     * Returns the hue.
     *
     * @deprecated Use hue instead.
     * @return {Number} The hue in radians.
     */ getHue() {
          return this.hue;
      }
      /**
     * Sets the hue.
     *
     * @deprecated Use hue instead.
     * @param {Number} value - The hue in radians.
     */ setHue(value) {
          this.hue = value;
      }
      /**
     * Constructs a new hue/saturation effect.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
     * @param {Number} [options.hue=0.0] - The hue in radians.
     * @param {Number} [options.saturation=0.0] - The saturation factor, ranging from -1 to 1, where 0 means no change.
     */ constructor({ blendFunction = BlendFunction.SRC, hue = 0, saturation = 0 } = {}){
          super("HueSaturationEffect", hue_saturation_default, {
              blendFunction,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "hue",
                      new three.Uniform(new three.Vector3())
                  ],
                  [
                      "saturation",
                      new three.Uniform(saturation)
                  ]
              ])
          });
          this.hue = hue;
      }
  };
  // src/enums/EdgeDetectionMode.js
  var EdgeDetectionMode = {
      COLOR: 2
  };
  // src/enums/PredicationMode.js
  var PredicationMode = {
      DISABLED: 0};
  // src/enums/SMAAPreset.js
  var SMAAPreset = {
      LOW: 0,
      MEDIUM: 1,
      HIGH: 2,
      ULTRA: 3
  };
  // src/enums/ToneMappingMode.js
  var ToneMappingMode = {
      LINEAR: 0,
      REINHARD: 1,
      REINHARD2: 2,
      REINHARD2_ADAPTIVE: 3,
      UNCHARTED2: 4,
      OPTIMIZED_CINEON: 5,
      CINEON: 5,
      ACES_FILMIC: 6,
      AGX: 7,
      NEUTRAL: 8
  };
  // src/materials/glsl/depth-comparison.frag
  var depth_comparison_default = `#include <packing>
#include <clipping_planes_pars_fragment>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float cameraNear;uniform float cameraFar;centroid varying float vViewZ;centroid varying vec4 vProjTexCoord;void main(){
#include <clipping_planes_fragment>
vec2 projTexCoord=(vProjTexCoord.xy/vProjTexCoord.w)*0.5+0.5;projTexCoord=clamp(projTexCoord,0.002,0.998);
#if DEPTH_PACKING == 3201
float fragCoordZ=unpackRGBAToDepth(texture2D(depthBuffer,projTexCoord));
#else
float fragCoordZ=texture2D(depthBuffer,projTexCoord).r;
#endif
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(fragCoordZ,cameraNear,cameraFar);
#else
float viewZ=orthographicDepthToViewZ(fragCoordZ,cameraNear,cameraFar);
#endif
float depthTest=(-vViewZ>-viewZ)?1.0:0.0;gl_FragColor.rg=vec2(0.0,depthTest);}`;
  // src/materials/glsl/depth-comparison.vert
  var depth_comparison_default2 = `#include <common>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
varying float vViewZ;varying vec4 vProjTexCoord;void main(){
#include <skinbase_vertex>
#include <begin_vertex>
#include <morphtarget_vertex>
#include <skinning_vertex>
#include <project_vertex>
vViewZ=mvPosition.z;vProjTexCoord=gl_Position;
#include <clipping_planes_vertex>
}`;
  // src/materials/DepthComparisonMaterial.js
  var DepthComparisonMaterial = class extends three.ShaderMaterial {
      /**
     * The depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer(value) {
          this.uniforms.depthBuffer.value = value;
      }
      /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking(value) {
          this.defines.DEPTH_PACKING = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=RGBADepthPacking] - The depth packing strategy.
     */ setDepthBuffer(buffer, depthPacking = three.RGBADepthPacking) {
          this.depthBuffer = buffer;
          this.depthPacking = depthPacking;
      }
      /**
     * Copies the settings of the given camera.
     *
     * @deprecated Use copyCameraSettings instead.
     * @param {Camera} camera - A camera.
     */ adoptCameraSettings(camera) {
          this.copyCameraSettings(camera);
      }
      /**
     * Copies the settings of the given camera.
     *
     * @param {Camera} camera - A camera.
     */ copyCameraSettings(camera) {
          if (camera) {
              this.uniforms.cameraNear.value = camera.near;
              this.uniforms.cameraFar.value = camera.far;
              if (camera instanceof three.PerspectiveCamera) {
                  this.defines.PERSPECTIVE_CAMERA = "1";
              } else {
                  delete this.defines.PERSPECTIVE_CAMERA;
              }
              this.needsUpdate = true;
          }
      }
      /**
     * Constructs a new depth comparison material.
     *
     * @param {Texture} [depthTexture=null] - A depth texture.
     * @param {PerspectiveCamera} [camera] - A camera.
     */ constructor(depthTexture = null, camera){
          super({
              name: "DepthComparisonMaterial",
              defines: {
                  DEPTH_PACKING: "0"
              },
              uniforms: {
                  depthBuffer: new three.Uniform(null),
                  cameraNear: new three.Uniform(0.3),
                  cameraFar: new three.Uniform(1e3)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: depth_comparison_default,
              vertexShader: depth_comparison_default2
          });
          this.depthBuffer = depthTexture;
          this.depthPacking = three.RGBADepthPacking;
          this.copyCameraSettings(camera);
      }
  };
  // src/materials/glsl/outline.frag
  var outline_default = `uniform lowp sampler2D inputBuffer;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 c0=texture2D(inputBuffer,vUv0).rg;vec2 c1=texture2D(inputBuffer,vUv1).rg;vec2 c2=texture2D(inputBuffer,vUv2).rg;vec2 c3=texture2D(inputBuffer,vUv3).rg;float d0=(c0.x-c1.x)*0.5;float d1=(c2.x-c3.x)*0.5;float d=length(vec2(d0,d1));float a0=min(c0.y,c1.y);float a1=min(c2.y,c3.y);float visibilityFactor=min(a0,a1);gl_FragColor.rg=(1.0-visibilityFactor>0.001)?vec2(d,0.0):vec2(0.0,d);}`;
  // src/materials/glsl/outline.vert
  var outline_default2 = `uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=vec2(uv.x+texelSize.x,uv.y);vUv1=vec2(uv.x-texelSize.x,uv.y);vUv2=vec2(uv.x,uv.y+texelSize.y);vUv3=vec2(uv.x,uv.y-texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/OutlineMaterial.js
  var OutlineMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */ setInputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */ setTexelSize(x, y) {
          this.uniforms.texelSize.value.set(x, y);
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.uniforms.texelSize.value.set(1 / width, 1 / height);
      }
      /**
     * Constructs a new outline material.
     *
     * TODO Remove texelSize param.
     * @param {Vector2} [texelSize] - The screen texel size.
     */ constructor(texelSize = new three.Vector2()){
          super({
              name: "OutlineMaterial",
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(new three.Vector2())
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: outline_default,
              vertexShader: outline_default2
          });
          this.uniforms.texelSize.value.set(texelSize.x, texelSize.y);
          this.uniforms.maskTexture = this.uniforms.inputBuffer;
      }
  };
  var DepthPass = class extends Pass {
      set mainScene(value) {
          this.renderPass.mainScene = value;
      }
      set mainCamera(value) {
          this.renderPass.mainCamera = value;
      }
      /**
     * The depth texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the depth texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution instead.
     */ getResolutionScale() {
          return this.resolution.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution instead.
     */ setResolutionScale(scale) {
          this.resolution.scale = scale;
      }
      /**
     * Renders the scene depth.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const renderTarget = this.renderToScreen ? null : this.renderTarget;
          this.renderPass.render(renderer, renderTarget);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          this.renderTarget.setSize(resolution.width, resolution.height);
      }
      /**
     * Constructs a new depth pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use to render the scene.
     * @param {Object} [options] - The options.
     * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor(scene, camera, { renderTarget, resolutionScale = 1, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("DepthPass");
          this.needsSwap = false;
          this.renderPass = new RenderPass(scene, camera, new three.MeshDepthMaterial({
              depthPacking: three.RGBADepthPacking
          }));
          const renderPass = this.renderPass;
          renderPass.skipShadowMapUpdate = true;
          renderPass.ignoreBackground = true;
          const clearPass = renderPass.clearPass;
          clearPass.overrideClearColor = new three.Color(16777215);
          clearPass.overrideClearAlpha = 1;
          this.renderTarget = renderTarget;
          if (this.renderTarget === void 0) {
              this.renderTarget = new three.WebGLRenderTarget(1, 1, {
                  minFilter: three.NearestFilter,
                  magFilter: three.NearestFilter
              });
              this.renderTarget.texture.name = "DepthPass.Target";
          }
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
      }
  };
  // src/effects/glsl/outline.frag
  var outline_default3 = `uniform lowp sampler2D edgeTexture;uniform lowp sampler2D maskTexture;uniform vec3 visibleEdgeColor;uniform vec3 hiddenEdgeColor;uniform float pulse;uniform float edgeStrength;
#ifdef USE_PATTERN
uniform lowp sampler2D patternTexture;varying vec2 vUvPattern;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 edge=texture2D(edgeTexture,uv).rg;vec2 mask=texture2D(maskTexture,uv).rg;
#ifndef X_RAY
edge.y=0.0;
#endif
edge*=(edgeStrength*mask.x*pulse);vec3 color=edge.x*visibleEdgeColor+edge.y*hiddenEdgeColor;float visibilityFactor=0.0;
#ifdef USE_PATTERN
vec4 patternColor=texture2D(patternTexture,vUvPattern);
#ifdef X_RAY
float hiddenFactor=0.5;
#else
float hiddenFactor=0.0;
#endif
visibilityFactor=(1.0-mask.y>0.0)?1.0:hiddenFactor;visibilityFactor*=(1.0-mask.x)*patternColor.a;color+=visibilityFactor*patternColor.rgb;
#endif
float alpha=max(max(edge.x,edge.y),visibilityFactor);
#ifdef ALPHA
outputColor=vec4(color,alpha);
#else
outputColor=vec4(color,max(alpha,inputColor.a));
#endif
}`;
  // src/effects/glsl/outline.vert
  var outline_default4 = `uniform float patternScale;varying vec2 vUvPattern;void mainSupport(const in vec2 uv){vUvPattern=uv*vec2(aspect,1.0)*patternScale;}`;
  // src/effects/OutlineEffect.js
  var OutlineEffect = class extends Effect {
      set mainScene(value) {
          this.scene = value;
          this.depthPass.mainScene = value;
          this.maskPass.mainScene = value;
      }
      set mainCamera(value) {
          this.camera = value;
          this.depthPass.mainCamera = value;
          this.maskPass.mainCamera = value;
          this.maskPass.overrideMaterial.copyCameraSettings(value);
      }
      /**
     * The resolution of this effect.
     *
     * @type {Resolution}
     */ get resolution() {
          return this.blurPass.resolution;
      }
      /**
     * Returns the resolution.
     *
     * @return {Resizer} The resolution.
     */ getResolution() {
          return this.blurPass.getResolution();
      }
      /**
     * The amount of MSAA samples.
     *
     * Requires WebGL 2. Set to zero to disable multisampling.
     *
     * @experimental Requires three >= r138.
     * @type {Number}
     */ get multisampling() {
          return this.renderTargetMask.samples;
      }
      set multisampling(value) {
          this.renderTargetMask.samples = value;
          this.renderTargetMask.dispose();
      }
      /**
     * The pattern scale.
     *
     * @type {Number}
     */ get patternScale() {
          return this.uniforms.get("patternScale").value;
      }
      set patternScale(value) {
          this.uniforms.get("patternScale").value = value;
      }
      /**
     * The edge strength.
     *
     * @type {Number}
     */ get edgeStrength() {
          return this.uniforms.get("edgeStrength").value;
      }
      set edgeStrength(value) {
          this.uniforms.get("edgeStrength").value = value;
      }
      /**
     * The visible edge color.
     *
     * @type {Color}
     */ get visibleEdgeColor() {
          return this.uniforms.get("visibleEdgeColor").value;
      }
      set visibleEdgeColor(value) {
          this.uniforms.get("visibleEdgeColor").value = value;
      }
      /**
     * The hidden edge color.
     *
     * @type {Color}
     */ get hiddenEdgeColor() {
          return this.uniforms.get("hiddenEdgeColor").value;
      }
      set hiddenEdgeColor(value) {
          this.uniforms.get("hiddenEdgeColor").value = value;
      }
      /**
     * Returns the blur pass.
     *
     * @deprecated Use blurPass instead.
     * @return {KawaseBlurPass} The blur pass.
     */ getBlurPass() {
          return this.blurPass;
      }
      /**
     * Returns the selection.
     *
     * @deprecated Use selection instead.
     * @return {Selection} The selection.
     */ getSelection() {
          return this.selection;
      }
      /**
     * Returns the pulse speed.
     *
     * @deprecated Use pulseSpeed instead.
     * @return {Number} The speed.
     */ getPulseSpeed() {
          return this.pulseSpeed;
      }
      /**
     * Sets the pulse speed. Set to zero to disable.
     *
     * @deprecated Use pulseSpeed instead.
     * @param {Number} value - The speed.
     */ setPulseSpeed(value) {
          this.pulseSpeed = value;
      }
      /**
     * The current width of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.width instead.
     */ get width() {
          return this.resolution.width;
      }
      set width(value) {
          this.resolution.preferredWidth = value;
      }
      /**
     * The current height of the internal render targets.
     *
     * @type {Number}
     * @deprecated Use resolution.height instead.
     */ get height() {
          return this.resolution.height;
      }
      set height(value) {
          this.resolution.preferredHeight = value;
      }
      /**
     * The selection layer.
     *
     * @type {Number}
     * @deprecated Use selection.layer instead.
     */ get selectionLayer() {
          return this.selection.layer;
      }
      set selectionLayer(value) {
          this.selection.layer = value;
      }
      /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     * @deprecated
     */ get dithering() {
          return this.blurPass.dithering;
      }
      set dithering(value) {
          this.blurPass.dithering = value;
      }
      /**
     * The blur kernel size.
     *
     * @type {KernelSize}
     * @deprecated Use blurPass.kernelSize instead.
     */ get kernelSize() {
          return this.blurPass.kernelSize;
      }
      set kernelSize(value) {
          this.blurPass.kernelSize = value;
      }
      /**
     * Indicates whether the outlines should be blurred.
     *
     * @type {Boolean}
     * @deprecated Use blurPass.enabled instead.
     */ get blur() {
          return this.blurPass.enabled;
      }
      set blur(value) {
          this.blurPass.enabled = value;
      }
      /**
     * Indicates whether X-ray mode is enabled.
     *
     * @type {Boolean}
     */ get xRay() {
          return this.defines.has("X_RAY");
      }
      set xRay(value) {
          if (this.xRay !== value) {
              if (value) {
                  this.defines.set("X_RAY", "1");
              } else {
                  this.defines.delete("X_RAY");
              }
              this.setChanged();
          }
      }
      /**
     * Indicates whether X-ray mode is enabled.
     *
     * @deprecated Use xRay instead.
     * @return {Boolean} Whether X-ray mode is enabled.
     */ isXRayEnabled() {
          return this.xRay;
      }
      /**
     * Enables or disables X-ray outlines.
     *
     * @deprecated Use xRay instead.
     * @param {Boolean} value - Whether X-ray should be enabled.
     */ setXRayEnabled(value) {
          this.xRay = value;
      }
      /**
     * The pattern texture. Set to `null` to disable.
     *
     * @type {Texture}
     */ get patternTexture() {
          return this.uniforms.get("patternTexture").value;
      }
      set patternTexture(value) {
          if (value !== null) {
              value.wrapS = value.wrapT = three.RepeatWrapping;
              this.defines.set("USE_PATTERN", "1");
              this.setVertexShader(outline_default4);
          } else {
              this.defines.delete("USE_PATTERN");
              this.setVertexShader(null);
          }
          this.uniforms.get("patternTexture").value = value;
          this.setChanged();
      }
      /**
     * Sets the pattern texture.
     *
     * @deprecated Use patternTexture instead.
     * @param {Texture} value - The new texture.
     */ setPatternTexture(value) {
          this.patternTexture = value;
      }
      /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution instead.
     */ getResolutionScale() {
          return this.resolution.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution instead.
     */ setResolutionScale(scale) {
          this.resolution.scale = scale;
      }
      /**
     * Clears the current selection and selects a list of objects.
     *
     * @param {Object3D[]} objects - The objects that should be outlined. This array will be copied.
     * @return {OutlinePass} This pass.
     * @deprecated Use selection.set() instead.
     */ setSelection(objects) {
          this.selection.set(objects);
          return this;
      }
      /**
     * Clears the list of selected objects.
     *
     * @return {OutlinePass} This pass.
     * @deprecated Use selection.clear() instead.
     */ clearSelection() {
          this.selection.clear();
          return this;
      }
      /**
     * Selects an object.
     *
     * @param {Object3D} object - The object that should be outlined.
     * @return {OutlinePass} This pass.
     * @deprecated Use selection.add() instead.
     */ selectObject(object) {
          this.selection.add(object);
          return this;
      }
      /**
     * Deselects an object.
     *
     * @param {Object3D} object - The object that should no longer be outlined.
     * @return {OutlinePass} This pass.
     * @deprecated Use selection.delete() instead.
     */ deselectObject(object) {
          this.selection.delete(object);
          return this;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          const scene = this.scene;
          const camera = this.camera;
          const selection = this.selection;
          const uniforms = this.uniforms;
          const pulse = uniforms.get("pulse");
          const background = scene.background;
          const mask = camera.layers.mask;
          if (this.forceUpdate || selection.size > 0) {
              scene.background = null;
              pulse.value = 1;
              if (this.pulseSpeed > 0) {
                  pulse.value = Math.cos(this.time * this.pulseSpeed * 10) * 0.375 + 0.625;
              }
              this.time += deltaTime;
              selection.setVisible(false);
              this.depthPass.render(renderer);
              selection.setVisible(true);
              camera.layers.set(selection.layer);
              this.maskPass.render(renderer, this.renderTargetMask);
              camera.layers.mask = mask;
              scene.background = background;
              this.outlinePass.render(renderer, null, this.renderTargetOutline);
              if (this.blurPass.enabled) {
                  this.blurPass.render(renderer, this.renderTargetOutline, this.renderTargetOutline);
              }
          }
          this.forceUpdate = selection.size > 0;
      }
      /**
     * Updates the size of internal render targets.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.blurPass.setSize(width, height);
          this.renderTargetMask.setSize(width, height);
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          const w = resolution.width, h = resolution.height;
          this.depthPass.setSize(w, h);
          this.renderTargetOutline.setSize(w, h);
          this.outlinePass.fullscreenMaterial.setSize(w, h);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          this.blurPass.initialize(renderer, alpha, three.UnsignedByteType);
          if (frameBufferType !== void 0) {
              this.depthPass.initialize(renderer, alpha, frameBufferType);
              this.maskPass.initialize(renderer, alpha, frameBufferType);
              this.outlinePass.initialize(renderer, alpha, frameBufferType);
          }
      }
      /**
     * Constructs a new outline effect.
     *
     * @param {Scene} scene - The main scene.
     * @param {Camera} camera - The main camera.
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function. Use `BlendFunction.ALPHA` for dark outlines.
     * @param {Texture} [options.patternTexture=null] - A pattern texture.
     * @param {Number} [options.patternScale=1.0] - The pattern scale.
     * @param {Number} [options.edgeStrength=1.0] - The edge strength.
     * @param {Number} [options.pulseSpeed=0.0] - The pulse speed. A value of zero disables the pulse effect.
     * @param {Number} [options.visibleEdgeColor=0xffffff] - The color of visible edges.
     * @param {Number} [options.hiddenEdgeColor=0x22090a] - The color of hidden edges.
     * @param {KernelSize} [options.kernelSize=KernelSize.VERY_SMALL] - The blur kernel size.
     * @param {Boolean} [options.blur=false] - Whether the outline should be blurred.
     * @param {Boolean} [options.xRay=true] - Whether occluded parts of selected objects should be visible.
     * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
     * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor(scene, camera, { blendFunction = BlendFunction.SCREEN, patternTexture = null, patternScale = 1, edgeStrength = 1, pulseSpeed = 0, visibleEdgeColor = 16777215, hiddenEdgeColor = 2230538, kernelSize = KernelSize.VERY_SMALL, blur = false, xRay = true, multisampling = 0, resolutionScale = 0.5, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("OutlineEffect", outline_default3, {
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "maskTexture",
                      new three.Uniform(null)
                  ],
                  [
                      "edgeTexture",
                      new three.Uniform(null)
                  ],
                  [
                      "edgeStrength",
                      new three.Uniform(edgeStrength)
                  ],
                  [
                      "visibleEdgeColor",
                      new three.Uniform(new three.Color(visibleEdgeColor))
                  ],
                  [
                      "hiddenEdgeColor",
                      new three.Uniform(new three.Color(hiddenEdgeColor))
                  ],
                  [
                      "pulse",
                      new three.Uniform(1)
                  ],
                  [
                      "patternScale",
                      new three.Uniform(patternScale)
                  ],
                  [
                      "patternTexture",
                      new three.Uniform(null)
                  ]
              ])
          });
          this.blendMode.addEventListener("change", (event)=>{
              if (this.blendMode.blendFunction === BlendFunction.ALPHA) {
                  this.defines.set("ALPHA", "1");
              } else {
                  this.defines.delete("ALPHA");
              }
              this.setChanged();
          });
          this.blendMode.blendFunction = blendFunction;
          this.patternTexture = patternTexture;
          this.xRay = xRay;
          this.scene = scene;
          this.camera = camera;
          this.renderTargetMask = new three.WebGLRenderTarget(1, 1);
          this.renderTargetMask.samples = multisampling;
          this.renderTargetMask.texture.name = "Outline.Mask";
          this.uniforms.get("maskTexture").value = this.renderTargetMask.texture;
          this.renderTargetOutline = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTargetOutline.texture.name = "Outline.Edges";
          this.uniforms.get("edgeTexture").value = this.renderTargetOutline.texture;
          this.clearPass = new ClearPass();
          this.clearPass.overrideClearColor = new three.Color(0);
          this.clearPass.overrideClearAlpha = 1;
          this.depthPass = new DepthPass(scene, camera);
          this.maskPass = new RenderPass(scene, camera, new DepthComparisonMaterial(this.depthPass.texture, camera));
          const clearPass = this.maskPass.clearPass;
          clearPass.overrideClearColor = new three.Color(16777215);
          clearPass.overrideClearAlpha = 1;
          this.blurPass = new KawaseBlurPass({
              resolutionScale,
              resolutionX,
              resolutionY,
              kernelSize
          });
          this.blurPass.enabled = blur;
          const resolution = this.blurPass.resolution;
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
          this.outlinePass = new ShaderPass(new OutlineMaterial());
          const outlineMaterial = this.outlinePass.fullscreenMaterial;
          outlineMaterial.inputBuffer = this.renderTargetMask.texture;
          this.time = 0;
          this.forceUpdate = true;
          this.selection = new Selection();
          this.pulseSpeed = pulseSpeed;
      }
  };
  // src/effects/glsl/pixelation.frag
  var pixelation_default = `uniform bool active;uniform vec4 d;void mainUv(inout vec2 uv){if(active){uv=d.xy*(floor(uv*d.zw)+0.5);}}`;
  // src/effects/PixelationEffect.js
  var PixelationEffect = class extends Effect {
      /**
     * The pixel granularity.
     *
     * A higher value yields coarser visuals.
     *
     * @type {Number}
     */ get granularity() {
          return this._granularity;
      }
      set granularity(value) {
          let d = Math.floor(value);
          if (d % 2 > 0) {
              d += 1;
          }
          this._granularity = d;
          this.uniforms.get("active").value = d > 0;
          this.setSize(this.resolution.width, this.resolution.height);
      }
      /**
     * Returns the pixel granularity.
     *
     * @deprecated Use granularity instead.
     * @return {Number} The granularity.
     */ getGranularity() {
          return this.granularity;
      }
      /**
     * Sets the pixel granularity.
     *
     * @deprecated Use granularity instead.
     * @param {Number} value - The new granularity.
     */ setGranularity(value) {
          this.granularity = value;
      }
      /**
     * Updates the granularity.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.set(width, height);
          const d = this.granularity;
          const x = d / resolution.x;
          const y = d / resolution.y;
          this.uniforms.get("d").value.set(x, y, 1 / x, 1 / y);
      }
      /**
     * Constructs a new pixelation effect.
     *
     * @param {Object} [granularity=30.0] - The pixel granularity.
     */ constructor(granularity = 30){
          super("PixelationEffect", pixelation_default, {
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "active",
                      new three.Uniform(false)
                  ],
                  [
                      "d",
                      new three.Uniform(new three.Vector4())
                  ]
              ])
          });
          this.resolution = new three.Vector2();
          this._granularity = 0;
          this.granularity = granularity;
      }
  };
  var SelectiveBloomEffect = class extends BloomEffect {
      set mainScene(value) {
          this.depthPass.mainScene = value;
      }
      set mainCamera(value) {
          this.camera = value;
          this.depthPass.mainCamera = value;
          this.depthMaskMaterial.copyCameraSettings(value);
      }
      /**
     * Returns the selection.
     *
     * @deprecated Use selection instead.
     * @return {Selection} The selection.
     */ getSelection() {
          return this.selection;
      }
      /**
     * The depth mask material.
     *
     * @type {DepthMaskMaterial}
     * @private
     */ get depthMaskMaterial() {
          return this.depthMaskPass.fullscreenMaterial;
      }
      /**
     * Indicates whether the selection should be considered inverted.
     *
     * @type {Boolean}
     */ get inverted() {
          return this._inverted;
      }
      set inverted(value) {
          this._inverted = value;
          this.depthMaskMaterial.depthMode = value ? three.NotEqualDepth : three.EqualDepth;
      }
      /**
     * Indicates whether the mask is inverted.
     *
     * @deprecated Use inverted instead.
     * @return {Boolean} Whether the mask is inverted.
     */ isInverted() {
          return this.inverted;
      }
      /**
     * Enables or disable mask inversion.
     *
     * @deprecated Use inverted instead.
     * @param {Boolean} value - Whether the mask should be inverted.
     */ setInverted(value) {
          this.inverted = value;
      }
      /**
     * Indicates whether the background colors will be ignored.
     *
     * @type {Boolean}
     */ get ignoreBackground() {
          return this._ignoreBackground;
      }
      set ignoreBackground(value) {
          this._ignoreBackground = value;
          this.depthMaskMaterial.maxDepthStrategy = value ? DepthTestStrategy.DISCARD_MAX_DEPTH : DepthTestStrategy.KEEP_MAX_DEPTH;
      }
      /**
     * Indicates whether the background is disabled.
     *
     * @deprecated Use ignoreBackground instead.
     * @return {Boolean} Whether the background is disabled.
     */ isBackgroundDisabled() {
          return this.ignoreBackground;
      }
      /**
     * Enables or disables the background.
     *
     * @deprecated Use ignoreBackground instead.
     * @param {Boolean} value - Whether the background should be disabled.
     */ setBackgroundDisabled(value) {
          this.ignoreBackground = value;
      }
      /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {
          this.depthMaskMaterial.depthBuffer0 = depthTexture;
          this.depthMaskMaterial.depthPacking0 = depthPacking;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          const camera = this.camera;
          const selection = this.selection;
          const inverted = this.inverted;
          let renderTarget = inputBuffer;
          if (this.ignoreBackground || !inverted || selection.size > 0) {
              const mask = camera.layers.mask;
              camera.layers.set(selection.layer);
              this.depthPass.render(renderer);
              camera.layers.mask = mask;
              renderTarget = this.renderTargetMasked;
              this.clearPass.render(renderer, renderTarget);
              this.depthMaskPass.render(renderer, inputBuffer, renderTarget);
          }
          super.update(renderer, renderTarget, deltaTime);
      }
      /**
     * Updates the size of internal render targets.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          super.setSize(width, height);
          this.renderTargetMasked.setSize(width, height);
          this.depthPass.setSize(width, height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          super.initialize(renderer, alpha, frameBufferType);
          this.clearPass.initialize(renderer, alpha, frameBufferType);
          this.depthPass.initialize(renderer, alpha, frameBufferType);
          this.depthMaskPass.initialize(renderer, alpha, frameBufferType);
          if (renderer !== null && renderer.capabilities.logarithmicDepthBuffer) {
              this.depthMaskPass.fullscreenMaterial.defines.LOG_DEPTH = "1";
          }
          if (frameBufferType !== void 0) {
              this.renderTargetMasked.texture.type = frameBufferType;
              if (renderer !== null && renderer.outputColorSpace === three.SRGBColorSpace) {
                  this.renderTargetMasked.texture.colorSpace = three.SRGBColorSpace;
              }
          }
      }
      /**
     * Constructs a new selective bloom effect.
     *
     * @param {Scene} scene - The main scene.
     * @param {Camera} camera - The main camera.
     * @param {Object} [options] - The options. See {@link BloomEffect} for details.
     */ constructor(scene, camera, options){
          super(options);
          this.setAttributes(this.getAttributes() | EffectAttribute.DEPTH);
          this.camera = camera;
          this.depthPass = new DepthPass(scene, camera);
          this.clearPass = new ClearPass(true, false, false);
          this.clearPass.overrideClearColor = new three.Color(0);
          this.depthMaskPass = new ShaderPass(new DepthMaskMaterial());
          const depthMaskMaterial = this.depthMaskMaterial;
          depthMaskMaterial.copyCameraSettings(camera);
          depthMaskMaterial.depthBuffer1 = this.depthPass.texture;
          depthMaskMaterial.depthPacking1 = three.RGBADepthPacking;
          depthMaskMaterial.depthMode = three.EqualDepth;
          this.renderTargetMasked = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTargetMasked.texture.name = "Bloom.Masked";
          this.selection = new Selection();
          this._inverted = false;
          this._ignoreBackground = false;
      }
  };
  // src/materials/glsl/edge-detection.frag
  var edge_detection_default = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`;
  // src/materials/glsl/edge-detection.vert
  var edge_detection_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/EdgeDetectionMaterial.js
  var EdgeDetectionMaterial = class extends three.ShaderMaterial {
      /**
     * The depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer(value) {
          this.uniforms.depthBuffer.value = value;
      }
      /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking(value) {
          this.defines.DEPTH_PACKING = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer = buffer;
          this.depthPacking = depthPacking;
      }
      /**
     * The edge detection mode.
     *
     * @type {EdgeDetectionMode}
     */ get edgeDetectionMode() {
          return Number(this.defines.EDGE_DETECTION_MODE);
      }
      set edgeDetectionMode(value) {
          this.defines.EDGE_DETECTION_MODE = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Returns the edge detection mode.
     *
     * @deprecated Use edgeDetectionMode instead.
     * @return {EdgeDetectionMode} The mode.
     */ getEdgeDetectionMode() {
          return this.edgeDetectionMode;
      }
      /**
     * Sets the edge detection mode.
     *
     * @deprecated Use edgeDetectionMode instead.
     * @param {EdgeDetectionMode} value - The edge detection mode.
     */ setEdgeDetectionMode(value) {
          this.edgeDetectionMode = value;
      }
      /**
     * The local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH. Default is 2.0.
     *
     * If a neighbor edge has _factor_ times bigger contrast than the current edge, the edge will be discarded.
     *
     * This allows to eliminate spurious crossing edges and is based on the fact that if there is too much contrast in a
     * direction, the perceptual contrast in the other neighbors will be hidden.
     *
     * @type {Number}
     */ get localContrastAdaptationFactor() {
          return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
      }
      set localContrastAdaptationFactor(value) {
          this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = value.toFixed("6");
          this.needsUpdate = true;
      }
      /**
     * Returns the local contrast adaptation factor.
     *
     * @deprecated Use localContrastAdaptationFactor instead.
     * @return {Number} The factor.
     */ getLocalContrastAdaptationFactor() {
          return this.localContrastAdaptationFactor;
      }
      /**
     * Sets the local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH.
     *
     * @deprecated Use localContrastAdaptationFactor instead.
     * @param {Number} value - The local contrast adaptation factor. Default is 2.0.
     */ setLocalContrastAdaptationFactor(value) {
          this.localContrastAdaptationFactor = value;
      }
      /**
     * The edge detection threshold. Range: [0.0, 0.5].
     *
     * A lower value results in more edges being detected at the expense of performance.
     *
     * For luma- and chroma-based edge detection, 0.1 is a reasonable value and allows to catch most visible edges. 0.05
     * is a rather overkill value that allows to catch 'em all. Darker scenes may require an even lower threshold.
     *
     * If depth-based edge detection is used, the threshold will depend on the scene depth.
     *
     * @type {Number}
     */ get edgeDetectionThreshold() {
          return Number(this.defines.EDGE_THRESHOLD);
      }
      set edgeDetectionThreshold(value) {
          this.defines.EDGE_THRESHOLD = value.toFixed("6");
          this.defines.DEPTH_THRESHOLD = (value * 0.1).toFixed("6");
          this.needsUpdate = true;
      }
      /**
     * Returns the edge detection threshold.
     *
     * @deprecated Use edgeDetectionThreshold instead.
     * @return {Number} The threshold.
     */ getEdgeDetectionThreshold() {
          return this.edgeDetectionThreshold;
      }
      /**
     * Sets the edge detection threshold.
     *
     * @deprecated Use edgeDetectionThreshold instead.
     * @param {Number} value - The edge detection threshold. Range: [0.0, 0.5].
     */ setEdgeDetectionThreshold(value) {
          this.edgeDetectionThreshold = value;
      }
      /**
     * The predication mode.
     *
     * Predicated thresholding allows to better preserve texture details and to improve edge detection using an additional
     * buffer such as a light accumulation or depth buffer.
     *
     * @type {PredicationMode}
     */ get predicationMode() {
          return Number(this.defines.PREDICATION_MODE);
      }
      set predicationMode(value) {
          this.defines.PREDICATION_MODE = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Returns the predication mode.
     *
     * @deprecated Use predicationMode instead.
     * @return {PredicationMode} The mode.
     */ getPredicationMode() {
          return this.predicationMode;
      }
      /**
     * Sets the predication mode.
     *
     * @deprecated Use predicationMode instead.
     * @param {PredicationMode} value - The predication mode.
     */ setPredicationMode(value) {
          this.predicationMode = value;
      }
      /**
     * The predication buffer.
     *
     * @type {Texture}
     */ set predicationBuffer(value) {
          this.uniforms.predicationBuffer.value = value;
      }
      /**
     * Sets a custom predication buffer.
     *
     * @deprecated Use predicationBuffer instead.
     * @param {Texture} value - The predication buffer.
     */ setPredicationBuffer(value) {
          this.uniforms.predicationBuffer.value = value;
      }
      /**
     * The predication threshold.
     *
     * @type {Number}
     */ get predicationThreshold() {
          return Number(this.defines.PREDICATION_THRESHOLD);
      }
      set predicationThreshold(value) {
          this.defines.PREDICATION_THRESHOLD = value.toFixed("6");
          this.needsUpdate = true;
      }
      /**
     * Returns the predication threshold.
     *
     * @deprecated Use predicationThreshold instead.
     * @return {Number} The threshold.
     */ getPredicationThreshold() {
          return this.predicationThreshold;
      }
      /**
     * Sets the predication threshold.
     *
     * @deprecated Use predicationThreshold instead.
     * @param {Number} value - The threshold.
     */ setPredicationThreshold(value) {
          this.predicationThreshold = value;
      }
      /**
     * The predication scale. Range: [1.0, 5.0].
     *
     * Determines how much the edge detection threshold should be scaled when using predication.
     *
     * @type {Boolean|Texture|Number}
     */ get predicationScale() {
          return Number(this.defines.PREDICATION_SCALE);
      }
      set predicationScale(value) {
          this.defines.PREDICATION_SCALE = value.toFixed("6");
          this.needsUpdate = true;
      }
      /**
     * Returns the predication scale.
     *
     * @deprecated Use predicationScale instead.
     * @return {Number} The scale.
     */ getPredicationScale() {
          return this.predicationScale;
      }
      /**
     * Sets the predication scale.
     *
     * @deprecated Use predicationScale instead.
     * @param {Number} value - The scale. Range: [1.0, 5.0].
     */ setPredicationScale(value) {
          this.predicationScale = value;
      }
      /**
     * The predication strength. Range: [0.0, 1.0].
     *
     * Determines how much the edge detection threshold should be decreased locally when using predication.
     *
     * @type {Number}
     */ get predicationStrength() {
          return Number(this.defines.PREDICATION_STRENGTH);
      }
      set predicationStrength(value) {
          this.defines.PREDICATION_STRENGTH = value.toFixed("6");
          this.needsUpdate = true;
      }
      /**
     * Returns the predication strength.
     *
     * @deprecated Use predicationStrength instead.
     * @return {Number} The strength.
     */ getPredicationStrength() {
          return this.predicationStrength;
      }
      /**
     * Sets the predication strength.
     *
     * @deprecated Use predicationStrength instead.
     * @param {Number} value - The strength. Range: [0.0, 1.0].
     */ setPredicationStrength(value) {
          this.predicationStrength = value;
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.uniforms.texelSize.value.set(1 / width, 1 / height);
      }
      /**
     * Constructs a new edge detection material.
     *
     * TODO Remove parameters.
     * @param {Vector2} [texelSize] - The screen texel size.
     * @param {EdgeDetectionMode} [mode=EdgeDetectionMode.COLOR] - The edge detection mode.
     */ constructor(texelSize = new three.Vector2(), mode = EdgeDetectionMode.COLOR){
          super({
              name: "EdgeDetectionMaterial",
              defines: {
                  THREE_REVISION: three.REVISION.replace(/\D+/g, ""),
                  LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                  EDGE_THRESHOLD: "0.1",
                  DEPTH_THRESHOLD: "0.01",
                  PREDICATION_MODE: "0",
                  PREDICATION_THRESHOLD: "0.01",
                  PREDICATION_SCALE: "2.0",
                  PREDICATION_STRENGTH: "1.0",
                  DEPTH_PACKING: "0"
              },
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  depthBuffer: new three.Uniform(null),
                  predicationBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(texelSize)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: edge_detection_default,
              vertexShader: edge_detection_default2
          });
          this.edgeDetectionMode = mode;
      }
  };
  // src/materials/glsl/smaa-weights.frag
  var smaa_weights_default = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`;
  // src/materials/glsl/smaa-weights.vert
  var smaa_weights_default2 = `uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/SMAAWeightsMaterial.js
  var SMAAWeightsMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */ setInputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * The search lookup texture.
     *
     * @type {Texture}
     */ get searchTexture() {
          return this.uniforms.searchTexture.value;
      }
      set searchTexture(value) {
          this.uniforms.searchTexture.value = value;
      }
      /**
     * The area lookup texture.
     *
     * @type {Texture}
     */ get areaTexture() {
          return this.uniforms.areaTexture.value;
      }
      set areaTexture(value) {
          this.uniforms.areaTexture.value = value;
      }
      /**
     * Sets the search and area lookup textures.
     *
     * @deprecated Use searchTexture and areaTexture instead.
     * @param {Texture} search - The search lookup texture.
     * @param {Texture} area - The area lookup texture.
     */ setLookupTextures(search, area2) {
          this.searchTexture = search;
          this.areaTexture = area2;
      }
      /**
     * The maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
     * Range: [0, 112].
     *
     * In number of pixels, it's actually the double. So the maximum line length perfectly handled by, for example 16, is
     * 64 (perfectly means that longer lines won't look as good, but are still antialiased).
     *
     * @type {Number}
     */ get orthogonalSearchSteps() {
          return Number(this.defines.MAX_SEARCH_STEPS_INT);
      }
      set orthogonalSearchSteps(value) {
          const s = Math.min(Math.max(value, 0), 112);
          this.defines.MAX_SEARCH_STEPS_INT = s.toFixed("0");
          this.defines.MAX_SEARCH_STEPS_FLOAT = s.toFixed("1");
          this.needsUpdate = true;
      }
      /**
     * Sets the maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
     *
     * @deprecated Use orthogonalSearchSteps instead.
     * @param {Number} value - The search steps. Range: [0, 112].
     */ setOrthogonalSearchSteps(value) {
          this.orthogonalSearchSteps = value;
      }
      /**
     * The maximum steps performed in the diagonal pattern searches, at each side of the pixel. This search
     * jumps one pixel at a time. Range: [0, 20].
     *
     * On high-end machines this search is cheap (between 0.8x and 0.9x slower for 16 steps), but it can have a
     * significant impact on older machines.
     *
     * @type {Number}
     */ get diagonalSearchSteps() {
          return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
      }
      set diagonalSearchSteps(value) {
          const s = Math.min(Math.max(value, 0), 20);
          this.defines.MAX_SEARCH_STEPS_DIAG_INT = s.toFixed("0");
          this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = s.toFixed("1");
          this.needsUpdate = true;
      }
      /**
     * Specifies the maximum steps performed in the diagonal pattern searches, at each side of the pixel.
     *
     * @deprecated Use diagonalSearchSteps instead.
     * @param {Number} value - The search steps. Range: [0, 20].
     */ setDiagonalSearchSteps(value) {
          this.diagonalSearchSteps = value;
      }
      /**
     * Indicates whether diagonal pattern detection is enabled.
     *
     * @type {Boolean}
     */ get diagonalDetection() {
          return this.defines.DISABLE_DIAG_DETECTION === void 0;
      }
      set diagonalDetection(value) {
          if (value) {
              delete this.defines.DISABLE_DIAG_DETECTION;
          } else {
              this.defines.DISABLE_DIAG_DETECTION = "1";
          }
          this.needsUpdate = true;
      }
      /**
     * Indicates whether diagonal pattern detection is enabled.
     *
     * @deprecated Use diagonalDetection instead.
     * @return {Boolean} Whether diagonal pattern detection is enabled.
     */ isDiagonalDetectionEnabled() {
          return this.diagonalDetection;
      }
      /**
     * Enables or disables diagonal pattern detection.
     *
     * @deprecated Use diagonalDetection instead.
     * @param {Boolean} value - Whether diagonal pattern detection should be enabled.
     */ setDiagonalDetectionEnabled(value) {
          this.diagonalDetection = value;
      }
      /**
     * Specifies how much sharp corners will be rounded. Range: [0, 100].
     *
     * @type {Number}
     */ get cornerRounding() {
          return Number(this.defines.CORNER_ROUNDING);
      }
      set cornerRounding(value) {
          const r = Math.min(Math.max(value, 0), 100);
          this.defines.CORNER_ROUNDING = r.toFixed("4");
          this.defines.CORNER_ROUNDING_NORM = (r / 100).toFixed("4");
          this.needsUpdate = true;
      }
      /**
     * Specifies how much sharp corners will be rounded.
     *
     * @deprecated Use cornerRounding instead.
     * @param {Number} value - The corner rounding amount. Range: [0, 100].
     */ setCornerRounding(value) {
          this.cornerRounding = value;
      }
      /**
     * Indicates whether corner detection is enabled.
     *
     * @type {Number}
     */ get cornerDetection() {
          return this.defines.DISABLE_CORNER_DETECTION === void 0;
      }
      set cornerDetection(value) {
          if (value) {
              delete this.defines.DISABLE_CORNER_DETECTION;
          } else {
              this.defines.DISABLE_CORNER_DETECTION = "1";
          }
          this.needsUpdate = true;
      }
      /**
     * Indicates whether corner rounding is enabled.
     *
     * @deprecated Use cornerDetection instead.
     * @return {Boolean} Whether corner rounding is enabled.
     */ isCornerRoundingEnabled() {
          return this.cornerDetection;
      }
      /**
     * Enables or disables corner rounding.
     *
     * @deprecated Use cornerDetection instead.
     * @param {Boolean} value - Whether corner rounding should be enabled.
     */ setCornerRoundingEnabled(value) {
          this.cornerDetection = value;
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const uniforms = this.uniforms;
          uniforms.texelSize.value.set(1 / width, 1 / height);
          uniforms.resolution.value.set(width, height);
      }
      /**
     * Constructs a new SMAA weights material.
     *
     * @param {Vector2} [texelSize] - The absolute screen texel size.
     * @param {Vector2} [resolution] - The resolution.
     */ constructor(texelSize = new three.Vector2(), resolution = new three.Vector2()){
          super({
              name: "SMAAWeightsMaterial",
              defines: {
                  // Configurable settings:
                  MAX_SEARCH_STEPS_INT: "16",
                  MAX_SEARCH_STEPS_FLOAT: "16.0",
                  MAX_SEARCH_STEPS_DIAG_INT: "8",
                  MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                  CORNER_ROUNDING: "25",
                  CORNER_ROUNDING_NORM: "0.25",
                  // Non-configurable settings:
                  AREATEX_MAX_DISTANCE: "16.0",
                  AREATEX_MAX_DISTANCE_DIAG: "20.0",
                  AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                  AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                  SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                  SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
              },
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  searchTexture: new three.Uniform(null),
                  areaTexture: new three.Uniform(null),
                  resolution: new three.Uniform(resolution),
                  texelSize: new three.Uniform(texelSize)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: smaa_weights_default,
              vertexShader: smaa_weights_default2
          });
      }
  };
  // src/textures/smaa/searchImageDataURL.js
  var searchImageDataURL_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC";
  // src/textures/smaa/areaImageDataURL.js
  var areaImageDataURL_default = "data:image/png;base64,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";
  // src/effects/glsl/smaa.frag
  var smaa_default = `uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}`;
  // src/effects/glsl/smaa.vert
  var smaa_default2 = `varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}`;
  // src/effects/SMAAEffect.js
  var SMAAEffect = class extends Effect {
      /**
     * The edges texture.
     *
     * @type {Texture}
     */ get edgesTexture() {
          return this.renderTargetEdges.texture;
      }
      /**
     * Returns the edges texture.
     *
     * @deprecated Use edgesTexture instead.
     * @return {Texture} The texture.
     */ getEdgesTexture() {
          return this.edgesTexture;
      }
      /**
     * The edge weights texture.
     *
     * @type {Texture}
     */ get weightsTexture() {
          return this.renderTargetWeights.texture;
      }
      /**
     * Returns the edge weights texture.
     *
     * @deprecated Use weightsTexture instead.
     * @return {Texture} The texture.
     */ getWeightsTexture() {
          return this.weightsTexture;
      }
      /**
     * The edge detection material.
     *
     * @type {EdgeDetectionMaterial}
     */ get edgeDetectionMaterial() {
          return this.edgeDetectionPass.fullscreenMaterial;
      }
      /**
     * The edge detection material.
     *
     * @type {EdgeDetectionMaterial}
     * @deprecated Use edgeDetectionMaterial instead.
     */ get colorEdgesMaterial() {
          return this.edgeDetectionMaterial;
      }
      /**
     * Returns the edge detection material.
     *
     * @deprecated Use edgeDetectionMaterial instead.
     * @return {EdgeDetectionMaterial} The material.
     */ getEdgeDetectionMaterial() {
          return this.edgeDetectionMaterial;
      }
      /**
     * The edge weights material.
     *
     * @type {SMAAWeightsMaterial}
     */ get weightsMaterial() {
          return this.weightsPass.fullscreenMaterial;
      }
      /**
     * Returns the edge weights material.
     *
     * @deprecated Use weightsMaterial instead.
     * @return {SMAAWeightsMaterial} The material.
     */ getWeightsMaterial() {
          return this.weightsMaterial;
      }
      /**
     * Sets the edge detection sensitivity.
     *
     * See {@link EdgeDetectionMaterial#setEdgeDetectionThreshold} for more details.
     *
     * @deprecated Use edgeDetectionMaterial instead.
     * @param {Number} threshold - The edge detection sensitivity. Range: [0.05, 0.5].
     */ setEdgeDetectionThreshold(threshold) {
          this.edgeDetectionMaterial.edgeDetectionThreshold = threshold;
      }
      /**
     * Sets the maximum amount of horizontal/vertical search steps.
     *
     * See {@link SMAAWeightsMaterial#setOrthogonalSearchSteps} for more details.
     *
     * @deprecated Use weightsMaterial instead.
     * @param {Number} steps - The search steps. Range: [0, 112].
     */ setOrthogonalSearchSteps(steps) {
          this.weightsMaterial.orthogonalSearchSteps = steps;
      }
      /**
     * Applies the given quality preset.
     *
     * @param {SMAAPreset} preset - The preset.
     */ applyPreset(preset) {
          const edgeDetectionMaterial = this.edgeDetectionMaterial;
          const weightsMaterial = this.weightsMaterial;
          switch(preset){
              case SMAAPreset.LOW:
                  edgeDetectionMaterial.edgeDetectionThreshold = 0.15;
                  weightsMaterial.orthogonalSearchSteps = 4;
                  weightsMaterial.diagonalDetection = false;
                  weightsMaterial.cornerDetection = false;
                  break;
              case SMAAPreset.MEDIUM:
                  edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                  weightsMaterial.orthogonalSearchSteps = 8;
                  weightsMaterial.diagonalDetection = false;
                  weightsMaterial.cornerDetection = false;
                  break;
              case SMAAPreset.HIGH:
                  edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                  weightsMaterial.orthogonalSearchSteps = 16;
                  weightsMaterial.diagonalSearchSteps = 8;
                  weightsMaterial.cornerRounding = 25;
                  weightsMaterial.diagonalDetection = true;
                  weightsMaterial.cornerDetection = true;
                  break;
              case SMAAPreset.ULTRA:
                  edgeDetectionMaterial.edgeDetectionThreshold = 0.05;
                  weightsMaterial.orthogonalSearchSteps = 32;
                  weightsMaterial.diagonalSearchSteps = 16;
                  weightsMaterial.cornerRounding = 25;
                  weightsMaterial.diagonalDetection = true;
                  weightsMaterial.cornerDetection = true;
                  break;
          }
      }
      /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {
          this.edgeDetectionMaterial.depthBuffer = depthTexture;
          this.edgeDetectionMaterial.depthPacking = depthPacking;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          this.clearPass.render(renderer, this.renderTargetEdges);
          this.edgeDetectionPass.render(renderer, inputBuffer, this.renderTargetEdges);
          this.weightsPass.render(renderer, this.renderTargetEdges, this.renderTargetWeights);
      }
      /**
     * Updates the size of internal render targets.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.edgeDetectionMaterial.setSize(width, height);
          this.weightsMaterial.setSize(width, height);
          this.renderTargetEdges.setSize(width, height);
          this.renderTargetWeights.setSize(width, height);
      }
      /**
     * Deletes internal render targets and textures.
     */ dispose() {
          const { searchTexture, areaTexture } = this.weightsMaterial;
          if (searchTexture !== null && areaTexture !== null) {
              searchTexture.dispose();
              areaTexture.dispose();
          }
          super.dispose();
      }
      /**
     * The SMAA search image, encoded as a base64 data URL.
     *
     * @type {String}
     * @deprecated
     */ static get searchImageDataURL() {
          return searchImageDataURL_default;
      }
      /**
     * The SMAA area image, encoded as a base64 data URL.
     *
     * @type {String}
     * @deprecated
     */ static get areaImageDataURL() {
          return areaImageDataURL_default;
      }
      /**
     * Constructs a new SMAA effect.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
     * @param {SMAAPreset} [options.preset=SMAAPreset.MEDIUM] - The quality preset.
     * @param {EdgeDetectionMode} [options.edgeDetectionMode=EdgeDetectionMode.COLOR] - The edge detection mode.
     * @param {PredicationMode} [options.predicationMode=PredicationMode.DISABLED] - The predication mode.
     */ constructor({ blendFunction = BlendFunction.SRC, preset = SMAAPreset.MEDIUM, edgeDetectionMode = EdgeDetectionMode.COLOR, predicationMode = PredicationMode.DISABLED } = {}){
          super("SMAAEffect", smaa_default, {
              vertexShader: smaa_default2,
              blendFunction,
              attributes: EffectAttribute.CONVOLUTION | EffectAttribute.DEPTH,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "weightMap",
                      new three.Uniform(null)
                  ]
              ])
          });
          let searchImage, areaImage;
          if (arguments.length > 1) {
              searchImage = arguments[0];
              areaImage = arguments[1];
              if (arguments.length > 2) {
                  preset = arguments[2];
              }
              if (arguments.length > 3) {
                  edgeDetectionMode = arguments[3];
              }
          }
          this.renderTargetEdges = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTargetEdges.texture.name = "SMAA.Edges";
          this.renderTargetWeights = this.renderTargetEdges.clone();
          this.renderTargetWeights.texture.name = "SMAA.Weights";
          this.uniforms.get("weightMap").value = this.renderTargetWeights.texture;
          this.clearPass = new ClearPass(true, false, false);
          this.clearPass.overrideClearColor = new three.Color(0);
          this.clearPass.overrideClearAlpha = 1;
          this.edgeDetectionPass = new ShaderPass(new EdgeDetectionMaterial());
          this.edgeDetectionMaterial.edgeDetectionMode = edgeDetectionMode;
          this.edgeDetectionMaterial.predicationMode = predicationMode;
          this.weightsPass = new ShaderPass(new SMAAWeightsMaterial());
          const loadingManager = new three.LoadingManager();
          loadingManager.onLoad = ()=>{
              const searchTexture = new three.Texture(searchImage);
              searchTexture.name = "SMAA.Search";
              searchTexture.magFilter = three.NearestFilter;
              searchTexture.minFilter = three.NearestFilter;
              searchTexture.generateMipmaps = false;
              searchTexture.needsUpdate = true;
              searchTexture.flipY = true;
              this.weightsMaterial.searchTexture = searchTexture;
              const areaTexture = new three.Texture(areaImage);
              areaTexture.name = "SMAA.Area";
              areaTexture.magFilter = three.LinearFilter;
              areaTexture.minFilter = three.LinearFilter;
              areaTexture.generateMipmaps = false;
              areaTexture.needsUpdate = true;
              areaTexture.flipY = false;
              this.weightsMaterial.areaTexture = areaTexture;
              this.dispatchEvent({
                  type: "load"
              });
          };
          loadingManager.itemStart("search");
          loadingManager.itemStart("area");
          if (searchImage !== void 0 && areaImage !== void 0) {
              loadingManager.itemEnd("search");
              loadingManager.itemEnd("area");
          } else if (typeof Image !== "undefined") {
              searchImage = new Image();
              areaImage = new Image();
              searchImage.addEventListener("load", ()=>loadingManager.itemEnd("search"));
              areaImage.addEventListener("load", ()=>loadingManager.itemEnd("area"));
              searchImage.src = searchImageDataURL_default;
              areaImage.src = areaImageDataURL_default;
          }
          this.applyPreset(preset);
      }
  };
  // src/materials/glsl/ssao.frag
  var ssao_default = `#include <common>
#include <packing>
#ifdef NORMAL_DEPTH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
float readDepth(const in vec2 uv){return texture2D(normalDepthBuffer,uv).a;}
#else
uniform lowp sampler2D normalBuffer;
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}
#endif
uniform lowp sampler2D noiseTexture;uniform mat4 inverseProjectionMatrix;uniform mat4 projectionMatrix;uniform vec2 texelSize;uniform vec2 cameraNearFar;uniform float intensity;uniform float minRadiusScale;uniform float fade;uniform float bias;uniform vec2 distanceCutoff;uniform vec2 proximityCutoff;varying vec2 vUv;varying vec2 vUv2;float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#else
return orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#endif
}vec3 getViewPosition(const in vec2 screenPosition,const in float depth,const in float viewZ){vec4 clipPosition=vec4(vec3(screenPosition,depth)*2.0-1.0,1.0);float clipW=projectionMatrix[2][3]*viewZ+projectionMatrix[3][3];clipPosition*=clipW;return(inverseProjectionMatrix*clipPosition).xyz;}float getAmbientOcclusion(const in vec3 p,const in vec3 n,const in float depth,const in vec2 uv){float radiusScale=1.0-smoothstep(0.0,distanceCutoff.y,depth);radiusScale=radiusScale*(1.0-minRadiusScale)+minRadiusScale;float radius=RADIUS*radiusScale;float noise=texture2D(noiseTexture,vUv2).r;float baseAngle=noise*PI2;float rings=SPIRAL_TURNS*PI2;float occlusion=0.0;int taps=0;for(int i=0;i<SAMPLES_INT;++i){float alpha=(float(i)+0.5)*INV_SAMPLES_FLOAT;float angle=alpha*rings+baseAngle;vec2 rotation=vec2(cos(angle),sin(angle));vec2 coords=alpha*radius*rotation*texelSize+uv;if(coords.s<0.0||coords.s>1.0||coords.t<0.0||coords.t>1.0){continue;}float sampleDepth=readDepth(coords);float viewZ=getViewZ(sampleDepth);
#ifdef PERSPECTIVE_CAMERA
float linearSampleDepth=viewZToOrthographicDepth(viewZ,cameraNearFar.x,cameraNearFar.y);
#else
float linearSampleDepth=sampleDepth;
#endif
float proximity=abs(depth-linearSampleDepth);if(proximity<proximityCutoff.y){float falloff=1.0-smoothstep(proximityCutoff.x,proximityCutoff.y,proximity);vec3 Q=getViewPosition(coords,sampleDepth,viewZ);vec3 v=Q-p;float vv=dot(v,v);float vn=dot(v,n)-bias;float f=max(RADIUS_SQ-vv,0.0)/RADIUS_SQ;occlusion+=(f*f*f*max(vn/(fade+vv),0.0))*falloff;}++taps;}return occlusion/(4.0*max(float(taps),1.0));}void main(){
#ifdef NORMAL_DEPTH
vec4 normalDepth=texture2D(normalDepthBuffer,vUv);
#else
vec4 normalDepth=vec4(texture2D(normalBuffer,vUv).xyz,readDepth(vUv));
#endif
float ao=0.0;float depth=normalDepth.a;float viewZ=getViewZ(depth);
#ifdef PERSPECTIVE_CAMERA
float linearDepth=viewZToOrthographicDepth(viewZ,cameraNearFar.x,cameraNearFar.y);
#else
float linearDepth=depth;
#endif
if(linearDepth<distanceCutoff.y){vec3 viewPosition=getViewPosition(vUv,depth,viewZ);vec3 viewNormal=unpackRGBToNormal(normalDepth.rgb);ao+=getAmbientOcclusion(viewPosition,viewNormal,linearDepth,vUv);float d=smoothstep(distanceCutoff.x,distanceCutoff.y,linearDepth);ao=mix(ao,0.0,d);
#ifdef LEGACY_INTENSITY
ao=clamp(1.0-pow(1.0-ao,abs(intensity)),0.0,1.0);
#endif
}gl_FragColor.r=ao;}`;
  // src/materials/glsl/ssao.vert
  var ssao_default2 = `uniform vec2 noiseScale;varying vec2 vUv;varying vec2 vUv2;void main(){vUv=position.xy*0.5+0.5;vUv2=vUv*noiseScale;gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/SSAOMaterial.js
  var SSAOMaterial = class extends three.ShaderMaterial {
      /**
     * The current near plane setting.
     *
     * @type {Number}
     * @private
     */ get near() {
          return this.uniforms.cameraNearFar.value.x;
      }
      /**
     * The current far plane setting.
     *
     * @type {Number}
     * @private
     */ get far() {
          return this.uniforms.cameraNearFar.value.y;
      }
      /**
     * A combined normal-depth buffer.
     *
     * @type {Texture}
     */ set normalDepthBuffer(value) {
          this.uniforms.normalDepthBuffer.value = value;
          if (value !== null) {
              this.defines.NORMAL_DEPTH = "1";
          } else {
              delete this.defines.NORMAL_DEPTH;
          }
          this.needsUpdate = true;
      }
      /**
     * Sets the combined normal-depth buffer.
     *
     * @deprecated Use normalDepthBuffer instead.
     * @param {Number} value - The buffer.
     */ setNormalDepthBuffer(value) {
          this.normalDepthBuffer = value;
      }
      /**
     * The normal buffer.
     *
     * @type {Texture}
     */ set normalBuffer(value) {
          this.uniforms.normalBuffer.value = value;
      }
      /**
     * Sets the normal buffer.
     *
     * @deprecated Use normalBuffer instead.
     * @param {Number} value - The buffer.
     */ setNormalBuffer(value) {
          this.uniforms.normalBuffer.value = value;
      }
      /**
     * The depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer(value) {
          this.uniforms.depthBuffer.value = value;
      }
      /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking(value) {
          this.defines.DEPTH_PACKING = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer = buffer;
          this.depthPacking = depthPacking;
      }
      /**
     * The noise texture.
     *
     * @type {Texture}
     */ set noiseTexture(value) {
          this.uniforms.noiseTexture.value = value;
      }
      /**
     * Sets the noise texture.
     *
     * @deprecated Use noiseTexture instead.
     * @param {Number} value - The texture.
     */ setNoiseTexture(value) {
          this.uniforms.noiseTexture.value = value;
      }
      /**
     * The sample count.
     *
     * @type {Number}
     */ get samples() {
          return Number(this.defines.SAMPLES_INT);
      }
      set samples(value) {
          this.defines.SAMPLES_INT = value.toFixed(0);
          this.defines.INV_SAMPLES_FLOAT = (1 / value).toFixed(9);
          this.needsUpdate = true;
      }
      /**
     * Returns the amount of occlusion samples per pixel.
     *
     * @deprecated Use samples instead.
     * @return {Number} The sample count.
     */ getSamples() {
          return this.samples;
      }
      /**
     * Sets the amount of occlusion samples per pixel.
     *
     * @deprecated Use samples instead.
     * @param {Number} value - The sample count.
     */ setSamples(value) {
          this.samples = value;
      }
      /**
     * The sampling spiral ring count.
     *
     * @type {Number}
     */ get rings() {
          return Number(this.defines.SPIRAL_TURNS);
      }
      set rings(value) {
          this.defines.SPIRAL_TURNS = value.toFixed(1);
          this.needsUpdate = true;
      }
      /**
     * Returns the amount of spiral turns in the occlusion sampling pattern.
     *
     * @deprecated Use rings instead.
     * @return {Number} The radius.
     */ getRings() {
          return this.rings;
      }
      /**
     * Sets the amount of spiral turns in the occlusion sampling pattern.
     *
     * @deprecated Use rings instead.
     * @param {Number} value - The radius.
     */ setRings(value) {
          this.rings = value;
      }
      /**
     * The intensity.
     *
     * @type {Number}
     * @deprecated Use SSAOEffect.intensity instead.
     */ get intensity() {
          return this.uniforms.intensity.value;
      }
      set intensity(value) {
          this.uniforms.intensity.value = value;
          if (this.defines.LEGACY_INTENSITY === void 0) {
              this.defines.LEGACY_INTENSITY = "1";
              this.needsUpdate = true;
          }
      }
      /**
     * Returns the intensity.
     *
     * @deprecated Use SSAOEffect.intensity instead.
     * @return {Number} The intensity.
     */ getIntensity() {
          return this.uniforms.intensity.value;
      }
      /**
     * Sets the intensity.
     *
     * @deprecated Use SSAOEffect.intensity instead.
     * @param {Number} value - The intensity.
     */ setIntensity(value) {
          this.uniforms.intensity.value = value;
      }
      /**
     * The depth fade factor.
     *
     * @type {Number}
     */ get fade() {
          return this.uniforms.fade.value;
      }
      set fade(value) {
          this.uniforms.fade.value = value;
      }
      /**
     * Returns the depth fade factor.
     *
     * @deprecated Use fade instead.
     * @return {Number} The fade factor.
     */ getFade() {
          return this.uniforms.fade.value;
      }
      /**
     * Sets the depth fade factor.
     *
     * @deprecated Use fade instead.
     * @param {Number} value - The fade factor.
     */ setFade(value) {
          this.uniforms.fade.value = value;
      }
      /**
     * The depth bias. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get bias() {
          return this.uniforms.bias.value;
      }
      set bias(value) {
          this.uniforms.bias.value = value;
      }
      /**
     * Returns the depth bias.
     *
     * @deprecated Use bias instead.
     * @return {Number} The bias.
     */ getBias() {
          return this.uniforms.bias.value;
      }
      /**
     * Sets the depth bias.
     *
     * @deprecated Use bias instead.
     * @param {Number} value - The bias.
     */ setBias(value) {
          this.uniforms.bias.value = value;
      }
      /**
     * The minimum radius scale for distance scaling. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get minRadiusScale() {
          return this.uniforms.minRadiusScale.value;
      }
      set minRadiusScale(value) {
          this.uniforms.minRadiusScale.value = value;
      }
      /**
     * Returns the minimum radius scale for distance scaling.
     *
     * @deprecated Use minRadiusScale instead.
     * @return {Number} The minimum radius scale.
     */ getMinRadiusScale() {
          return this.uniforms.minRadiusScale.value;
      }
      /**
     * Sets the minimum radius scale for distance scaling.
     *
     * @deprecated Use minRadiusScale instead.
     * @param {Number} value - The minimum radius scale.
     */ setMinRadiusScale(value) {
          this.uniforms.minRadiusScale.value = value;
      }
      /**
     * Updates the absolute radius.
     *
     * @private
     */ updateRadius() {
          const radius = this.r * this.resolution.height;
          this.defines.RADIUS = radius.toFixed(11);
          this.defines.RADIUS_SQ = (radius * radius).toFixed(11);
          this.needsUpdate = true;
      }
      /**
     * The occlusion sampling radius. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get radius() {
          return this.r;
      }
      set radius(value) {
          this.r = Math.min(Math.max(value, 1e-6), 1);
          this.updateRadius();
      }
      /**
     * Returns the occlusion sampling radius.
     *
     * @deprecated Use radius instead.
     * @return {Number} The radius.
     */ getRadius() {
          return this.radius;
      }
      /**
     * Sets the occlusion sampling radius.
     *
     * @deprecated Use radius instead.
     * @param {Number} value - The radius. Range [1e-6, 1.0].
     */ setRadius(value) {
          this.radius = value;
      }
      /**
     * Indicates whether distance-based radius scaling is enabled.
     *
     * @type {Boolean}
     * @deprecated
     */ get distanceScaling() {
          return true;
      }
      set distanceScaling(value) {}
      /**
     * Indicates whether distance-based radius scaling is enabled.
     *
     * @deprecated
     * @return {Boolean} Whether distance scaling is enabled.
     */ isDistanceScalingEnabled() {
          return this.distanceScaling;
      }
      /**
     * Enables or disables distance-based radius scaling.
     *
     * @deprecated
     * @param {Boolean} value - Whether distance scaling should be enabled.
     */ setDistanceScalingEnabled(value) {
          this.distanceScaling = value;
      }
      /**
     * The occlusion distance threshold. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get distanceThreshold() {
          return this.uniforms.distanceCutoff.value.x;
      }
      set distanceThreshold(value) {
          this.uniforms.distanceCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.distanceFalloff, 0), 1));
      }
      /**
     * The occlusion distance threshold in world units.
     *
     * @type {Number}
     */ get worldDistanceThreshold() {
          return -orthographicDepthToViewZ(this.distanceThreshold, this.near, this.far);
      }
      set worldDistanceThreshold(value) {
          this.distanceThreshold = viewZToOrthographicDepth(-value, this.near, this.far);
      }
      /**
     * The occlusion distance falloff. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get distanceFalloff() {
          return this.uniforms.distanceCutoff.value.y - this.distanceThreshold;
      }
      set distanceFalloff(value) {
          this.uniforms.distanceCutoff.value.y = Math.min(Math.max(this.distanceThreshold + value, 0), 1);
      }
      /**
     * The occlusion distance falloff in world units.
     *
     * @type {Number}
     */ get worldDistanceFalloff() {
          return -orthographicDepthToViewZ(this.distanceFalloff, this.near, this.far);
      }
      set worldDistanceFalloff(value) {
          this.distanceFalloff = viewZToOrthographicDepth(-value, this.near, this.far);
      }
      /**
     * Sets the occlusion distance cutoff.
     *
     * @deprecated Use distanceThreshold and distanceFalloff instead.
     * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
     * @param {Number} falloff - The falloff. Range [0.0, 1.0].
     */ setDistanceCutoff(threshold, falloff) {
          this.uniforms.distanceCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
      }
      /**
     * The occlusion proximity threshold. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get proximityThreshold() {
          return this.uniforms.proximityCutoff.value.x;
      }
      set proximityThreshold(value) {
          this.uniforms.proximityCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.proximityFalloff, 0), 1));
      }
      /**
     * The occlusion proximity threshold in world units.
     *
     * @type {Number}
     */ get worldProximityThreshold() {
          return -orthographicDepthToViewZ(this.proximityThreshold, this.near, this.far);
      }
      set worldProximityThreshold(value) {
          this.proximityThreshold = viewZToOrthographicDepth(-value, this.near, this.far);
      }
      /**
     * The occlusion proximity falloff. Range: [0.0, 1.0].
     *
     * @type {Number}
     */ get proximityFalloff() {
          return this.uniforms.proximityCutoff.value.y - this.proximityThreshold;
      }
      set proximityFalloff(value) {
          this.uniforms.proximityCutoff.value.y = Math.min(Math.max(this.proximityThreshold + value, 0), 1);
      }
      /**
     * The occlusion proximity falloff in world units.
     *
     * @type {Number}
     */ get worldProximityFalloff() {
          return -orthographicDepthToViewZ(this.proximityFalloff, this.near, this.far);
      }
      set worldProximityFalloff(value) {
          this.proximityFalloff = viewZToOrthographicDepth(-value, this.near, this.far);
      }
      /**
     * Sets the occlusion proximity cutoff.
     *
     * @deprecated Use proximityThreshold and proximityFalloff instead.
     * @param {Number} threshold - The range threshold. Range [0.0, 1.0].
     * @param {Number} falloff - The falloff. Range [0.0, 1.0].
     */ setProximityCutoff(threshold, falloff) {
          this.uniforms.proximityCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
      }
      /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */ setTexelSize(x, y) {
          this.uniforms.texelSize.value.set(x, y);
      }
      /**
     * Copies the settings of the given camera.
     *
     * @deprecated Use copyCameraSettings instead.
     * @param {Camera} camera - A camera.
     */ adoptCameraSettings(camera) {
          this.copyCameraSettings(camera);
      }
      /**
     * Copies the settings of the given camera.
     *
     * @param {Camera} camera - A camera.
     */ copyCameraSettings(camera) {
          if (camera) {
              this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
              this.uniforms.projectionMatrix.value.copy(camera.projectionMatrix);
              this.uniforms.inverseProjectionMatrix.value.copy(camera.projectionMatrix).invert();
              if (camera instanceof three.PerspectiveCamera) {
                  this.defines.PERSPECTIVE_CAMERA = "1";
              } else {
                  delete this.defines.PERSPECTIVE_CAMERA;
              }
              this.needsUpdate = true;
          }
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const uniforms = this.uniforms;
          const noiseTexture = uniforms.noiseTexture.value;
          if (noiseTexture !== null) {
              uniforms.noiseScale.value.set(width / noiseTexture.image.width, height / noiseTexture.image.height);
          }
          uniforms.texelSize.value.set(1 / width, 1 / height);
          this.resolution.set(width, height);
          this.updateRadius();
      }
      /**
     * Constructs a new SSAO material.
     *
     * @param {Camera} camera - A camera.
     */ constructor(camera){
          super({
              name: "SSAOMaterial",
              defines: {
                  SAMPLES_INT: "0",
                  INV_SAMPLES_FLOAT: "0.0",
                  SPIRAL_TURNS: "0.0",
                  RADIUS: "1.0",
                  RADIUS_SQ: "1.0",
                  DISTANCE_SCALING: "1",
                  DEPTH_PACKING: "0"
              },
              uniforms: {
                  depthBuffer: new three.Uniform(null),
                  normalBuffer: new three.Uniform(null),
                  normalDepthBuffer: new three.Uniform(null),
                  noiseTexture: new three.Uniform(null),
                  inverseProjectionMatrix: new three.Uniform(new three.Matrix4()),
                  projectionMatrix: new three.Uniform(new three.Matrix4()),
                  texelSize: new three.Uniform(new three.Vector2()),
                  cameraNearFar: new three.Uniform(new three.Vector2()),
                  distanceCutoff: new three.Uniform(new three.Vector2()),
                  proximityCutoff: new three.Uniform(new three.Vector2()),
                  noiseScale: new three.Uniform(new three.Vector2()),
                  minRadiusScale: new three.Uniform(0.33),
                  intensity: new three.Uniform(1),
                  fade: new three.Uniform(0.01),
                  bias: new three.Uniform(0)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: ssao_default,
              vertexShader: ssao_default2
          });
          this.copyCameraSettings(camera);
          this.resolution = new three.Vector2();
          this.r = 1;
      }
  };
  // src/materials/glsl/depth-downsampling.frag
  var depth_downsampling_default = `#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
#ifdef DOWNSAMPLE_NORMALS
uniform lowp sampler2D normalBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}int findBestDepth(const in float samples[4]){float c=(samples[0]+samples[1]+samples[2]+samples[3])*0.25;float distances[4];distances[0]=abs(c-samples[0]);distances[1]=abs(c-samples[1]);distances[2]=abs(c-samples[2]);distances[3]=abs(c-samples[3]);float maxDistance=max(max(distances[0],distances[1]),max(distances[2],distances[3]));int remaining[3];int rejected[3];int i,j,k;for(i=0,j=0,k=0;i<4;++i){if(distances[i]<maxDistance){remaining[j++]=i;}else{rejected[k++]=i;}}for(;j<3;++j){remaining[j]=rejected[--k];}vec3 s=vec3(samples[remaining[0]],samples[remaining[1]],samples[remaining[2]]);c=(s.x+s.y+s.z)/3.0;distances[0]=abs(c-s.x);distances[1]=abs(c-s.y);distances[2]=abs(c-s.z);float minDistance=min(distances[0],min(distances[1],distances[2]));for(i=0;i<3;++i){if(distances[i]==minDistance){break;}}return remaining[i];}void main(){float d[4];d[0]=readDepth(vUv0);d[1]=readDepth(vUv1);d[2]=readDepth(vUv2);d[3]=readDepth(vUv3);int index=findBestDepth(d);
#ifdef DOWNSAMPLE_NORMALS
vec3 n[4];n[0]=texture2D(normalBuffer,vUv0).rgb;n[1]=texture2D(normalBuffer,vUv1).rgb;n[2]=texture2D(normalBuffer,vUv2).rgb;n[3]=texture2D(normalBuffer,vUv3).rgb;
#else
vec3 n[4];n[0]=vec3(0.0);n[1]=vec3(0.0);n[2]=vec3(0.0);n[3]=vec3(0.0);
#endif
gl_FragColor=vec4(n[index],d[index]);}`;
  // src/materials/glsl/depth-downsampling.vert
  var depth_downsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=uv;vUv1=vec2(uv.x,uv.y+texelSize.y);vUv2=vec2(uv.x+texelSize.x,uv.y);vUv3=uv+texelSize;gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/DepthDownsamplingMaterial.js
  var DepthDownsamplingMaterial = class extends three.ShaderMaterial {
      /**
     * The depth buffer.
     *
     * @type {Texture}
     */ set depthBuffer(value) {
          this.uniforms.depthBuffer.value = value;
      }
      /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ set depthPacking(value) {
          this.defines.DEPTH_PACKING = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer = buffer;
          this.depthPacking = depthPacking;
      }
      /**
     * The normal buffer.
     *
     * @type {Texture}
     */ set normalBuffer(value) {
          this.uniforms.normalBuffer.value = value;
          if (value !== null) {
              this.defines.DOWNSAMPLE_NORMALS = "1";
          } else {
              delete this.defines.DOWNSAMPLE_NORMALS;
          }
          this.needsUpdate = true;
      }
      /**
     * Sets the normal buffer.
     *
     * @deprecated Use normalBuffer instead.
     * @param {Texture} value - The normal buffer.
     */ setNormalBuffer(value) {
          this.normalBuffer = value;
      }
      /**
     * Sets the texel size.
     *
     * @deprecated Use setSize() instead.
     * @param {Number} x - The texel width.
     * @param {Number} y - The texel height.
     */ setTexelSize(x, y) {
          this.uniforms.texelSize.value.set(x, y);
      }
      /**
     * Sets the size of this object.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.uniforms.texelSize.value.set(1 / width, 1 / height);
      }
      /**
     * Constructs a new depth downsampling material.
     */ constructor(){
          super({
              name: "DepthDownsamplingMaterial",
              defines: {
                  DEPTH_PACKING: "0"
              },
              uniforms: {
                  depthBuffer: new three.Uniform(null),
                  normalBuffer: new three.Uniform(null),
                  texelSize: new three.Uniform(new three.Vector2())
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: depth_downsampling_default,
              vertexShader: depth_downsampling_default2
          });
      }
  };
  // src/passes/DepthDownsamplingPass.js
  var DepthDownsamplingPass = class extends Pass {
      /**
     * The normal(RGB) + depth(A) texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the normal(RGB) + depth(A) texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {
          this.fullscreenMaterial.depthBuffer = depthTexture;
          this.fullscreenMaterial.depthPacking = depthPacking;
      }
      /**
     * Downsamples depth and scene normals.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
          renderer.render(this.scene, this.camera);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          this.renderTarget.setSize(resolution.width, resolution.height);
          this.fullscreenMaterial.setSize(width, height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          const gl = renderer.getContext();
          const renderable = gl.getExtension("EXT_color_buffer_float") || gl.getExtension("EXT_color_buffer_half_float");
          if (!renderable) {
              throw new Error("Rendering to float texture is not supported.");
          }
      }
      /**
     * Constructs a new depth downsampling pass.
     *
     * @param {Object} [options] - The options.
     * @param {Texture} [options.normalBuffer=null] - A texture that contains view space normals. See {@link NormalPass}.
     * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor({ normalBuffer = null, resolutionScale = 0.5, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("DepthDownsamplingPass");
          const material = new DepthDownsamplingMaterial();
          material.normalBuffer = normalBuffer;
          this.fullscreenMaterial = material;
          this.needsDepthTexture = true;
          this.needsSwap = false;
          this.renderTarget = new three.WebGLRenderTarget(1, 1, {
              minFilter: three.NearestFilter,
              magFilter: three.NearestFilter,
              depthBuffer: false,
              type: three.FloatType
          });
          this.renderTarget.texture.name = "DepthDownsamplingPass.Target";
          this.renderTarget.texture.generateMipmaps = false;
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
      }
  };
  // src/effects/glsl/ssao.frag
  var ssao_default3 = `uniform lowp sampler2D aoBuffer;uniform float luminanceInfluence;uniform float intensity;
#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH)
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
#endif
#ifdef COLORIZE
uniform vec3 color;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){float aoLinear=texture2D(aoBuffer,uv).r;
#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH) && __VERSION__ == 300
vec4 normalDepth[4];normalDepth[0]=textureOffset(normalDepthBuffer,uv,ivec2(0,0));normalDepth[1]=textureOffset(normalDepthBuffer,uv,ivec2(0,1));normalDepth[2]=textureOffset(normalDepthBuffer,uv,ivec2(1,0));normalDepth[3]=textureOffset(normalDepthBuffer,uv,ivec2(1,1));float dot01=dot(normalDepth[0].rgb,normalDepth[1].rgb);float dot02=dot(normalDepth[0].rgb,normalDepth[2].rgb);float dot03=dot(normalDepth[0].rgb,normalDepth[3].rgb);float minDot=min(dot01,min(dot02,dot03));float s=step(THRESHOLD,minDot);float smallestDistance=1.0;int index;for(int i=0;i<4;++i){float distance=abs(depth-normalDepth[i].a);if(distance<smallestDistance){smallestDistance=distance;index=i;}}ivec2 offsets[4];offsets[0]=ivec2(0,0);offsets[1]=ivec2(0,1);offsets[2]=ivec2(1,0);offsets[3]=ivec2(1,1);ivec2 coord=ivec2(uv*vec2(textureSize(aoBuffer,0)))+offsets[index];float aoNearest=texelFetch(aoBuffer,coord,0).r;float ao=mix(aoNearest,aoLinear,s);
#else
float ao=aoLinear;
#endif
float l=luminance(inputColor.rgb);ao=mix(ao,0.0,l*luminanceInfluence);ao=clamp(ao*intensity,0.0,1.0);
#ifdef COLORIZE
outputColor=vec4(1.0-ao*(1.0-color),inputColor.a);
#else
outputColor=vec4(vec3(1.0-ao),inputColor.a);
#endif
}`;
  // src/effects/SSAOEffect.js
  var NOISE_TEXTURE_SIZE = 64;
  var SSAOEffect = class extends Effect {
      set mainCamera(value) {
          this.camera = value;
          this.ssaoMaterial.copyCameraSettings(value);
      }
      /**
     * Sets the normal buffer.
     *
     * @type {Texture}
     */ get normalBuffer() {
          return this.ssaoMaterial.normalBuffer;
      }
      set normalBuffer(value) {
          this.ssaoMaterial.normalBuffer = value;
          this.depthDownsamplingPass.fullscreenMaterial.normalBuffer = value;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * The SSAO material.
     *
     * @type {SSAOMaterial}
     */ get ssaoMaterial() {
          return this.ssaoPass.fullscreenMaterial;
      }
      /**
     * Returns the SSAO material.
     *
     * @deprecated Use ssaoMaterial instead.
     * @return {SSAOMaterial} The material.
     */ getSSAOMaterial() {
          return this.ssaoMaterial;
      }
      /**
     * The amount of occlusion samples per pixel.
     *
     * @type {Number}
     * @deprecated Use ssaoMaterial.samples instead.
     */ get samples() {
          return this.ssaoMaterial.samples;
      }
      set samples(value) {
          this.ssaoMaterial.samples = value;
      }
      /**
     * The amount of spiral turns in the occlusion sampling pattern.
     *
     * @type {Number}
     * @deprecated Use ssaoMaterial.rings instead.
     */ get rings() {
          return this.ssaoMaterial.rings;
      }
      set rings(value) {
          this.ssaoMaterial.rings = value;
      }
      /**
     * The occlusion sampling radius.
     *
     * @type {Number}
     * @deprecated Use ssaoMaterial.radius instead.
     */ get radius() {
          return this.ssaoMaterial.radius;
      }
      set radius(value) {
          this.ssaoMaterial.radius = value;
      }
      /**
     * Indicates whether depth-aware upsampling is enabled.
     *
     * @type {Boolean}
     */ get depthAwareUpsampling() {
          return this.defines.has("DEPTH_AWARE_UPSAMPLING");
      }
      set depthAwareUpsampling(value) {
          if (this.depthAwareUpsampling !== value) {
              if (value) {
                  this.defines.set("DEPTH_AWARE_UPSAMPLING", "1");
              } else {
                  this.defines.delete("DEPTH_AWARE_UPSAMPLING");
              }
              this.setChanged();
          }
      }
      /**
     * Indicates whether depth-aware upsampling is enabled.
     *
     * @deprecated Use depthAwareUpsampling instead.
     * @return {Boolean} Whether depth-aware upsampling is enabled.
     */ isDepthAwareUpsamplingEnabled() {
          return this.depthAwareUpsampling;
      }
      /**
     * Enables or disables depth-aware upsampling.
     *
     * @deprecated Use depthAwareUpsampling instead.
     * @param {Boolean} value - Whether depth-aware upsampling should be enabled.
     */ setDepthAwareUpsamplingEnabled(value) {
          this.depthAwareUpsampling = value;
      }
      /**
     * Indicates whether distance-based radius scaling is enabled.
     *
     * @type {Boolean}
     * @deprecated
     */ get distanceScaling() {
          return true;
      }
      set distanceScaling(value) {}
      /**
     * The color of the ambient occlusion. Set to `null` to disable.
     *
     * @type {Color}
     */ get color() {
          return this.uniforms.get("color").value;
      }
      set color(value) {
          const uniforms = this.uniforms;
          const defines = this.defines;
          if (value !== null) {
              if (defines.has("COLORIZE")) {
                  uniforms.get("color").value.set(value);
              } else {
                  defines.set("COLORIZE", "1");
                  uniforms.get("color").value = new three.Color(value);
                  this.setChanged();
              }
          } else if (defines.has("COLORIZE")) {
              defines.delete("COLORIZE");
              uniforms.get("color").value = null;
              this.setChanged();
          }
      }
      /**
     * The luminance influence factor. Range: [0.0, 1.0].
     *
     * @type {Boolean}
     */ get luminanceInfluence() {
          return this.uniforms.get("luminanceInfluence").value;
      }
      set luminanceInfluence(value) {
          this.uniforms.get("luminanceInfluence").value = value;
      }
      /**
     * The intensity.
     *
     * @type {Number}
     */ get intensity() {
          return this.uniforms.get("intensity").value;
      }
      set intensity(value) {
          this.uniforms.get("intensity").value = value;
      }
      /**
     * Returns the color of the ambient occlusion.
     *
     * @deprecated Use color instead.
     * @return {Color} The color.
     */ getColor() {
          return this.color;
      }
      /**
     * Sets the color of the ambient occlusion. Set to `null` to disable colorization.
     *
     * @deprecated Use color instead.
     * @param {Color} value - The color.
     */ setColor(value) {
          this.color = value;
      }
      /**
     * Sets the occlusion distance cutoff.
     *
     * @deprecated Use ssaoMaterial instead.
     * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
     * @param {Number} falloff - The falloff. Range [0.0, 1.0].
     */ setDistanceCutoff(threshold, falloff) {
          this.ssaoMaterial.distanceThreshold = threshold;
          this.ssaoMaterial.distanceFalloff = falloff;
      }
      /**
     * Sets the occlusion proximity cutoff.
     *
     * @deprecated Use ssaoMaterial instead.
     * @param {Number} threshold - The proximity threshold. Range [0.0, 1.0].
     * @param {Number} falloff - The falloff. Range [0.0, 1.0].
     */ setProximityCutoff(threshold, falloff) {
          this.ssaoMaterial.proximityThreshold = threshold;
          this.ssaoMaterial.proximityFalloff = falloff;
      }
      /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {
          this.depthDownsamplingPass.setDepthTexture(depthTexture, depthPacking);
          this.ssaoMaterial.depthBuffer = depthTexture;
          this.ssaoMaterial.depthPacking = depthPacking;
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          const renderTarget = this.renderTarget;
          if (this.depthDownsamplingPass.enabled) {
              this.depthDownsamplingPass.render(renderer);
          }
          this.ssaoPass.render(renderer, null, renderTarget);
      }
      /**
     * Sets the size.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          const w = resolution.width, h = resolution.height;
          this.ssaoMaterial.copyCameraSettings(this.camera);
          this.ssaoMaterial.setSize(w, h);
          this.renderTarget.setSize(w, h);
          this.depthDownsamplingPass.resolution.scale = resolution.scale;
          this.depthDownsamplingPass.setSize(width, height);
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          try {
              let normalDepthBuffer = this.uniforms.get("normalDepthBuffer").value;
              if (normalDepthBuffer === null) {
                  this.depthDownsamplingPass.initialize(renderer, alpha, frameBufferType);
                  normalDepthBuffer = this.depthDownsamplingPass.texture;
                  this.uniforms.get("normalDepthBuffer").value = normalDepthBuffer;
                  this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
                  this.defines.set("NORMAL_DEPTH", "1");
              }
          } catch (e) {
              this.depthDownsamplingPass.enabled = false;
          }
      }
      /**
     * Constructs a new SSAO effect.
     *
     * @todo Move normalBuffer to options.
     * @param {Camera} [camera] - The main camera.
     * @param {Texture} [normalBuffer] - A texture that contains the scene normals.
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.MULTIPLY] - The blend function of this effect.
     * @param {Boolean} [options.distanceScaling=true] - Deprecated.
     * @param {Boolean} [options.depthAwareUpsampling=true] - Enables or disables depth-aware upsampling. Has no effect if WebGL 2 is not supported.
     * @param {Texture} [options.normalDepthBuffer=null] - Deprecated.
     * @param {Number} [options.samples=9] - The amount of samples per pixel. Should not be a multiple of the ring count.
     * @param {Number} [options.rings=7] - The amount of spiral turns in the occlusion sampling pattern. Should be a prime number.
     * @param {Number} [options.worldDistanceThreshold] - The world distance threshold at which the occlusion effect starts to fade out.
     * @param {Number} [options.worldDistanceFalloff] - The world distance falloff. Influences the smoothness of the occlusion cutoff.
     * @param {Number} [options.worldProximityThreshold] - The world proximity threshold at which the occlusion starts to fade out.
     * @param {Number} [options.worldProximityFalloff] - The world proximity falloff. Influences the smoothness of the proximity cutoff.
     * @param {Number} [options.distanceThreshold=0.97] - Deprecated.
     * @param {Number} [options.distanceFalloff=0.03] - Deprecated.
     * @param {Number} [options.rangeThreshold=0.0005] - Deprecated.
     * @param {Number} [options.rangeFalloff=0.001] - Deprecated.
     * @param {Number} [options.minRadiusScale=0.1] - The minimum radius scale.
     * @param {Number} [options.luminanceInfluence=0.7] - Determines how much the luminance of the scene influences the ambient occlusion.
     * @param {Number} [options.radius=0.1825] - The occlusion sampling radius, expressed as a scale relative to the resolution. Range [1e-6, 1.0].
     * @param {Number} [options.intensity=1.0] - The intensity of the ambient occlusion.
     * @param {Number} [options.bias=0.025] - An occlusion bias. Eliminates artifacts caused by depth discontinuities.
     * @param {Number} [options.fade=0.01] - Influences the smoothness of the shadows. A lower value results in higher contrast.
     * @param {Color} [options.color=null] - The color of the ambient occlusion.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor(camera, normalBuffer, { blendFunction = BlendFunction.MULTIPLY, samples = 9, rings = 7, normalDepthBuffer = null, depthAwareUpsampling = true, worldDistanceThreshold, worldDistanceFalloff, worldProximityThreshold, worldProximityFalloff, distanceThreshold = 0.97, distanceFalloff = 0.03, rangeThreshold = 5e-4, rangeFalloff = 1e-3, minRadiusScale = 0.1, luminanceInfluence = 0.7, radius = 0.1825, intensity = 1, bias = 0.025, fade = 0.01, color: color2 = null, resolutionScale = 1, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("SSAOEffect", ssao_default3, {
              blendFunction,
              attributes: EffectAttribute.DEPTH,
              defines: /* @__PURE__ */ new Map([
                  [
                      "THRESHOLD",
                      "0.997"
                  ]
              ]),
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "aoBuffer",
                      new three.Uniform(null)
                  ],
                  [
                      "normalDepthBuffer",
                      new three.Uniform(normalDepthBuffer)
                  ],
                  [
                      "luminanceInfluence",
                      new three.Uniform(luminanceInfluence)
                  ],
                  [
                      "color",
                      new three.Uniform(null)
                  ],
                  [
                      "intensity",
                      new three.Uniform(intensity)
                  ],
                  [
                      "scale",
                      new three.Uniform(0)
                  ]
              ])
          });
          this.renderTarget = new three.WebGLRenderTarget(1, 1, {
              depthBuffer: false
          });
          this.renderTarget.texture.name = "AO.Target";
          this.uniforms.get("aoBuffer").value = this.renderTarget.texture;
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
          this.camera = camera;
          this.depthDownsamplingPass = new DepthDownsamplingPass({
              normalBuffer,
              resolutionScale
          });
          this.depthDownsamplingPass.enabled = normalDepthBuffer === null;
          this.ssaoPass = new ShaderPass(new SSAOMaterial(camera));
          const noiseTexture = new NoiseTexture(NOISE_TEXTURE_SIZE, NOISE_TEXTURE_SIZE, three.RGBAFormat);
          noiseTexture.wrapS = noiseTexture.wrapT = three.RepeatWrapping;
          const ssaoMaterial = this.ssaoMaterial;
          ssaoMaterial.normalBuffer = normalBuffer;
          ssaoMaterial.noiseTexture = noiseTexture;
          ssaoMaterial.minRadiusScale = minRadiusScale;
          ssaoMaterial.samples = samples;
          ssaoMaterial.radius = radius;
          ssaoMaterial.rings = rings;
          ssaoMaterial.fade = fade;
          ssaoMaterial.bias = bias;
          ssaoMaterial.distanceThreshold = distanceThreshold;
          ssaoMaterial.distanceFalloff = distanceFalloff;
          ssaoMaterial.proximityThreshold = rangeThreshold;
          ssaoMaterial.proximityFalloff = rangeFalloff;
          if (worldDistanceThreshold !== void 0) {
              ssaoMaterial.worldDistanceThreshold = worldDistanceThreshold;
          }
          if (worldDistanceFalloff !== void 0) {
              ssaoMaterial.worldDistanceFalloff = worldDistanceFalloff;
          }
          if (worldProximityThreshold !== void 0) {
              ssaoMaterial.worldProximityThreshold = worldProximityThreshold;
          }
          if (worldProximityFalloff !== void 0) {
              ssaoMaterial.worldProximityFalloff = worldProximityFalloff;
          }
          if (normalDepthBuffer !== null) {
              this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
              this.defines.set("NORMAL_DEPTH", "1");
          }
          this.depthAwareUpsampling = depthAwareUpsampling;
          this.color = color2;
      }
  };
  // src/materials/glsl/adaptive-luminance.frag
  var adaptive_luminance_default = `#include <packing>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
uniform lowp sampler2D luminanceBuffer0;uniform lowp sampler2D luminanceBuffer1;uniform float minLuminance;uniform float deltaTime;uniform float tau;varying vec2 vUv;void main(){float l0=unpackRGBAToFloat(texture2D(luminanceBuffer0,vUv));
#if __VERSION__ < 300
float l1=texture2DLodEXT(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;
#else
float l1=textureLod(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;
#endif
l0=max(minLuminance,l0);l1=max(minLuminance,l1);float adaptedLum=l0+(l1-l0)*(1.0-exp(-deltaTime*tau));gl_FragColor=(adaptedLum==1.0)?vec4(1.0):packFloatToRGBA(adaptedLum);}`;
  // src/materials/AdaptiveLuminanceMaterial.js
  var AdaptiveLuminanceMaterial = class extends three.ShaderMaterial {
      /**
     * The primary luminance buffer that contains the downsampled average luminance.
     *
     * @type {Texture}
     */ set luminanceBuffer0(value) {
          this.uniforms.luminanceBuffer0.value = value;
      }
      /**
     * Sets the primary luminance buffer that contains the downsampled average luminance.
     *
     * @deprecated Use luminanceBuffer0 instead.
     * @param {Texture} value - The buffer.
     */ setLuminanceBuffer0(value) {
          this.uniforms.luminanceBuffer0.value = value;
      }
      /**
     * The secondary luminance buffer.
     *
     * @type {Texture}
     */ set luminanceBuffer1(value) {
          this.uniforms.luminanceBuffer1.value = value;
      }
      /**
     * Sets the secondary luminance buffer.
     *
     * @deprecated Use luminanceBuffer1 instead.
     * @param {Texture} value - The buffer.
     */ setLuminanceBuffer1(value) {
          this.uniforms.luminanceBuffer1.value = value;
      }
      /**
     * The 1x1 mipmap level.
     *
     * This level is used to identify the smallest mipmap of the primary luminance buffer.
     *
     * @type {Number}
     */ set mipLevel1x1(value) {
          this.defines.MIP_LEVEL_1X1 = value.toFixed(1);
          this.needsUpdate = true;
      }
      /**
     * Sets the 1x1 mipmap level.
     *
     * @deprecated Use mipLevel1x1 instead.
     * @param {Number} value - The level.
     */ setMipLevel1x1(value) {
          this.mipLevel1x1 = value;
      }
      /**
     * The delta time.
     *
     * @type {Number}
     */ set deltaTime(value) {
          this.uniforms.deltaTime.value = value;
      }
      /**
     * Sets the delta time.
     *
     * @deprecated Use deltaTime instead.
     * @param {Number} value - The delta time.
     */ setDeltaTime(value) {
          this.uniforms.deltaTime.value = value;
      }
      /**
     * The lowest possible luminance value.
     *
     * @type {Number}
     */ get minLuminance() {
          return this.uniforms.minLuminance.value;
      }
      set minLuminance(value) {
          this.uniforms.minLuminance.value = value;
      }
      /**
     * Returns the lowest possible luminance value.
     *
     * @deprecated Use minLuminance instead.
     * @return {Number} The minimum luminance.
     */ getMinLuminance() {
          return this.uniforms.minLuminance.value;
      }
      /**
     * Sets the minimum luminance.
     *
     * @deprecated Use minLuminance instead.
     * @param {Number} value - The minimum luminance.
     */ setMinLuminance(value) {
          this.uniforms.minLuminance.value = value;
      }
      /**
     * The luminance adaptation rate.
     *
     * @type {Number}
     */ get adaptationRate() {
          return this.uniforms.tau.value;
      }
      set adaptationRate(value) {
          this.uniforms.tau.value = value;
      }
      /**
     * Returns the luminance adaptation rate.
     *
     * @deprecated Use adaptationRate instead.
     * @return {Number} The adaptation rate.
     */ getAdaptationRate() {
          return this.uniforms.tau.value;
      }
      /**
     * Sets the luminance adaptation rate.
     *
     * @deprecated Use adaptationRate instead.
     * @param {Number} value - The adaptation rate.
     */ setAdaptationRate(value) {
          this.uniforms.tau.value = value;
      }
      /**
     * Constructs a new adaptive luminance material.
     */ constructor(){
          super({
              name: "AdaptiveLuminanceMaterial",
              defines: {
                  MIP_LEVEL_1X1: "0.0"
              },
              uniforms: {
                  luminanceBuffer0: new three.Uniform(null),
                  luminanceBuffer1: new three.Uniform(null),
                  minLuminance: new three.Uniform(0.01),
                  deltaTime: new three.Uniform(0),
                  tau: new three.Uniform(1)
              },
              extensions: {
                  shaderTextureLOD: true
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              fragmentShader: adaptive_luminance_default,
              vertexShader: common_default
          });
      }
  };
  // src/passes/AdaptiveLuminancePass.js
  var AdaptiveLuminancePass = class extends Pass {
      /**
     * The adaptive luminance texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTargetAdapted.texture;
      }
      /**
     * Returns the adaptive 1x1 luminance texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTargetAdapted.texture;
      }
      /**
     * Sets the 1x1 mipmap level.
     *
     * This level is used to identify the smallest mipmap of the main luminance texture which contains the downsampled
     * average scene luminance.
     *
     * @type {Number}
     * @deprecated Use fullscreenMaterial.mipLevel1x1 instead.
     */ set mipLevel1x1(value) {
          this.fullscreenMaterial.mipLevel1x1 = value;
      }
      /**
     * The luminance adaptation rate.
     *
     * @type {Number}
     * @deprecated Use fullscreenMaterial.adaptationRate instead.
     */ get adaptationRate() {
          return this.fullscreenMaterial.adaptationRate;
      }
      /**
     * @type {Number}
     * @deprecated Use fullscreenMaterial.adaptationRate instead.
     */ set adaptationRate(value) {
          this.fullscreenMaterial.adaptationRate = value;
      }
      /**
     * Renders the scene normals.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          this.fullscreenMaterial.deltaTime = deltaTime;
          renderer.setRenderTarget(this.renderToScreen ? null : this.renderTargetAdapted);
          renderer.render(this.scene, this.camera);
          this.copyPass.render(renderer, this.renderTargetAdapted);
      }
      /**
     * Constructs a new adaptive luminance pass.
     *
     * @param {Texture} luminanceBuffer - A buffer that contains the current scene luminance.
     * @param {Object} [options] - The options.
     * @param {Number} [options.minLuminance=0.01] - The minimum luminance.
     * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
     */ constructor(luminanceBuffer, { minLuminance = 0.01, adaptationRate = 1 } = {}){
          super("AdaptiveLuminancePass");
          this.fullscreenMaterial = new AdaptiveLuminanceMaterial();
          this.needsSwap = false;
          this.renderTargetPrevious = new three.WebGLRenderTarget(1, 1, {
              minFilter: three.NearestFilter,
              magFilter: three.NearestFilter,
              depthBuffer: false
          });
          this.renderTargetPrevious.texture.name = "Luminance.Previous";
          const material = this.fullscreenMaterial;
          material.luminanceBuffer0 = this.renderTargetPrevious.texture;
          material.luminanceBuffer1 = luminanceBuffer;
          material.minLuminance = minLuminance;
          material.adaptationRate = adaptationRate;
          this.renderTargetAdapted = this.renderTargetPrevious.clone();
          this.renderTargetAdapted.texture.name = "Luminance.Adapted";
          this.copyPass = new CopyPass(this.renderTargetPrevious, false);
      }
  };
  // src/effects/glsl/tone-mapping.frag
  var tone_mapping_default = `#include <tonemapping_pars_fragment>
uniform float whitePoint;
#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3
uniform float middleGrey;
#if TONE_MAPPING_MODE == 3
uniform lowp sampler2D luminanceBuffer;
#else
uniform float averageLuminance;
#endif
vec3 Reinhard2ToneMapping(vec3 color){color*=toneMappingExposure;float l=luminance(color);
#if TONE_MAPPING_MODE == 3
float lumAvg=unpackRGBAToFloat(texture2D(luminanceBuffer,vec2(0.5)));
#else
float lumAvg=averageLuminance;
#endif
float lumScaled=(l*middleGrey)/max(lumAvg,1e-6);float lumCompressed=lumScaled*(1.0+lumScaled/(whitePoint*whitePoint));lumCompressed/=(1.0+lumScaled);return clamp(lumCompressed*color,0.0,1.0);}
#elif TONE_MAPPING_MODE == 4
#define A 0.15
#define B 0.50
#define C 0.10
#define D 0.20
#define E 0.02
#define F 0.30
vec3 Uncharted2Helper(const in vec3 x){return((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}vec3 Uncharted2ToneMapping(vec3 color){color*=toneMappingExposure;return clamp(Uncharted2Helper(color)/Uncharted2Helper(vec3(whitePoint)),0.0,1.0);}
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){
#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3
outputColor=vec4(Reinhard2ToneMapping(inputColor.rgb),inputColor.a);
#elif TONE_MAPPING_MODE == 4
outputColor=vec4(Uncharted2ToneMapping(inputColor.rgb),inputColor.a);
#else
outputColor=vec4(toneMapping(inputColor.rgb),inputColor.a);
#endif
}`;
  // src/effects/ToneMappingEffect.js
  var ToneMappingEffect = class extends Effect {
      /**
     * The tone mapping mode.
     *
     * @type {ToneMappingMode}
     */ get mode() {
          return Number(this.defines.get("TONE_MAPPING_MODE"));
      }
      set mode(value) {
          if (this.mode === value) {
              return;
          }
          const revision = three.REVISION.replace(/\D+/g, "");
          const cineonToneMapping = revision >= 168 ? "CineonToneMapping(texel)" : "OptimizedCineonToneMapping(texel)";
          this.defines.clear();
          this.defines.set("TONE_MAPPING_MODE", value.toFixed(0));
          switch(value){
              case ToneMappingMode.LINEAR:
                  this.defines.set("toneMapping(texel)", "LinearToneMapping(texel)");
                  break;
              case ToneMappingMode.REINHARD:
                  this.defines.set("toneMapping(texel)", "ReinhardToneMapping(texel)");
                  break;
              case ToneMappingMode.CINEON:
              case ToneMappingMode.OPTIMIZED_CINEON:
                  this.defines.set("toneMapping(texel)", cineonToneMapping);
                  break;
              case ToneMappingMode.ACES_FILMIC:
                  this.defines.set("toneMapping(texel)", "ACESFilmicToneMapping(texel)");
                  break;
              case ToneMappingMode.AGX:
                  this.defines.set("toneMapping(texel)", "AgXToneMapping(texel)");
                  break;
              case ToneMappingMode.NEUTRAL:
                  this.defines.set("toneMapping(texel)", "NeutralToneMapping(texel)");
                  break;
              default:
                  this.defines.set("toneMapping(texel)", "texel");
                  break;
          }
          this.adaptiveLuminancePass.enabled = value === ToneMappingMode.REINHARD2_ADAPTIVE;
          this.setChanged();
      }
      /**
     * Returns the current tone mapping mode.
     *
     * @deprecated Use mode instead.
     * @return {ToneMappingMode} The tone mapping mode.
     */ getMode() {
          return this.mode;
      }
      /**
     * Sets the tone mapping mode.
     *
     * @deprecated Use mode instead.
     * @param {ToneMappingMode} value - The tone mapping mode.
     */ setMode(value) {
          this.mode = value;
      }
      /**
     * The white point. Default is `4.0`.
     *
     * Only applies to Reinhard2 (Modified & Adaptive).
     *
     * @type {Number}
     */ get whitePoint() {
          return this.uniforms.get("whitePoint").value;
      }
      set whitePoint(value) {
          this.uniforms.get("whitePoint").value = value;
      }
      /**
     * The middle grey factor. Default is `0.6`.
     *
     * Only applies to Reinhard2 (Modified & Adaptive).
     *
     * @type {Number}
     */ get middleGrey() {
          return this.uniforms.get("middleGrey").value;
      }
      set middleGrey(value) {
          this.uniforms.get("middleGrey").value = value;
      }
      /**
     * The average luminance.
     *
     * Only applies to Reinhard2 (Modified).
     *
     * @type {Number}
     */ get averageLuminance() {
          return this.uniforms.get("averageLuminance").value;
      }
      set averageLuminance(value) {
          this.uniforms.get("averageLuminance").value = value;
      }
      /**
     * The adaptive luminance material.
     *
     * @type {AdaptiveLuminanceMaterial}
     */ get adaptiveLuminanceMaterial() {
          return this.adaptiveLuminancePass.fullscreenMaterial;
      }
      /**
     * Returns the adaptive luminance material.
     *
     * @deprecated Use adaptiveLuminanceMaterial instead.
     * @return {AdaptiveLuminanceMaterial} The material.
     */ getAdaptiveLuminanceMaterial() {
          return this.adaptiveLuminanceMaterial;
      }
      /**
     * The resolution of the luminance texture. Must be a power of two.
     *
     * @type {Number}
     */ get resolution() {
          return this.luminancePass.resolution.width;
      }
      set resolution(value) {
          const exponent = Math.max(0, Math.ceil(Math.log2(value)));
          const size = Math.pow(2, exponent);
          this.luminancePass.resolution.setPreferredSize(size, size);
          this.adaptiveLuminanceMaterial.mipLevel1x1 = exponent;
      }
      /**
     * Returns the resolution of the luminance texture.
     *
     * @deprecated Use resolution instead.
     * @return {Number} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Sets the resolution of the luminance texture. Must be a power of two.
     *
     * @deprecated Use resolution instead.
     * @param {Number} value - The resolution.
     */ setResolution(value) {
          this.resolution = value;
      }
      /**
     * Indicates whether this pass uses adaptive luminance.
     *
     * @type {Boolean}
     * @deprecated Use mode instead.
     */ get adaptive() {
          return this.mode === ToneMappingMode.REINHARD2_ADAPTIVE;
      }
      set adaptive(value) {
          this.mode = value ? ToneMappingMode.REINHARD2_ADAPTIVE : ToneMappingMode.REINHARD2;
      }
      /**
     * The luminance adaptation rate.
     *
     * @type {Number}
     * @deprecated Use adaptiveLuminanceMaterial.adaptationRate instead.
     */ get adaptationRate() {
          return this.adaptiveLuminanceMaterial.adaptationRate;
      }
      set adaptationRate(value) {
          this.adaptiveLuminanceMaterial.adaptationRate = value;
      }
      /**
     * @type {Number}
     * @deprecated
     */ get distinction() {
          console.warn(this.name, "distinction was removed.");
          return 1;
      }
      set distinction(value) {
          console.warn(this.name, "distinction was removed.");
      }
      /**
     * Updates this effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     */ update(renderer, inputBuffer, deltaTime) {
          if (this.adaptiveLuminancePass.enabled) {
              this.luminancePass.render(renderer, inputBuffer);
              this.adaptiveLuminancePass.render(renderer, null, null, deltaTime);
          }
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          this.adaptiveLuminancePass.initialize(renderer, alpha, frameBufferType);
      }
      /**
     * Constructs a new tone mapping effect.
     *
     * The additional parameters only affect the Reinhard2 operator.
     *
     * @param {Object} [options] - The options.
     * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
     * @param {Boolean} [options.adaptive=false] - Deprecated. Use mode instead.
     * @param {ToneMappingMode} [options.mode=ToneMappingMode.AGX] - The tone mapping mode.
     * @param {Number} [options.resolution=256] - The resolution of the luminance texture. Must be a power of two.
     * @param {Number} [options.maxLuminance=4.0] - Deprecated. Same as whitePoint.
     * @param {Number} [options.whitePoint=4.0] - The white point.
     * @param {Number} [options.middleGrey=0.6] - The middle grey factor.
     * @param {Number} [options.minLuminance=0.01] - The minimum luminance. Prevents very high exposure in dark scenes.
     * @param {Number} [options.averageLuminance=1.0] - The average luminance. Used for the non-adaptive Reinhard operator.
     * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
     */ constructor({ blendFunction = BlendFunction.SRC, adaptive = false, mode = adaptive ? ToneMappingMode.REINHARD2_ADAPTIVE : ToneMappingMode.AGX, resolution = 256, maxLuminance = 4, whitePoint = maxLuminance, middleGrey = 0.6, minLuminance = 0.01, averageLuminance = 1, adaptationRate = 1 } = {}){
          super("ToneMappingEffect", tone_mapping_default, {
              blendFunction,
              uniforms: /* @__PURE__ */ new Map([
                  [
                      "luminanceBuffer",
                      new three.Uniform(null)
                  ],
                  [
                      "maxLuminance",
                      new three.Uniform(maxLuminance)
                  ],
                  // Unused
                  [
                      "whitePoint",
                      new three.Uniform(whitePoint)
                  ],
                  [
                      "middleGrey",
                      new three.Uniform(middleGrey)
                  ],
                  [
                      "averageLuminance",
                      new three.Uniform(averageLuminance)
                  ]
              ])
          });
          this.renderTargetLuminance = new three.WebGLRenderTarget(1, 1, {
              minFilter: three.LinearMipmapLinearFilter,
              depthBuffer: false
          });
          this.renderTargetLuminance.texture.generateMipmaps = true;
          this.renderTargetLuminance.texture.name = "Luminance";
          this.luminancePass = new LuminancePass({
              renderTarget: this.renderTargetLuminance
          });
          this.adaptiveLuminancePass = new AdaptiveLuminancePass(this.luminancePass.texture, {
              minLuminance,
              adaptationRate
          });
          this.uniforms.get("luminanceBuffer").value = this.adaptiveLuminancePass.texture;
          this.resolution = resolution;
          this.mode = mode;
      }
  };
  // src/materials/glsl/effect.frag
  var effect_default = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}vec3 RGBToHCV(const in vec3 RGB){vec4 P=mix(vec4(RGB.bg,-1.0,2.0/3.0),vec4(RGB.gb,0.0,-1.0/3.0),step(RGB.b,RGB.g));vec4 Q=mix(vec4(P.xyw,RGB.r),vec4(RGB.r,P.yzx),step(P.x,RGB.r));float C=Q.x-min(Q.w,Q.y);float H=abs((Q.w-Q.y)/(6.0*C+EPSILON)+Q.z);return vec3(H,C,Q.x);}vec3 RGBToHSL(const in vec3 RGB){vec3 HCV=RGBToHCV(RGB);float L=HCV.z-HCV.y*0.5;float S=HCV.y/(1.0-abs(L*2.0-1.0)+EPSILON);return vec3(HCV.x,S,L);}vec3 HueToRGB(const in float H){float R=abs(H*6.0-3.0)-1.0;float G=2.0-abs(H*6.0-2.0);float B=2.0-abs(H*6.0-4.0);return clamp(vec3(R,G,B),0.0,1.0);}vec3 HSLToRGB(const in vec3 HSL){vec3 RGB=HueToRGB(HSL.x);float C=(1.0-abs(2.0*HSL.z-1.0))*HSL.y;return(RGB-0.5)*C+HSL.z;}FRAGMENT_HEAD void main(){FRAGMENT_MAIN_UV vec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGE color0.a=clamp(color0.a,0.0,1.0);gl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <colorspace_fragment>
#endif
#include <dithering_fragment>
}`;
  // src/materials/glsl/effect.vert
  var effect_default2 = `uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEAD void main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORT gl_Position=vec4(position.xy,1.0,1.0);}`;
  // src/materials/EffectMaterial.js
  var EffectMaterial = class extends three.ShaderMaterial {
      /**
     * The input buffer.
     *
     * @type {Texture}
     */ set inputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Texture} value - The input buffer.
     */ setInputBuffer(value) {
          this.uniforms.inputBuffer.value = value;
      }
      /**
     * The depth buffer.
     *
     * @type {Texture}
     */ get depthBuffer() {
          return this.uniforms.depthBuffer.value;
      }
      set depthBuffer(value) {
          this.uniforms.depthBuffer.value = value;
      }
      /**
     * The depth packing strategy.
     *
     * @type {DepthPackingStrategies}
     */ get depthPacking() {
          return Number(this.defines.DEPTH_PACKING);
      }
      set depthPacking(value) {
          this.defines.DEPTH_PACKING = value.toFixed(0);
          this.needsUpdate = true;
      }
      /**
     * Sets the depth buffer.
     *
     * @deprecated Use depthBuffer and depthPacking instead.
     * @param {Texture} buffer - The depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
     */ setDepthBuffer(buffer, depthPacking = three.BasicDepthPacking) {
          this.depthBuffer = buffer;
          this.depthPacking = depthPacking;
      }
      /**
     * Sets the shader data.
     *
     * @param {EffectShaderData} data - The shader data.
     * @return {EffectMaterial} This material.
     */ setShaderData(data) {
          this.setShaderParts(data.shaderParts);
          this.setDefines(data.defines);
          this.setUniforms(data.uniforms);
          this.setExtensions(data.extensions);
      }
      /**
     * Sets the shader parts.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, String>} shaderParts - A collection of shader snippets. See {@link EffectShaderSection}.
     * @return {EffectMaterial} This material.
     */ setShaderParts(shaderParts) {
          this.fragmentShader = effect_default.replace(EffectShaderSection.FRAGMENT_HEAD, shaderParts.get(EffectShaderSection.FRAGMENT_HEAD) || "").replace(EffectShaderSection.FRAGMENT_MAIN_UV, shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_UV) || "").replace(EffectShaderSection.FRAGMENT_MAIN_IMAGE, shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_IMAGE) || "");
          this.vertexShader = effect_default2.replace(EffectShaderSection.VERTEX_HEAD, shaderParts.get(EffectShaderSection.VERTEX_HEAD) || "").replace(EffectShaderSection.VERTEX_MAIN_SUPPORT, shaderParts.get(EffectShaderSection.VERTEX_MAIN_SUPPORT) || "");
          this.needsUpdate = true;
          return this;
      }
      /**
     * Sets the shader macros.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, String>} defines - A collection of preprocessor macro definitions.
     * @return {EffectMaterial} This material.
     */ setDefines(defines) {
          for (const entry of defines.entries()){
              this.defines[entry[0]] = entry[1];
          }
          this.needsUpdate = true;
          return this;
      }
      /**
     * Sets the shader uniforms.
     *
     * @deprecated Use setShaderData instead.
     * @param {Map<String, Uniform>} uniforms - A collection of uniforms.
     * @return {EffectMaterial} This material.
     */ setUniforms(uniforms) {
          for (const entry of uniforms.entries()){
              this.uniforms[entry[0]] = entry[1];
          }
          return this;
      }
      /**
     * Sets the required shader extensions.
     *
     * @deprecated Use setShaderData instead.
     * @param {Set<WebGLExtension>} extensions - A collection of extensions.
     * @return {EffectMaterial} This material.
     */ setExtensions(extensions) {
          this.extensions = {};
          for (const extension of extensions){
              this.extensions[extension] = true;
          }
          return this;
      }
      /**
     * Indicates whether output encoding is enabled.
     *
     * @type {Boolean}
     */ get encodeOutput() {
          return this.defines.ENCODE_OUTPUT !== void 0;
      }
      set encodeOutput(value) {
          if (this.encodeOutput !== value) {
              if (value) {
                  this.defines.ENCODE_OUTPUT = "1";
              } else {
                  delete this.defines.ENCODE_OUTPUT;
              }
              this.needsUpdate = true;
          }
      }
      /**
     * Indicates whether output encoding is enabled.
     *
     * @deprecated Use encodeOutput instead.
     * @return {Boolean} Whether output encoding is enabled.
     */ isOutputEncodingEnabled(value) {
          return this.encodeOutput;
      }
      /**
     * Enables or disables output encoding.
     *
     * @deprecated Use encodeOutput instead.
     * @param {Boolean} value - Whether output encoding should be enabled.
     */ setOutputEncodingEnabled(value) {
          this.encodeOutput = value;
      }
      /**
     * The time in seconds.
     *
     * @type {Number}
     */ get time() {
          return this.uniforms.time.value;
      }
      set time(value) {
          this.uniforms.time.value = value;
      }
      /**
     * Sets the delta time.
     *
     * @deprecated Use time instead.
     * @param {Number} value - The delta time in seconds.
     */ setDeltaTime(value) {
          this.uniforms.time.value += value;
      }
      /**
     * Copies the settings of the given camera.
     *
     * @deprecated Use copyCameraSettings instead.
     * @param {Camera} camera - A camera.
     */ adoptCameraSettings(camera) {
          this.copyCameraSettings(camera);
      }
      /**
     * Copies the settings of the given camera.
     *
     * @param {Camera} camera - A camera.
     */ copyCameraSettings(camera) {
          if (camera) {
              this.uniforms.cameraNear.value = camera.near;
              this.uniforms.cameraFar.value = camera.far;
              if (camera instanceof three.PerspectiveCamera) {
                  this.defines.PERSPECTIVE_CAMERA = "1";
              } else {
                  delete this.defines.PERSPECTIVE_CAMERA;
              }
              this.needsUpdate = true;
          }
      }
      /**
     * Sets the resolution.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const uniforms = this.uniforms;
          uniforms.resolution.value.set(width, height);
          uniforms.texelSize.value.set(1 / width, 1 / height);
          uniforms.aspect.value = width / height;
      }
      /**
     * An enumeration of shader code placeholders.
     *
     * @deprecated Use EffectShaderSection instead.
     * @type {Object}
     */ static get Section() {
          return EffectShaderSection;
      }
      /**
     * Constructs a new effect material.
     *
     * @param {Map<String, String>} [shaderParts] - Deprecated. Use setShaderData instead.
     * @param {Map<String, String>} [defines] - Deprecated. Use setShaderData instead.
     * @param {Map<String, Uniform>} [uniforms] - Deprecated. Use setShaderData instead.
     * @param {Camera} [camera] - A camera.
     * @param {Boolean} [dithering=false] - Deprecated.
     */ constructor(shaderParts, defines, uniforms, camera, dithering = false){
          super({
              name: "EffectMaterial",
              defines: {
                  THREE_REVISION: three.REVISION.replace(/\D+/g, ""),
                  DEPTH_PACKING: "0",
                  ENCODE_OUTPUT: "1"
              },
              uniforms: {
                  inputBuffer: new three.Uniform(null),
                  depthBuffer: new three.Uniform(null),
                  resolution: new three.Uniform(new three.Vector2()),
                  texelSize: new three.Uniform(new three.Vector2()),
                  cameraNear: new three.Uniform(0.3),
                  cameraFar: new three.Uniform(1e3),
                  aspect: new three.Uniform(1),
                  time: new three.Uniform(0)
              },
              blending: three.NoBlending,
              toneMapped: false,
              depthWrite: false,
              depthTest: false,
              dithering
          });
          if (shaderParts) {
              this.setShaderParts(shaderParts);
          }
          if (defines) {
              this.setDefines(defines);
          }
          if (uniforms) {
              this.setUniforms(uniforms);
          }
          this.copyCameraSettings(camera);
      }
  };
  // src/passes/DepthPickingPass.js
  Number(three.REVISION.replace(/\D+/g, ""));
  function prefixSubstrings(prefix, substrings, strings) {
      for (const substring of substrings){
          const prefixed = "$1" + prefix + substring.charAt(0).toUpperCase() + substring.slice(1);
          const regExp = new RegExp("([^\\.])(\\b" + substring + "\\b)", "g");
          for (const entry of strings.entries()){
              if (entry[1] !== null) {
                  strings.set(entry[0], entry[1].replace(regExp, prefixed));
              }
          }
      }
  }
  function integrateEffect(prefix, effect, data) {
      let fragmentShader = effect.getFragmentShader();
      let vertexShader = effect.getVertexShader();
      const mainImageExists = fragmentShader !== void 0 && /mainImage/.test(fragmentShader);
      const mainUvExists = fragmentShader !== void 0 && /mainUv/.test(fragmentShader);
      data.attributes |= effect.getAttributes();
      if (fragmentShader === void 0) {
          throw new Error(`Missing fragment shader (${effect.name})`);
      } else if (mainUvExists && (data.attributes & EffectAttribute.CONVOLUTION) !== 0) {
          throw new Error(`Effects that transform UVs are incompatible with convolution effects (${effect.name})`);
      } else if (!mainImageExists && !mainUvExists) {
          throw new Error(`Could not find mainImage or mainUv function (${effect.name})`);
      } else {
          const functionRegExp = /\w+\s+(\w+)\([\w\s,]*\)\s*{/g;
          const shaderParts = data.shaderParts;
          let fragmentHead = shaderParts.get(EffectShaderSection.FRAGMENT_HEAD) || "";
          let fragmentMainUv = shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_UV) || "";
          let fragmentMainImage = shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_IMAGE) || "";
          let vertexHead = shaderParts.get(EffectShaderSection.VERTEX_HEAD) || "";
          let vertexMainSupport = shaderParts.get(EffectShaderSection.VERTEX_MAIN_SUPPORT) || "";
          const varyings = /* @__PURE__ */ new Set();
          const names = /* @__PURE__ */ new Set();
          if (mainUvExists) {
              fragmentMainUv += `	${prefix}MainUv(UV);
`;
              data.uvTransformation = true;
          }
          if (vertexShader !== null && /mainSupport/.test(vertexShader)) {
              const needsUv = /mainSupport *\([\w\s]*?uv\s*?\)/.test(vertexShader);
              vertexMainSupport += `	${prefix}MainSupport(`;
              vertexMainSupport += needsUv ? "vUv);\n" : ");\n";
              for (const m2 of vertexShader.matchAll(/(?:varying\s+\w+\s+([\S\s]*?);)/g)){
                  for (const n of m2[1].split(/\s*,\s*/)){
                      data.varyings.add(n);
                      varyings.add(n);
                      names.add(n);
                  }
              }
              for (const m2 of vertexShader.matchAll(functionRegExp)){
                  names.add(m2[1]);
              }
          }
          for (const m2 of fragmentShader.matchAll(functionRegExp)){
              names.add(m2[1]);
          }
          for (const d of effect.defines.keys()){
              names.add(d.replace(/\([\w\s,]*\)/g, ""));
          }
          for (const u of effect.uniforms.keys()){
              names.add(u);
          }
          names.delete("while");
          names.delete("for");
          names.delete("if");
          effect.uniforms.forEach((val, key)=>data.uniforms.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
          effect.defines.forEach((val, key)=>data.defines.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
          const shaders = /* @__PURE__ */ new Map([
              [
                  "fragment",
                  fragmentShader
              ],
              [
                  "vertex",
                  vertexShader
              ]
          ]);
          prefixSubstrings(prefix, names, data.defines);
          prefixSubstrings(prefix, names, shaders);
          fragmentShader = shaders.get("fragment");
          vertexShader = shaders.get("vertex");
          const blendMode = effect.blendMode;
          data.blendModes.set(blendMode.blendFunction, blendMode);
          if (mainImageExists) {
              if (effect.inputColorSpace !== null && effect.inputColorSpace !== data.colorSpace) {
                  fragmentMainImage += effect.inputColorSpace === three.SRGBColorSpace ? "color0 = sRGBTransferOETF(color0);\n	" : "color0 = sRGBToLinear(color0);\n	";
              }
              if (effect.outputColorSpace !== three.NoColorSpace) {
                  data.colorSpace = effect.outputColorSpace;
              } else if (effect.inputColorSpace !== null) {
                  data.colorSpace = effect.inputColorSpace;
              }
              const depthParamRegExp = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/;
              fragmentMainImage += `${prefix}MainImage(color0, UV, `;
              if ((data.attributes & EffectAttribute.DEPTH) !== 0 && depthParamRegExp.test(fragmentShader)) {
                  fragmentMainImage += "depth, ";
                  data.readDepth = true;
              }
              fragmentMainImage += "color1);\n	";
              const blendOpacity = prefix + "BlendOpacity";
              data.uniforms.set(blendOpacity, blendMode.opacity);
              fragmentMainImage += `color0 = blend${blendMode.blendFunction}(color0, color1, ${blendOpacity});

	`;
              fragmentHead += `uniform float ${blendOpacity};

`;
          }
          fragmentHead += fragmentShader + "\n";
          if (vertexShader !== null) {
              vertexHead += vertexShader + "\n";
          }
          shaderParts.set(EffectShaderSection.FRAGMENT_HEAD, fragmentHead);
          shaderParts.set(EffectShaderSection.FRAGMENT_MAIN_UV, fragmentMainUv);
          shaderParts.set(EffectShaderSection.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
          shaderParts.set(EffectShaderSection.VERTEX_HEAD, vertexHead);
          shaderParts.set(EffectShaderSection.VERTEX_MAIN_SUPPORT, vertexMainSupport);
          if (effect.extensions !== null) {
              for (const extension of effect.extensions){
                  data.extensions.add(extension);
              }
          }
      }
  }
  var EffectPass = class extends Pass {
      set mainScene(value) {
          for (const effect of this.effects){
              effect.mainScene = value;
          }
      }
      set mainCamera(value) {
          this.fullscreenMaterial.copyCameraSettings(value);
          for (const effect of this.effects){
              effect.mainCamera = value;
          }
      }
      /**
     * Indicates whether this pass encodes its output when rendering to screen.
     *
     * @type {Boolean}
     * @deprecated Use fullscreenMaterial.encodeOutput instead.
     */ get encodeOutput() {
          return this.fullscreenMaterial.encodeOutput;
      }
      set encodeOutput(value) {
          this.fullscreenMaterial.encodeOutput = value;
      }
      /**
     * Indicates whether dithering is enabled.
     *
     * @type {Boolean}
     */ get dithering() {
          return this.fullscreenMaterial.dithering;
      }
      set dithering(value) {
          const material = this.fullscreenMaterial;
          material.dithering = value;
          material.needsUpdate = true;
      }
      /**
     * Sets the effects.
     *
     * @param {Effect[]} effects - The effects.
     * @protected
     */ setEffects(effects) {
          for (const effect of this.effects){
              effect.removeEventListener("change", this.listener);
          }
          this.effects = effects.sort((a, b)=>b.attributes - a.attributes);
          for (const effect of this.effects){
              effect.addEventListener("change", this.listener);
          }
      }
      /**
     * Updates the compound shader material.
     *
     * @protected
     */ updateMaterial() {
          const data = new EffectShaderData();
          let id = 0;
          for (const effect of this.effects){
              if (effect.blendMode.blendFunction === BlendFunction.DST) {
                  data.attributes |= effect.getAttributes() & EffectAttribute.DEPTH;
              } else if ((data.attributes & effect.getAttributes() & EffectAttribute.CONVOLUTION) !== 0) {
                  throw new Error(`Convolution effects cannot be merged (${effect.name})`);
              } else {
                  integrateEffect("e" + id++, effect, data);
              }
          }
          let fragmentHead = data.shaderParts.get(EffectShaderSection.FRAGMENT_HEAD);
          let fragmentMainImage = data.shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_IMAGE);
          let fragmentMainUv = data.shaderParts.get(EffectShaderSection.FRAGMENT_MAIN_UV);
          const blendRegExp = /\bblend\b/g;
          for (const blendMode of data.blendModes.values()){
              fragmentHead += blendMode.getShaderCode().replace(blendRegExp, `blend${blendMode.blendFunction}`) + "\n";
          }
          if ((data.attributes & EffectAttribute.DEPTH) !== 0) {
              if (data.readDepth) {
                  fragmentMainImage = "float depth = readDepth(UV);\n\n	" + fragmentMainImage;
              }
              this.needsDepthTexture = this.getDepthTexture() === null;
          } else {
              this.needsDepthTexture = false;
          }
          if (data.colorSpace === three.SRGBColorSpace) {
              fragmentMainImage += "color0 = sRGBToLinear(color0);\n	";
          }
          if (data.uvTransformation) {
              fragmentMainUv = "vec2 transformedUv = vUv;\n" + fragmentMainUv;
              data.defines.set("UV", "transformedUv");
          } else {
              data.defines.set("UV", "vUv");
          }
          data.shaderParts.set(EffectShaderSection.FRAGMENT_HEAD, fragmentHead);
          data.shaderParts.set(EffectShaderSection.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
          data.shaderParts.set(EffectShaderSection.FRAGMENT_MAIN_UV, fragmentMainUv);
          for (const [key, value] of data.shaderParts){
              if (value !== null) {
                  data.shaderParts.set(key, value.trim().replace(/^#/, "\n#"));
              }
          }
          this.skipRendering = id === 0;
          this.needsSwap = !this.skipRendering;
          this.fullscreenMaterial.setShaderData(data);
      }
      /**
     * Rebuilds the shader material.
     */ recompile() {
          this.updateMaterial();
      }
      /**
     * Returns the current depth texture.
     *
     * @return {Texture} The current depth texture, or null if there is none.
     */ getDepthTexture() {
          return this.fullscreenMaterial.depthBuffer;
      }
      /**
     * Sets the depth texture.
     *
     * @param {Texture} depthTexture - A depth texture.
     * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
     */ setDepthTexture(depthTexture, depthPacking = three.BasicDepthPacking) {
          this.fullscreenMaterial.depthBuffer = depthTexture;
          this.fullscreenMaterial.depthPacking = depthPacking;
          for (const effect of this.effects){
              effect.setDepthTexture(depthTexture, depthPacking);
          }
      }
      /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          for (const effect of this.effects){
              effect.update(renderer, inputBuffer, deltaTime);
          }
          if (!this.skipRendering || this.renderToScreen) {
              const material = this.fullscreenMaterial;
              material.inputBuffer = inputBuffer.texture;
              material.time += deltaTime * this.timeScale;
              renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
              renderer.render(this.scene, this.camera);
          }
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          this.fullscreenMaterial.setSize(width, height);
          for (const effect of this.effects){
              effect.setSize(width, height);
          }
      }
      /**
     * Performs initialization tasks.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
     * @param {Number} frameBufferType - The type of the main frame buffers.
     */ initialize(renderer, alpha, frameBufferType) {
          this.renderer = renderer;
          for (const effect of this.effects){
              effect.initialize(renderer, alpha, frameBufferType);
          }
          this.updateMaterial();
          if (frameBufferType !== void 0 && frameBufferType !== three.UnsignedByteType) {
              this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
          }
      }
      /**
     * Deletes disposable objects.
     */ dispose() {
          super.dispose();
          for (const effect of this.effects){
              effect.removeEventListener("change", this.listener);
              effect.dispose();
          }
      }
      /**
     * Handles events.
     *
     * @param {Event} event - An event.
     */ handleEvent(event) {
          switch(event.type){
              case "change":
                  this.recompile();
                  break;
          }
      }
      /**
     * Constructs a new effect pass.
     *
     * @param {Camera} camera - The main camera.
     * @param {...Effect} effects - The effects that will be rendered by this pass.
     */ constructor(camera, ...effects){
          super("EffectPass");
          this.fullscreenMaterial = new EffectMaterial(null, null, null, camera);
          this.listener = (event)=>this.handleEvent(event);
          this.effects = [];
          this.setEffects(effects);
          this.skipRendering = false;
          this.minTime = 1;
          this.maxTime = Number.POSITIVE_INFINITY;
          this.timeScale = 1;
      }
  };
  var NormalPass = class extends Pass {
      set mainScene(value) {
          this.renderPass.mainScene = value;
      }
      set mainCamera(value) {
          this.renderPass.mainCamera = value;
      }
      /**
     * The normal texture.
     *
     * @type {Texture}
     */ get texture() {
          return this.renderTarget.texture;
      }
      /**
     * The normal texture.
     *
     * @deprecated Use texture instead.
     * @return {Texture} The texture.
     */ getTexture() {
          return this.renderTarget.texture;
      }
      /**
     * Returns the resolution settings.
     *
     * @deprecated Use resolution instead.
     * @return {Resolution} The resolution.
     */ getResolution() {
          return this.resolution;
      }
      /**
     * Returns the current resolution scale.
     *
     * @return {Number} The resolution scale.
     * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
     */ getResolutionScale() {
          return this.resolution.scale;
      }
      /**
     * Sets the resolution scale.
     *
     * @param {Number} scale - The new resolution scale.
     * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
     */ setResolutionScale(scale) {
          this.resolution.scale = scale;
      }
      /**
     * Renders the scene normals.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
          const renderTarget = this.renderToScreen ? null : this.renderTarget;
          this.renderPass.render(renderer, renderTarget, renderTarget);
      }
      /**
     * Updates the size of this pass.
     *
     * @param {Number} width - The width.
     * @param {Number} height - The height.
     */ setSize(width, height) {
          const resolution = this.resolution;
          resolution.setBaseSize(width, height);
          this.renderTarget.setSize(resolution.width, resolution.height);
      }
      /**
     * Constructs a new normal pass.
     *
     * @param {Scene} scene - The scene to render.
     * @param {Camera} camera - The camera to use to render the scene.
     * @param {Object} [options] - The options.
     * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
     * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
     * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
     * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
     * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
     * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
     */ constructor(scene, camera, { renderTarget, resolutionScale = 1, width = Resolution.AUTO_SIZE, height = Resolution.AUTO_SIZE, resolutionX = width, resolutionY = height } = {}){
          super("NormalPass");
          this.needsSwap = false;
          this.renderPass = new RenderPass(scene, camera, new three.MeshNormalMaterial());
          const renderPass = this.renderPass;
          renderPass.ignoreBackground = true;
          renderPass.skipShadowMapUpdate = true;
          const clearPass = renderPass.getClearPass();
          clearPass.overrideClearColor = new three.Color(7829503);
          clearPass.overrideClearAlpha = 1;
          this.renderTarget = renderTarget;
          if (this.renderTarget === void 0) {
              this.renderTarget = new three.WebGLRenderTarget(1, 1, {
                  minFilter: three.NearestFilter,
                  magFilter: three.NearestFilter
              });
              this.renderTarget.texture.name = "NormalPass.Target";
          }
          const resolution = this.resolution = new Resolution(this, resolutionX, resolutionY, resolutionScale);
          resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
      }
  };

  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ var _t;
  const t = globalThis, i$1 = t.trustedTypes, s = i$1 ? i$1.createPolicy("lit-html", {
      createHTML: (t)=>t
  }) : void 0, e = "$lit$", h = `lit$${Math.random().toFixed(9).slice(2)}$`, o = "?" + h, n = `<${o}>`, r$1 = document, l = ()=>r$1.createComment(""), c = (t)=>null === t || "object" != typeof t && "function" != typeof t, a = Array.isArray, u = (t)=>a(t) || "function" == typeof t?.[Symbol.iterator], d = "[ \t\n\f\r]", f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, _ = />/g, m = RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), p = /'/g, g = /"/g, $ = /^(?:script|style|textarea|title)$/i, T = Symbol.for("lit-noChange"), E = Symbol.for("lit-nothing"), A = new WeakMap, C = r$1.createTreeWalker(r$1, 129);
  function P(t, i) {
      if (!a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
      return void 0 !== s ? s.createHTML(i) : i;
  }
  const V = (t, i)=>{
      const s = t.length - 1, o = [];
      let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = f;
      for(let i = 0; i < s; i++){
          const s = t[i];
          let a, u, d = -1, y = 0;
          for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === f ? "!--" === u[1] ? c = v : void 0 !== u[1] ? c = _ : void 0 !== u[2] ? ($.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = m) : void 0 !== u[3] && (c = m) : c === m ? ">" === u[0] ? (c = r ?? f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? m : '"' === u[3] ? g : p) : c === g || c === p ? c = m : c === v || c === _ ? c = f : (c = m, r = void 0);
          const x = c === m && t[i + 1].startsWith("/>") ? " " : "";
          l += c === f ? s + n : d >= 0 ? (o.push(a), s.slice(0, d) + e + s.slice(d) + h + x) : s + h + (-2 === d ? i : x);
      }
      return [
          P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
          o
      ];
  };
  class N {
      static createElement(t, i) {
          const s = r$1.createElement("template");
          return s.innerHTML = t, s;
      }
      constructor({ strings: t, _$litType$: s }, n){
          let r;
          this.parts = [];
          let c = 0, a = 0;
          const u = t.length - 1, d = this.parts, [f, v] = V(t, s);
          if (this.el = N.createElement(f, n), C.currentNode = this.el.content, 2 === s || 3 === s) {
              const t = this.el.content.firstChild;
              t.replaceWith(...t.childNodes);
          }
          for(; null !== (r = C.nextNode()) && d.length < u;){
              if (1 === r.nodeType) {
                  if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith(e)) {
                      const i = v[a++], s = r.getAttribute(t).split(h), e = /([.?@])?(.*)/.exec(i);
                      d.push({
                          type: 1,
                          index: c,
                          name: e[2],
                          strings: s,
                          ctor: "." === e[1] ? H : "?" === e[1] ? I : "@" === e[1] ? L : k
                      }), r.removeAttribute(t);
                  } else t.startsWith(h) && (d.push({
                      type: 6,
                      index: c
                  }), r.removeAttribute(t));
                  if ($.test(r.tagName)) {
                      const t = r.textContent.split(h), s = t.length - 1;
                      if (s > 0) {
                          r.textContent = i$1 ? i$1.emptyScript : "";
                          for(let i = 0; i < s; i++)r.append(t[i], l()), C.nextNode(), d.push({
                              type: 2,
                              index: ++c
                          });
                          r.append(t[s], l());
                      }
                  }
              } else if (8 === r.nodeType) if (r.data === o) d.push({
                  type: 2,
                  index: c
              });
              else {
                  let t = -1;
                  for(; -1 !== (t = r.data.indexOf(h, t + 1));)d.push({
                      type: 7,
                      index: c
                  }), t += h.length - 1;
              }
              c++;
          }
      }
  }
  function S(t, i, s = t, e) {
      var _s;
      if (i === T) return i;
      let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
      const o = c(i) ? void 0 : i._$litDirective$;
      return h?.constructor !== o && (h?._$AO?.(false), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? ((_s = s)._$Co ?? (_s._$Co = []))[e] = h : s._$Cl = h), void 0 !== h && (i = S(t, h._$AS(t, i.values), h, e)), i;
  }
  class M {
      get parentNode() {
          return this._$AM.parentNode;
      }
      get _$AU() {
          return this._$AM._$AU;
      }
      u(t) {
          const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? r$1).importNode(i, true);
          C.currentNode = e;
          let h = C.nextNode(), o = 0, n = 0, l = s[0];
          for(; void 0 !== l;){
              if (o === l.index) {
                  let i;
                  2 === l.type ? i = new R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new z(h, this, t)), this._$AV.push(i), l = s[++n];
              }
              o !== l?.index && (h = C.nextNode(), o++);
          }
          return C.currentNode = r$1, e;
      }
      p(t) {
          let i = 0;
          for (const s of this._$AV) void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
      }
      constructor(t, i){
          this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
      }
  }
  class R {
      get _$AU() {
          return this._$AM?._$AU ?? this._$Cv;
      }
      get parentNode() {
          let t = this._$AA.parentNode;
          const i = this._$AM;
          return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
      }
      get startNode() {
          return this._$AA;
      }
      get endNode() {
          return this._$AB;
      }
      _$AI(t, i = this) {
          t = S(this, t, i), c(t) ? t === E || null == t || "" === t ? (this._$AH !== E && this._$AR(), this._$AH = E) : t !== this._$AH && t !== T && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : u(t) ? this.k(t) : this._(t);
      }
      O(t) {
          return this._$AA.parentNode.insertBefore(t, this._$AB);
      }
      T(t) {
          this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
      }
      _(t) {
          this._$AH !== E && c(this._$AH) ? this._$AA.nextSibling.data = t : this.T(r$1.createTextNode(t)), this._$AH = t;
      }
      $(t) {
          const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = N.createElement(P(s.h, s.h[0]), this.options)), s);
          if (this._$AH?._$AD === e) this._$AH.p(i);
          else {
              const t = new M(e, this), s = t.u(this.options);
              t.p(i), this.T(s), this._$AH = t;
          }
      }
      _$AC(t) {
          let i = A.get(t.strings);
          return void 0 === i && A.set(t.strings, i = new N(t)), i;
      }
      k(t) {
          a(this._$AH) || (this._$AH = [], this._$AR());
          const i = this._$AH;
          let s, e = 0;
          for (const h of t)e === i.length ? i.push(s = new R(this.O(l()), this.O(l()), this, this.options)) : s = i[e], s._$AI(h), e++;
          e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
      }
      _$AR(t = this._$AA.nextSibling, i) {
          for(this._$AP?.(false, true, i); t && t !== this._$AB;){
              const i = t.nextSibling;
              t.remove(), t = i;
          }
      }
      setConnected(t) {
          void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
      }
      constructor(t, i, s, e){
          this.type = 2, this._$AH = E, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? true;
      }
  }
  class k {
      get tagName() {
          return this.element.tagName;
      }
      get _$AU() {
          return this._$AM._$AU;
      }
      _$AI(t, i = this, s, e) {
          const h = this.strings;
          let o = false;
          if (void 0 === h) t = S(this, t, i, 0), o = !c(t) || t !== this._$AH && t !== T, o && (this._$AH = t);
          else {
              const e = t;
              let n, r;
              for(t = h[0], n = 0; n < h.length - 1; n++)r = S(this, e[s + n], i, n), r === T && (r = this._$AH[n]), o || (o = !c(r) || r !== this._$AH[n]), r === E ? t = E : t !== E && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
          }
          o && !e && this.j(t);
      }
      j(t) {
          t === E ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
      }
      constructor(t, i, s, e, h){
          this.type = 1, this._$AH = E, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = E;
      }
  }
  class H extends k {
      j(t) {
          this.element[this.name] = t === E ? void 0 : t;
      }
      constructor(){
          super(...arguments), this.type = 3;
      }
  }
  class I extends k {
      j(t) {
          this.element.toggleAttribute(this.name, !!t && t !== E);
      }
      constructor(){
          super(...arguments), this.type = 4;
      }
  }
  class L extends k {
      _$AI(t, i = this) {
          if ((t = S(this, t, i, 0) ?? E) === T) return;
          const s = this._$AH, e = t === E && s !== E || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== E && (s === E || e);
          e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
      }
      handleEvent(t) {
          "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
      }
      constructor(t, i, s, e, h){
          super(t, i, s, e, h), this.type = 5;
      }
  }
  class z {
      get _$AU() {
          return this._$AM._$AU;
      }
      _$AI(t) {
          S(this, t);
      }
      constructor(t, i, s){
          this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
      }
  }
  const j = t.litHtmlPolyfillSupport;
  j?.(N, R), ((_t = t).litHtmlVersions ?? (_t.litHtmlVersions = [])).push("3.2.1");
  const B = (t, i, s)=>{
      const e = s?.renderBefore ?? i;
      let h = e._$litPart$;
      if (void 0 === h) {
          const t = s?.renderBefore ?? null;
          e._$litPart$ = h = new R(i.insertBefore(l(), t), t, void 0, s ?? {});
      }
      return h._$AI(t), h;
  };

  var _globalThis;
  /**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   */ class r extends b {
      createRenderRoot() {
          var _this_renderOptions;
          const t = super.createRenderRoot();
          return (_this_renderOptions = this.renderOptions).renderBefore ?? (_this_renderOptions.renderBefore = t.firstChild), t;
      }
      update(t) {
          const s = this.render();
          this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = B(s, this.renderRoot, this.renderOptions);
      }
      connectedCallback() {
          super.connectedCallback(), this._$Do?.setConnected(true);
      }
      disconnectedCallback() {
          super.disconnectedCallback(), this._$Do?.setConnected(false);
      }
      render() {
          return T;
      }
      constructor(){
          super(...arguments), this.renderOptions = {
              host: this
          }, this._$Do = void 0;
      }
  }
  r._$litElement$ = true, r["finalized"] = true, globalThis.litElementHydrateSupport?.({
      LitElement: r
  });
  const i = globalThis.litElementPolyfillSupport;
  i?.({
      LitElement: r
  });
  ((_globalThis = globalThis).litElementVersions ?? (_globalThis.litElementVersions = [])).push("4.1.1");

  function clamp(value, lowerLimit, upperLimit) {
      return Math.max(lowerLimit, Math.min(upperLimit, value));
  }
   function clampNormal(value) {
      return clamp(value, 0, 1);
  }
   function wrapClamp(value, lowerLimit, upperLimit) {
      if (value > upperLimit) return lowerLimit;
      if (value < lowerLimit) return upperLimit;
      return value;
  }
   function isConvolution(effect) {
      return (effect.getAttributes() & EffectAttribute.CONVOLUTION) != 0;
  }
   function disposeEffectPass(pass) {
      Pass.prototype.dispose.call(pass);
      if (!pass.listener) return;
      for (const effect of pass.effects){
          effect.removeEventListener('change', pass.listener);
      }
  }
   function validateLiteralType(options, value) {
      if (!options.includes(value)) throw new TypeError(`Validation Error: ${value} is not a valid value. Expected ${options.join(' | ')}`);
  }

  var __decorate$a = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  var _a, _b, _c;
  const $scene = Symbol('scene');
  const $composer = Symbol('composer');
  const $modelViewerElement = Symbol('modelViewerElement');
  const $effectComposer = Symbol('effectComposer');
  const $renderPass = Symbol('renderPass');
  const $normalPass = Symbol('normalPass');
  const $effectPasses = Symbol('effectsPass');
  const $requires = Symbol('requires');
  const $effects = Symbol('effects');
  const $selection = Symbol('selection');
  const $onSceneLoad = Symbol('onSceneLoad');
  const $resetEffectPasses = Symbol('resetEffectPasses');
  const $userEffectCount = Symbol('userEffectCount');
  const $tonemapping = Symbol('tonemapping');
  const $updateProperties$1 = Symbol('updateProperties');
   class EffectComposer extends EffectComposer$1 {
      preRender() {
          const renderer = this.getRenderer();
          renderer.autoClear = false;
          renderer.toneMapping = this[$tonemapping];
      }
      postRender() {
          const renderer = this.getRenderer();
          renderer.toneMapping = three.NeutralToneMapping;
          renderer.autoClear = true;
      }
      render(deltaTime) {
          this.preRender();
          super.render(deltaTime);
          this.postRender();
      }
   addPass(pass, index) {
          super.addPass(pass, index);
          this.refresh();
      }
      setMainCamera(camera) {
          this.camera = camera;
          super.setMainCamera(camera);
      }
      setMainScene(scene) {
          this.scene = scene;
          super.setMainScene(scene);
      }
   refresh() {
          if (this.camera && this.scene) {
              super.setMainCamera(this.camera);
              super.setMainScene(this.scene);
          }
      }
      beforeRender(_time, _delta) {
          var _d;
          if (this.dirtyRender) {
              (_d = this.scene) === null || _d === void 0 ? void 0 : _d.queueRender();
          }
      }
      constructor(renderer, options){
          super(renderer, options);
          this[_a] = three.NeutralToneMapping;
      }
  }
  _a = $tonemapping;
  const RENDER_MODES = [
      'performance',
      'quality'
  ];
  const N_DEFAULT_PASSES = 2;
  class MVEffectComposer extends b {
      static get is() {
          return 'effect-composer';
      }
      get [(_b = $userEffectCount, $effectComposer)]() {
          if (!this[$composer]) throw new Error('The EffectComposer has not been instantiated yet. Please make sure the component is properly mounted on the Document within a <model-viewer> element.');
          return this[$composer];
      }
   get userPasses() {
          return this[$effectComposer].passes.slice(N_DEFAULT_PASSES, N_DEFAULT_PASSES + this[$userEffectCount]);
      }
      get modelViewerElement() {
          if (!this[$modelViewerElement]) throw new Error('<effect-composer> must be a child of a <model-viewer> component.');
          return this[$modelViewerElement];
      }
   get normalBuffer() {
          return this[$normalPass].texture;
      }
   get selection() {
          return this[$selection];
      }
      connectedCallback() {
          var _d;
          super.connectedCallback && super.connectedCallback();
          if (((_d = this.parentNode) === null || _d === void 0 ? void 0 : _d.nodeName.toLowerCase()) === 'model-viewer') {
              this[$modelViewerElement] = this.parentNode;
          }
          try {
              validateLiteralType(RENDER_MODES, this.renderMode);
          } catch (e) {
              console.error(e.message + '\nrenderMode defaulting to: performance');
          }
          this[$composer] = new EffectComposer(undefined, {
              stencilBuffer: true,
              multisampling: this.msaa,
              frameBufferType: this.renderMode === 'quality' ? three.HalfFloatType : three.UnsignedByteType
          });
          this.modelViewerElement.registerEffectComposer(this[$effectComposer]);
          this[$effectComposer].addPass(this[$renderPass], 0);
          this[$effectComposer].addPass(this[$normalPass], 1);
          this[$onSceneLoad]();
          this.modelViewerElement.addEventListener('before-render', this[$onSceneLoad]);
          this.updateEffects();
      }
      disconnectedCallback() {
          super.disconnectedCallback && super.disconnectedCallback();
          this.modelViewerElement.unregisterEffectComposer();
          this.modelViewerElement.removeEventListener('before-render', this[$onSceneLoad]);
          this[$effectComposer].dispose();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('msaa')) {
              this[$effectComposer].multisampling = this.msaa;
          }
          if (changedProperties.has('renderMode') && changedProperties.get('renderMode') !== undefined) {
              throw new Error('renderMode cannot be changed after startup.');
          }
      }
   addPass(pass, requireNormals, requireDirtyRender) {
          pass.requireNormals = requireNormals;
          pass.requireDirtyRender = requireDirtyRender;
          this[$effectComposer].addPass(pass, this[$userEffectCount] + N_DEFAULT_PASSES);
          this[$userEffectCount]++;
          this[$updateProperties$1]();
      }
   removePass(pass, dispose = true) {
          if (!this[$effectComposer].passes.includes(pass)) throw new Error(`Pass ${pass.name} not found.`);
          this[$effectComposer].removePass(pass);
          if (dispose) pass.dispose();
          this[$updateProperties$1]();
          this[$userEffectCount]--;
      }
   updateEffects() {
          this[$resetEffectPasses]();
          const effects = this[$effects];
          let i = 0;
          while(i < effects.length){
              const separateIndex = effects.slice(i).findIndex((effect)=>effect.requireSeparatePass || isConvolution(effect));
              if (separateIndex != 0) {
                  const effectPass = new EffectPass(undefined, ...effects.slice(i, separateIndex == -1 ? effects.length : separateIndex));
                  this[$effectComposer].addPass(effectPass);
              }
              if (separateIndex != -1) {
                  const convolutionPass = new EffectPass(undefined, effects[i + separateIndex]);
                  this[$effectComposer].addPass(convolutionPass);
                  i += separateIndex + 1;
              } else {
                  break;
              }
          }
          this[$updateProperties$1]();
          this.queueRender();
      }
   queueRender() {
          var _d;
          (_d = this[$scene]) === null || _d === void 0 ? void 0 : _d.queueRender();
      }
      get [$scene]() {
          return this[$effectComposer].scene;
      }
   get [$effects]() {
          const effects = [];
          for(let i = 0; i < this.children.length; i++){
              const childEffect = this.children.item(i);
              if (!childEffect.effects) continue;
              const childEffects = childEffect.effects;
              if (childEffects) {
                  effects.push(...childEffects.filter((effect)=>!effect.disabled));
              }
          }
          return effects;
      }
   get [$effectPasses]() {
          return this[$effectComposer].passes.slice(N_DEFAULT_PASSES + this[$userEffectCount]);
      }
      [(_c = $onSceneLoad, $updateProperties$1)]() {
          this[$normalPass].enabled = this[$requires]('requireNormals');
          this[$normalPass].renderToScreen = false;
          this[$effectComposer].dirtyRender = this[$requires]('requireDirtyRender');
          this[$renderPass].renderToScreen = this[$effectComposer].passes.length === N_DEFAULT_PASSES;
      }
      [$requires](property) {
          return this[$effectComposer].passes.some((pass)=>pass[property] || pass.effects && pass.effects.some((effect)=>effect[property]));
      }
      [$resetEffectPasses]() {
          this[$effectPasses].forEach((pass)=>{
              this[$effectComposer].removePass(pass);
              disposeEffectPass(pass);
          });
      }
   constructor(){
          super();
   this.renderMode = 'performance';
   this.msaa = 0;
          this[_b] = 0;
          this[_c] = ()=>{
              var _d;
              this[$effectComposer].refresh();
              this[$selection].clear();
              (_d = this[$scene]) === null || _d === void 0 ? void 0 : _d.traverse((obj)=>obj.hasOwnProperty('geometry') && this[$selection].add(obj));
              this.dispatchEvent(new CustomEvent('updated-selection'));
          };
          this[$renderPass] = new RenderPass();
          this[$normalPass] = new NormalPass();
          this[$selection] = new Selection();
      }
  }
  __decorate$a([
      n$1({
          type: String,
          attribute: 'render-mode'
      })
  ], MVEffectComposer.prototype, "renderMode", void 0);
  __decorate$a([
      n$1({
          type: Number,
          attribute: 'msaa'
      })
  ], MVEffectComposer.prototype, "msaa", void 0);

  var __decorate$9 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  const $setDefaultProperties = Symbol('setDefaultProperties');
  const BLEND_MODES = Object.keys(BlendFunction);
  const BlendModeMixin = (EffectClass)=>{
      class BlendEffectElement extends EffectClass {
          connectedCallback() {
              super.connectedCallback && super.connectedCallback();
              this[$setDefaultProperties]();
          }
          updated(changedProperties) {
              super.updated(changedProperties);
              if (changedProperties.has('blendMode') || changedProperties.has('opacity')) {
                  this.opacity = clampNormal(this.opacity);
                  this.blendMode = this.blendMode.toUpperCase();
                  this.effects.forEach((effect)=>{
                      if (this.blendMode === 'DEFAULT') {
                          if (effect.blendMode.defaultBlendFunction === undefined) throw new Error(`${effect.name} has no default blend function`);
                          effect.blendMode.blendFunction = effect.blendMode.defaultBlendFunction;
                      } else {
                          validateLiteralType(BLEND_MODES, this.blendMode);
                          effect.blendMode.blendFunction = BlendFunction[this.blendMode];
                      }
                      effect.disabled = this.blendMode === 'SKIP';
                      effect.blendMode.setOpacity(this.opacity);
                  });
                  if (this.blendMode === 'SKIP' || changedProperties.get('blendMode') === 'SKIP') {
                      this.effectComposer.updateEffects();
                  }
                  this.effectComposer.queueRender();
              }
          }
          [$setDefaultProperties]() {
              this.effects.forEach((effect)=>{
                  effect.blendMode.defaultBlendFunction = effect.blendMode.blendFunction;
              });
          }
          constructor(){
              super(...arguments);
   this.blendMode = 'DEFAULT';
   this.opacity = 1;
          }
      }
      __decorate$9([
          n$1({
              type: String,
              attribute: 'blend-mode',
              reflect: true
          })
      ], BlendEffectElement.prototype, "blendMode", void 0);
      __decorate$9([
          n$1({
              type: Number,
              attribute: 'opacity',
              reflect: true
          })
      ], BlendEffectElement.prototype, "opacity", void 0);
      return BlendEffectElement;
  };

  function getKernelSize(n) {
      return Math.round(clamp(n + 1, KernelSize.VERY_SMALL, KernelSize.HUGE + 1)) - 1;
  }
  function getComponentName(obj) {
      return '<' + obj.constructor.name.replace('MV', '').split(/(?=[A-Z])/).join('-').toLowerCase() + '>';
  }
  const TEMP_CAMERA = new three.PerspectiveCamera();

  const $updateProperties = Symbol('updateProperties');
  const $effectOptions = Symbol('effectOptions');
  const EffectBaseMixin = (EffectClass)=>{
      class EffectBaseElement extends EffectClass {
   get effectComposer() {
              if (!this[$effectComposer]) throw new Error(`${getComponentName(this)} must be a child of a <model-viewer> component.`);
              return this[$effectComposer];
          }
          connectedCallback() {
              var _a;
              super.connectedCallback && super.connectedCallback();
              if (((_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName.toLowerCase()) === 'effect-composer') {
                  this[$effectComposer] = this.parentNode;
              }
              this.effectComposer.updateEffects();
          }
          disconnectedCallback() {
              super.disconnectedCallback && super.disconnectedCallback();
              this.effects.forEach((effect)=>effect.dispose());
              this.effectComposer.updateEffects();
          }
      }
      return EffectBaseElement;
  };
  const MVEffectBase = BlendModeMixin(EffectBaseMixin(r));

  var __decorate$8 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  class MVBloomEffect extends MVEffectBase {
      static get is() {
          return 'bloom-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('strength') || changedProperties.has('threshold') || changedProperties.has('smoothing') || changedProperties.has('radius')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.effects[0].luminanceMaterial.threshold = this.threshold;
          this.effects[0].luminanceMaterial.smoothing = this.smoothing;
          this.effects[0].intensity = this.strength;
          this.effects[0].mipmapBlurPass.radius = this.radius;
          this.effectComposer.queueRender();
      }
      get [$effectOptions]() {
          return {
              blendFunction: BlendFunction.ADD,
              mipmapBlur: true,
              radius: this.radius,
              luminanceThreshold: this.threshold,
              luminanceSmoothing: this.smoothing,
              intensity: this.strength
          };
      }
      constructor(){
          super();
   this.strength = 1;
   this.threshold = 0.85;
   this.radius = 0.85;
   this.smoothing = 0.025;
          this.effects = [
              new BloomEffect(this[$effectOptions])
          ];
      }
  }
  __decorate$8([
      n$1({
          type: Number,
          attribute: 'strength',
          reflect: true
      })
  ], MVBloomEffect.prototype, "strength", void 0);
  __decorate$8([
      n$1({
          type: Number,
          attribute: 'threshold',
          reflect: true
      })
  ], MVBloomEffect.prototype, "threshold", void 0);
  __decorate$8([
      n$1({
          type: Number,
          attribute: 'radius',
          reflect: true
      })
  ], MVBloomEffect.prototype, "radius", void 0);
  __decorate$8([
      n$1({
          type: Number,
          attribute: 'smoothing',
          reflect: true
      })
  ], MVBloomEffect.prototype, "smoothing", void 0);

  var __decorate$7 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  const TWO_PI = Math.PI * 2;
  const TONEMAPPING_MODES = Object.keys(ToneMappingMode);
  class MVColorGradeEffect extends MVEffectBase {
      static get is() {
          return 'color-grade-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('tonemapping') || changedProperties.has('brightness') || changedProperties.has('contrast') || changedProperties.has('hue') || changedProperties.has('saturation') || changedProperties.has('blendMode')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          if (this.blendMode === 'SKIP') {
              this.effectComposer[$effectComposer][$tonemapping] = three.NeutralToneMapping;
          } else {
              this.effectComposer[$effectComposer][$tonemapping] = three.NoToneMapping;
          }
          this.saturation = clamp(this.saturation, -1, 1);
          this.hue = wrapClamp(this.hue, 0, TWO_PI);
          this.brightness = clamp(this.brightness, -1, 1);
          this.contrast = clamp(this.contrast, -1, 1);
          this.effects[1].saturation = this.saturation;
          this.effects[1].hue = this.hue;
          this.effects[2].brightness = this.brightness;
          this.effects[2].contrast = this.contrast;
          try {
              this.tonemapping = this.tonemapping.toUpperCase();
              validateLiteralType(TONEMAPPING_MODES, this.tonemapping);
              this.effects[0].mode = ToneMappingMode[this.tonemapping];
          } finally{
              this.effectComposer.queueRender();
          }
      }
      constructor(){
          super();
   this.tonemapping = 'ACES_FILMIC';
   this.brightness = 0;
   this.contrast = 0;
   this.saturation = 0;
   this.hue = 0;
          this.effects = [
              new ToneMappingEffect({
                  mode: ToneMappingMode.ACES_FILMIC
              }),
              new HueSaturationEffect({
                  hue: wrapClamp(this.hue, 0, TWO_PI),
                  saturation: clamp(this.saturation, -1, 1),
                  blendFunction: BlendFunction.SRC
              }),
              new BrightnessContrastEffect({
                  brightness: clamp(this.brightness, -1, 1),
                  contrast: clamp(this.contrast, -1, 1),
                  blendFunction: BlendFunction.SRC
              })
          ];
      }
  }
  __decorate$7([
      n$1({
          type: String,
          attribute: 'tonemapping',
          reflect: true
      })
  ], MVColorGradeEffect.prototype, "tonemapping", void 0);
  __decorate$7([
      n$1({
          type: Number,
          attribute: 'brightness',
          reflect: true
      })
  ], MVColorGradeEffect.prototype, "brightness", void 0);
  __decorate$7([
      n$1({
          type: Number,
          attribute: 'contrast',
          reflect: true
      })
  ], MVColorGradeEffect.prototype, "contrast", void 0);
  __decorate$7([
      n$1({
          type: Number,
          attribute: 'saturation',
          reflect: true
      })
  ], MVColorGradeEffect.prototype, "saturation", void 0);
  __decorate$7([
      n$1({
          type: Number,
          attribute: 'hue',
          reflect: true
      })
  ], MVColorGradeEffect.prototype, "hue", void 0);

  var __decorate$6 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  const GLITCH_MODES = [
      'sporadic',
      'constant'
  ];
  class MVGlitchEffect extends MVEffectBase {
      static get is() {
          return 'glitch-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('mode') || changedProperties.has('strength')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.strength = clamp(this.strength, 0, 1);
          this.mode = this.mode.toLowerCase();
          try {
              validateLiteralType(GLITCH_MODES, this.mode);
          } catch (e) {
              console.error(e.message + NaN);
          }
          if (this.strength == 0) {
              this.effects[0].columns = 0;
              this.effects[0].mode = this.mode === 'constant' ? GlitchMode.CONSTANT_MILD : GlitchMode.SPORADIC;
          } else {
              this.effects[0].columns = 0.06;
              this.effects[0].mode = this.mode === 'constant' ? GlitchMode.CONSTANT_WILD : GlitchMode.SPORADIC;
          }
          this.effects[0].maxStrength = this.strength;
          this.effects[0].ratio = 1 - this.strength;
      }
      [$effectOptions](chromaticAberrationEffect) {
          this.strength = clamp(this.strength, 0, 1);
          return {
              chromaticAberrationOffset: chromaticAberrationEffect.offset,
              delay: new three.Vector2(1 * 1000, 3.5 * 1000),
              duration: new three.Vector2(0.5 * 1000, 1 * 1000),
              strength: new three.Vector2(0.075, this.strength),
              ratio: 1 - this.strength
          };
      }
      constructor(){
          super();
   this.strength = 0.5;
   this.mode = 'sporadic';
          const chromaticAberrationEffect = new ChromaticAberrationEffect();
          const glitchEffect = new GlitchEffect(this[$effectOptions](chromaticAberrationEffect));
          this.effects = [
              glitchEffect,
              chromaticAberrationEffect
          ];
          this.effects[1].requireDirtyRender = true;
      }
  }
  __decorate$6([
      n$1({
          type: Number,
          attribute: 'strength',
          reflect: true
      })
  ], MVGlitchEffect.prototype, "strength", void 0);
  __decorate$6([
      n$1({
          type: String,
          attribute: 'mode',
          reflect: true
      })
  ], MVGlitchEffect.prototype, "mode", void 0);

  var __decorate$5 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  const $setSelection = Symbol('setSelection');
  const SelectiveMixin = (EffectClass)=>{
      var _a;
      class SelectiveEffectElement extends EffectClass {
          connectedCallback() {
              super.connectedCallback && super.connectedCallback();
              this[$setSelection]();
              this.effectComposer.addEventListener('updated-selection', this[$setSelection]);
          }
          disconnectedCallback() {
              super.disconnectedCallback && super.disconnectedCallback();
              this.effectComposer.removeEventListener('updated-selection', this[$setSelection]);
          }
          updated(changedProperties) {
              super.updated(changedProperties);
              if (changedProperties.has('selection')) {
                  this[$setSelection]();
                  this.effectComposer.queueRender();
              }
          }
          constructor(){
              super(...arguments);
   this.selection = [];
              this[_a] = ()=>{
                  var _b;
                  const { effectComposer } = this;
                  if (!effectComposer) return;
                  if (((_b = this.selection) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                      const selection = [];
                      const scene = effectComposer[$scene];
                      scene === null || scene === void 0 ? void 0 : scene.traverse((obj)=>(this.selection.includes(obj.name) || this.selection.includes(obj)) && selection.push(obj));
                      this.effects.forEach((effect)=>{
                          var _b;
                          return (_b = effect.selection) === null || _b === void 0 ? void 0 : _b.set(selection);
                      });
                  } else {
                      this.effects.forEach((effect)=>{
                          var _b;
                          return (_b = effect.selection) === null || _b === void 0 ? void 0 : _b.set(effectComposer[$selection].values());
                      });
                  }
              };
          }
      }
      _a = $setSelection;
      __decorate$5([
          n$1({
              type: Array
          })
      ], SelectiveEffectElement.prototype, "selection", void 0);
      return SelectiveEffectElement;
  };

  var __decorate$4 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  class MVOutlineEffect extends SelectiveMixin(MVEffectBase) {
      static get is() {
          return 'outline-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('color') || changedProperties.has('smoothing') || changedProperties.has('strength')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.effects[0].edgeStrength = this.strength;
          this.effects[0].visibleEdgeColor = new three.Color(this.color);
          this.effects[0].hiddenEdgeColor = new three.Color(this.color);
          this.effects[0].blurPass.enabled = Math.round(this.smoothing) > 0;
          this.effects[0].blurPass.kernelSize = getKernelSize(this.smoothing);
          this.effectComposer.queueRender();
      }
      get [$effectOptions]() {
          return {
              blendFunction: BlendFunction.SCREEN,
              edgeStrength: this.strength,
              pulseSpeed: 0.0,
              visibleEdgeColor: new three.Color(this.color).getHex(),
              hiddenEdgeColor: new three.Color(this.color).getHex(),
              blur: Math.round(this.smoothing) > 0,
              kernelSize: getKernelSize(this.smoothing),
              xRay: true,
              resolutionScale: 1
          };
      }
      constructor(){
          super();
   this.color = 'white';
   this.strength = 1;
   this.smoothing = 1;
          this.effects = [
              new OutlineEffect(undefined, TEMP_CAMERA, this[$effectOptions])
          ];
      }
  }
  __decorate$4([
      n$1({
          type: String || Number,
          attribute: 'color',
          reflect: true
      })
  ], MVOutlineEffect.prototype, "color", void 0);
  __decorate$4([
      n$1({
          type: Number,
          attribute: 'strength',
          reflect: true
      })
  ], MVOutlineEffect.prototype, "strength", void 0);
  __decorate$4([
      n$1({
          type: Number,
          attribute: 'smoothing',
          reflect: true
      })
  ], MVOutlineEffect.prototype, "smoothing", void 0);

  var __decorate$3 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  class MVPixelateEffect extends MVEffectBase {
      static get is() {
          return 'pixelate-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('granularity')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.effects[0].granularity = this.granularity;
          this.effectComposer.queueRender();
      }
      constructor(){
          super();
   this.granularity = 10.0;
          this.effects = [
              new PixelationEffect(this.granularity)
          ];
      }
  }
  __decorate$3([
      n$1({
          type: Number,
          attribute: 'granularity',
          reflect: true
      })
  ], MVPixelateEffect.prototype, "granularity", void 0);

  var __decorate$2 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  const SMAA_QUALITIES = Object.keys(SMAAPreset);
  class MVSMAAEffect extends MVEffectBase {
      static get is() {
          return 'smaa-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('quality')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.quality = this.quality.toUpperCase();
          validateLiteralType(SMAA_QUALITIES, this.quality);
          this.effects[0].applyPreset(SMAAPreset[this.quality]);
          this.effectComposer.queueRender();
      }
      constructor(){
          super();
   this.quality = 'MEDIUM';
          this.effects = [
              new SMAAEffect({
                  preset: SMAAPreset[this.quality]
              })
          ];
      }
  }
  __decorate$2([
      n$1({
          type: String,
          attribute: 'quality',
          reflect: true
      })
  ], MVSMAAEffect.prototype, "quality", void 0);

  var __decorate$1 = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  class MVSSAOEffect extends MVEffectBase {
      static get is() {
          return 'ssao-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$setDefaultProperties]();
          this[$updateProperties]();
      }
      update(changedProperties) {
          super.update && super.update(changedProperties);
          if (changedProperties.has('strength')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.effects[0].intensity = this.strength;
          this.effectComposer.queueRender();
      }
      [$setDefaultProperties]() {
          super[$setDefaultProperties]();
          this.effects[0].normalBuffer = this.effectComposer.normalBuffer;
      }
      get [$effectOptions]() {
          return {
              worldDistanceThreshold: 1000,
              worldDistanceFalloff: 1000,
              worldProximityThreshold: 1000,
              worldProximityFalloff: 1000,
              luminanceInfluence: 0.7,
              samples: 16,
              fade: 0.05,
              radius: 0.05,
              intensity: this.strength
          };
      }
      constructor(){
          super();
   this.strength = 2;
          this.effects = [
              new SSAOEffect(TEMP_CAMERA, undefined, this[$effectOptions])
          ];
          this.effects[0].requireNormals = true;
      }
  }
  __decorate$1([
      n$1({
          type: Number,
          attribute: 'strength',
          reflect: true
      })
  ], MVSSAOEffect.prototype, "strength", void 0);

  var __decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  class MVSelectiveBloomEffect extends SelectiveMixin(MVEffectBase) {
      static get is() {
          return 'selective-bloom-effect';
      }
      connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          this[$updateProperties]();
      }
      updated(changedProperties) {
          super.updated(changedProperties);
          if (changedProperties.has('strength') || changedProperties.has('threshold') || changedProperties.has('smoothing') || changedProperties.has('radius')) {
              this[$updateProperties]();
          }
      }
      [$updateProperties]() {
          this.effects[0].luminanceMaterial.threshold = this.threshold;
          this.effects[0].luminanceMaterial.smoothing = this.smoothing;
          this.effects[0].intensity = this.strength;
          this.effects[0].mipmapBlurPass.radius = this.radius;
          this.effectComposer.queueRender();
      }
      get [$effectOptions]() {
          return {
              blendFunction: BlendFunction.ADD,
              mipmapBlur: true,
              radius: this.radius,
              luminanceThreshold: this.threshold,
              luminanceSmoothing: this.smoothing,
              intensity: this.strength
          };
      }
      constructor(){
          super();
   this.strength = 1;
   this.threshold = 0.85;
   this.smoothing = 0.025;
   this.radius = 0.85;
          this.effects = [
              new SelectiveBloomEffect(undefined, TEMP_CAMERA, this[$effectOptions])
          ];
      }
  }
  __decorate([
      n$1({
          type: Number,
          attribute: 'strength',
          reflect: true
      })
  ], MVSelectiveBloomEffect.prototype, "strength", void 0);
  __decorate([
      n$1({
          type: Number,
          attribute: 'threshold',
          reflect: true
      })
  ], MVSelectiveBloomEffect.prototype, "threshold", void 0);
  __decorate([
      n$1({
          type: Number,
          attribute: 'smoothing',
          reflect: true
      })
  ], MVSelectiveBloomEffect.prototype, "smoothing", void 0);
  __decorate([
      n$1({
          type: Number,
          attribute: 'radius',
          reflect: true
      })
  ], MVSelectiveBloomEffect.prototype, "radius", void 0);

  customElements.define('effect-composer', MVEffectComposer);
  customElements.define('pixelate-effect', MVPixelateEffect);
  customElements.define('bloom-effect', MVBloomEffect);
  customElements.define('selective-bloom-effect', MVSelectiveBloomEffect);
  customElements.define('color-grade-effect', MVColorGradeEffect);
  customElements.define('outline-effect', MVOutlineEffect);
  customElements.define('smaa-effect', MVSMAAEffect);
  customElements.define('ssao-effect', MVSSAOEffect);
  customElements.define('glitch-effect', MVGlitchEffect);

  exports.BloomEffect = MVBloomEffect;
  exports.ColorGradeEffect = MVColorGradeEffect;
  exports.EffectBase = MVEffectBase;
  exports.EffectComposer = MVEffectComposer;
  exports.GlitchEffect = MVGlitchEffect;
  exports.OutlineEffect = MVOutlineEffect;
  exports.PixelateEffect = MVPixelateEffect;
  exports.SMAAEffect = MVSMAAEffect;
  exports.SSAOEffect = MVSSAOEffect;
  exports.SelectiveBloomEffect = MVSelectiveBloomEffect;
  exports.SelectiveMixin = SelectiveMixin;

}));
//# sourceMappingURL=model-viewer-effects-umd.js.map
